window.theme = window.theme || {};

/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on("shopify:section:load", this._onSectionLoad.bind(this))
    .on("shopify:section:unload", this._onSectionUnload.bind(this))
    .on("shopify:section:select", this._onSelect.bind(this))
    .on("shopify:section:deselect", this._onDeselect.bind(this))
    .on("shopify:block:select", this._onBlockSelect.bind(this))
    .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var $container = $(container);
    var id = $container.attr("data-section-id");
    var type = $container.attr("data-section-type");

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = $("[data-section-id]", evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    this.instances = _.filter(this.instances, function (instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    $("[data-section-type=" + type + "]").each(
      function (index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  },
});

window.slate = window.slate || {};

/**
 * Slate utilities
 * -----------------------------------------------------------------------------
 * A collection of useful utilities to help build your theme
 *
 *
 * @namespace utils
 */

slate.utils = {
  /**
   * Get the query params in a Url
   * Ex
   * https://mysite.com/search?q=noodles&b
   * getParameterByName('q') = "noodles"
   * getParameterByName('b') = "" (empty value)
   * getParameterByName('test') = null (absent)
   */
  getParameterByName: function (name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  },

  keyboardKeys: {
    TAB: 9,
    ENTER: 13,
  },
};

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function (options) {
    options.$tables.wrap(
      '<div class="' + options.tableWrapperClass + '"></div>'
    );
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function (options) {
    options.$iframes.each(function () {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + options.iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  },
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function ($element) {
    var focusClass = "js-focus-hidden";

    $element
      .first()
      .attr("tabIndex", "-1")
      .focus()
      .addClass(focusClass)
      .one("blur", callback);

    function callback() {
      $element.first().removeClass(focusClass).removeAttr("tabindex");
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function () {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function () {
    $("a[href*=#]").on(
      "click",
      function (evt) {
        console.log("dfgdfg");
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function (options) {
    var eventsName = {
      focusin: options.namespace ? "focusin." + options.namespace : "focusin",
      focusout: options.namespace
        ? "focusout." + options.namespace
        : "focusout",
      keydown: options.namespace
        ? "keydown." + options.namespace
        : "keydown.handleFocus",
    };

    /**
     * Get every possible visible focusable element
     */
    var $focusableElements = options.$container.find(
      $(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
      ).filter(":visible")
    );
    var firstFocusable = $focusableElements[0];
    var lastFocusable = $focusableElements[$focusableElements.length - 1];

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    function _manageFocus(evt) {
      if (evt.keyCode !== slate.utils.keyboardKeys.TAB) return;

      /**
       * On the last focusable element and tab forward,
       * focus the first element.
       */
      if (evt.target === lastFocusable && !evt.shiftKey) {
        evt.preventDefault();
        firstFocusable.focus();
      }
      /**
       * On the first focusable element and tab backward,
       * focus the last element.
       */
      if (evt.target === firstFocusable && evt.shiftKey) {
        evt.preventDefault();
        lastFocusable.focus();
      }
    }

    options.$container.attr("tabindex", "-1");
    options.$elementToFocus.focus();

    $(document).off("focusin");

    $(document).on(eventsName.focusout, function () {
      $(document).off(eventsName.keydown);
    });

    $(document).on(eventsName.focusin, function (evt) {
      if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;

      $(document).on(eventsName.keydown, function (evt) {
        _manageFocus(evt);
      });
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function (options) {
    var eventName = options.namespace
      ? "focusin." + options.namespace
      : "focusin";

    if (options.$container && options.$container.length) {
      options.$container.removeAttr("tabindex");
    }

    $(document).off(eventName);
  },

  /**
   * Add aria-describedby attribute to external and new window links
   *
   * @param {object} options - Options to be used
   * @param {object} options.messages - Custom messages to be used
   * @param {jQuery} options.$links - Specific links to be targeted
   */
  accessibleLinks: function (options) {
    var body = document.querySelector("body");

    var idSelectors = {
      newWindow: "a11y-new-window-message",
      external: "a11y-external-message",
      newWindowExternal: "a11y-new-window-external-message",
    };

    if (options.$links === undefined || !options.$links.jquery) {
      options.$links = $("a:not([aria-describedby])");
    }

    function generateHTML(customMessages) {
      if (typeof customMessages !== "object") {
        customMessages = {};
      }

      var messages = $.extend(
        {
          newWindow: "Opens in a new window.",
          external: "Opens external website.",
          newWindowExternal: "Opens external website in a new window.",
        },
        customMessages
      );

      var container = document.createElement("ul");
      var htmlMessages = "";

      for (var message in messages) {
        htmlMessages +=
          "<li id=" + idSelectors[message] + ">" + messages[message] + "</li>";
      }

      container.setAttribute("hidden", true);
      container.innerHTML = htmlMessages;

      body.appendChild(container);
    }

    function _externalSite($link) {
      var hostname = window.location.hostname;

      return $link[0].hostname !== hostname;
    }

    $.each(options.$links, function () {
      var $link = $(this);
      var target = $link.attr("target");
      var rel = $link.attr("rel");
      var isExternal = _externalSite($link);
      var isTargetBlank = target === "_blank";

      if (isExternal) {
        $link.attr("aria-describedby", idSelectors.external);
      }
      if (isTargetBlank) {
        if (rel === undefined || rel.indexOf("noopener") === -1) {
          $link.attr("rel", function (i, val) {
            var relValue = val === undefined ? "" : val + " ";
            return relValue + "noopener";
          });
        }
        $link.attr("aria-describedby", idSelectors.newWindow);
      }
      if (isExternal && isTargetBlank) {
        $link.attr("aria-describedby", idSelectors.newWindowExternal);
      }
    });

    generateHTML(options.messages);
  },
};

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function () {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === "string") {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
    );

    if (match !== null) {
      if (match[2] !== undefined) {
        return match[1] + match[2];
      } else {
        return match[1];
      }
    } else {
      return null;
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === "master") {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + "_" + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, "");
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol,
  };
})();

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function () {
  var moneyFormat = "${{amount}}"; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ",";
      decimal = decimal || ".";

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney,
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function () {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on(
      "change",
      this._onSelectChange.bind(this)
    );
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function () {
      var currentOptions = _.map(
        $(this.singleOptionSelector, this.$container),
        function (element) {
          var $element = $(element);
          var type = $element.attr("type");
          var currentOption = {};

          if (type === "radio" || type === "checkbox") {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data("index");

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data("index");

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function () {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = _.find(variants, function (variant) {
        return selectedValues.every(function (values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function () {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: "variantChange",
        variant: variant,
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function (variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.$container.trigger({
        type: "variantImageChange",
        variant: variant,
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function (variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: "variantPriceChange",
        variant: variant,
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function (variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: "variantSKUChange",
        variant: variant,
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function (variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?variant=" +
        variant.id;
      window.history.replaceState({ path: newurl }, "", newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function (variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    },
  });

  return Variants;
})();

/* ================ GLOBAL ================ */
/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function () {
  function Drawer(id, position, options) {
    var defaults = {
      close: ".js-drawer-close",
      open: ".js-drawer-open-" + position,
      openClass: "js-drawer-open",
      dirOpenClass: "js-drawer-open-" + position,
    };

    this.nodes = {
      $parent: $("html").add("body"),
      $page: $("#PageContainer"),
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $("#" + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function () {
    $(this.config.open).on("click", $.proxy(this.open, this));
    this.$drawer.on("click", this.config.close, $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.$page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(
      this.config.openClass + " " + this.config.dirOpenClass
    );
    this.drawerIsOpen = true;

    // Set focus on drawer
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: "drawer_focus",
    });

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === "function"
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr("aria-expanded")) {
      this.$activeSource.attr("aria-expanded", "true");
    }

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) {
      // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger("blur");

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + " " + this.config.openClass
    );

    if (this.$activeSource && this.$activeSource.attr("aria-expanded")) {
      this.$activeSource.attr("aria-expanded", "false");
    }

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: "drawer_focus",
    });

    this.unbindEvents();

    // Run function when draw closes if set
    if (
      this.config.onDrawerClose &&
      typeof this.config.onDrawerClose === "function"
    ) {
      this.config.onDrawerClose();
    }
  };

  Drawer.prototype.bindEvents = function () {
    this.nodes.$parent.on(
      "keyup.drawer",
      $.proxy(function (evt) {
        // close on 'esc' keypress
        if (evt.keyCode === 27) {
          this.close();
          return false;
        } else {
          return true;
        }
      }, this)
    );

    // Lock scrolling on mobile
    this.nodes.$page.on("touchmove.drawer", function () {
      return false;
    });

    this.nodes.$page.on(
      "click.drawer",
      $.proxy(function () {
        this.close();
        return false;
      }, this)
    );
  };

  Drawer.prototype.unbindEvents = function () {
    this.nodes.$page.off(".drawer");
    this.nodes.$parent.off(".drawer");
  };

  return Drawer;
})();

/* ================ MODULES ================ */
window.theme = window.theme || {};

theme.Header = (function () {
  var selectors = {
    body: "body",
    navigation: "#AccessibleNav",
    siteNavHasDropdown: ".site-nav--has-dropdown",
    siteNavChildLinks: ".site-nav__child-link",
    siteNavActiveDropdown: ".site-nav--active-dropdown",
    siteNavLinkMain: ".site-nav__link--main",
    siteNavChildLink: ".site-nav__link--last",
  };

  var config = {
    activeClass: "site-nav--active-dropdown",
    childLinkClass: "site-nav__child-link",
  };

  var cache = {};

  function init() {
    cacheSelectors();

    cache.$parents.on("click.siteNav", function () {
      var $el = $(this);

      $el.hasClass(config.activeClass) ? hideDropdown($el) : showDropdown($el);
    });

    // check when we're leaving a dropdown and close the active dropdown
    $(selectors.siteNavChildLink).on("focusout.siteNav", function () {
      setTimeout(function () {
        if (
          $(document.activeElement).hasClass(config.childLinkClass) ||
          !cache.$activeDropdown.length
        ) {
          return;
        }

        hideDropdown(cache.$activeDropdown);
      });
    });

    // close dropdowns when on top level nav
    cache.$topLevel.on("focus.siteNav", function () {
      if (cache.$activeDropdown.length) {
        hideDropdown(cache.$activeDropdown);
      }
    });

    cache.$subMenuLinks.on("click.siteNav", function (evt) {
      // Prevent click on body from firing instead of link
      evt.stopImmediatePropagation();
    });
  }

  function cacheSelectors() {
    cache = {
      $nav: $(selectors.navigation),
      $topLevel: $(selectors.siteNavLinkMain),
      $parents: $(selectors.navigation).find(selectors.siteNavHasDropdown),
      $subMenuLinks: $(selectors.siteNavChildLinks),
      $activeDropdown: $(selectors.siteNavActiveDropdown),
    };
  }

  function showDropdown($el) {
    $el.addClass(config.activeClass);

    // close open dropdowns
    if (cache.$activeDropdown.length) {
      hideDropdown(cache.$activeDropdown);
    }

    cache.$activeDropdown = $el;

    // set expanded on open dropdown
    $el.find(selectors.siteNavLinkMain).attr("aria-expanded", "true");

    setTimeout(function () {
      $(window).on("keyup.siteNav", function (evt) {
        if (evt.keyCode === 27) {
          hideDropdown($el);
        }
      });

      $(selectors.body).on("click.siteNav", function () {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown($el) {
    // remove aria on open dropdown
    $el.find(selectors.siteNavLinkMain).attr("aria-expanded", "false");
    $el.removeClass(config.activeClass);

    // reset active dropdown
    cache.$activeDropdown = $(selectors.siteNavActiveDropdown);

    $(selectors.body).off("click.siteNav");
    $(window).off("keyup.siteNav");
  }

  function unload() {
    $(window).off(".siteNav");
    cache.$parents.off(".siteNav");
    cache.$subMenuLinks.off(".siteNav");
    cache.$topLevel.off(".siteNav");
    $(selectors.siteNavChildLink).off(".siteNav");
    $(selectors.body).off(".siteNav");
  }

  return {
    init: init,
    unload: unload,
  };
})();

window.theme = window.theme || {};

theme.MobileNav = (function () {
  var classes = {
    mobileNavOpenIcon: "mobile-nav--open",
    mobileNavCloseIcon: "mobile-nav--close",
    navLinkWrapper: "mobile-nav__item",
    navLink: "mobile-nav__link",
    subNavLink: "mobile-nav__sublist-link",
    return: "mobile-nav__return-btn",
    subNavActive: "is-active",
    subNavClosing: "is-closing",
    navOpen: "js-menu--is-open",
    subNavShowing: "sub-nav--is-open",
    thirdNavShowing: "third-nav--is-open",
    subNavToggleBtn: "js-toggle-submenu",
  };
  var cache = {};
  var isTransitioning;
  var $activeSubNav;
  var $activeTrigger;
  var menuLevel = 1;
  // Breakpoints from src/stylesheets/global/variables.scss.liquid
  var mediaQuerySmall = "screen and (max-width: 749px)";

  function init() {
    cacheSelectors();

    cache.$mobileNavToggle.on("click", toggleMobileNav);
    cache.$subNavToggleBtn.on("click.subNav", toggleSubNav);

    // Close mobile nav when unmatching mobile breakpoint
    enquire.register(mediaQuerySmall, {
      unmatch: function () {
        if (cache.$mobileNavContainer.hasClass(classes.navOpen)) {
          closeMobileNav();
        }
      },
    });
  }

  function toggleMobileNav() {
    if (cache.$mobileNavToggle.hasClass(classes.mobileNavCloseIcon)) {
      closeMobileNav();
    } else {
      openMobileNav();
    }
  }

  function cacheSelectors() {
    cache = {
      $pageContainer: $("#PageContainer"),
      $siteHeader: $(".site-header"),
      $mobileNavToggle: $(".js-mobile-nav-toggle"),
      $mobileNavContainer: $(".mobile-nav-wrapper"),
      $mobileNav: $("#MobileNav"),
      $sectionHeader: $("#shopify-section-header"),
      $subNavToggleBtn: $("." + classes.subNavToggleBtn),
    };
  }

  function openMobileNav() {
    var translateHeaderHeight = cache.$siteHeader.outerHeight();

    cache.$mobileNavContainer.prepareTransition().addClass(classes.navOpen);

    cache.$mobileNavContainer.css({
      transform: "translateY(" + translateHeaderHeight + "px)",
    });

    cache.$pageContainer.css({
      transform:
        "translate3d(0, " +
        cache.$mobileNavContainer[0].scrollHeight +
        "px, 0)",
    });

    slate.a11y.trapFocus({
      $container: cache.$sectionHeader,
      $elementToFocus: cache.$mobileNavToggle,
      namespace: "navFocus",
    });

    cache.$mobileNavToggle
      .addClass(classes.mobileNavCloseIcon)
      .removeClass(classes.mobileNavOpenIcon)
      .attr("aria-expanded", true);

    // close on escape
    $(window).on("keyup.mobileNav", function (evt) {
      if (evt.which === 27) {
        closeMobileNav();
      }
    });
  }

  function closeMobileNav() {
    cache.$mobileNavContainer.prepareTransition().removeClass(classes.navOpen);

    cache.$mobileNavContainer.css({
      transform: "translateY(-100%)",
    });

    cache.$pageContainer.removeAttr("style");

    slate.a11y.trapFocus({
      $container: $("html"),
      $elementToFocus: $("body"),
    });

    cache.$mobileNavContainer.one(
      "TransitionEnd.navToggle webkitTransitionEnd.navToggle transitionend.navToggle oTransitionEnd.navToggle",
      function () {
        slate.a11y.removeTrapFocus({
          $container: cache.$mobileNav,
          namespace: "navFocus",
        });
      }
    );

    cache.$mobileNavToggle
      .addClass(classes.mobileNavOpenIcon)
      .removeClass(classes.mobileNavCloseIcon)
      .attr("aria-expanded", false)
      .focus();

    $(window).off("keyup.mobileNav");

    scrollTo(0, 0);
  }

  function toggleSubNav(evt) {
    if (isTransitioning) {
      return;
    }

    var $toggleBtn = $(evt.currentTarget);
    var isReturn = $toggleBtn.hasClass(classes.return);
    isTransitioning = true;

    if (isReturn) {
      // Close all subnavs by removing active class on buttons
      $(
        "." + classes.subNavToggleBtn + '[data-level="' + (menuLevel - 1) + '"]'
      ).removeClass(classes.subNavActive);

      if ($activeTrigger && $activeTrigger.length) {
        $activeTrigger.removeClass(classes.subNavActive);
      }
    } else {
      $toggleBtn.addClass(classes.subNavActive);
    }

    $activeTrigger = $toggleBtn;

    goToSubnav($toggleBtn.data("target"));
  }

  function goToSubnav(target) {
    /*eslint-disable shopify/jquery-dollar-sign-reference */

    var $targetMenu = target
      ? $('.mobile-nav__dropdown[data-parent="' + target + '"]')
      : cache.$mobileNav;

    menuLevel = $targetMenu.data("level") ? $targetMenu.data("level") : 1;

    if ($activeSubNav && $activeSubNav.length) {
      $activeSubNav.prepareTransition().addClass(classes.subNavClosing);
    }

    $activeSubNav = $targetMenu;

    /*eslint-enable shopify/jquery-dollar-sign-reference */

    var translateMenuHeight = $targetMenu.outerHeight();

    var openNavClass =
      menuLevel > 2 ? classes.thirdNavShowing : classes.subNavShowing;

    cache.$mobileNavContainer
      .css("height", translateMenuHeight)
      .removeClass(classes.thirdNavShowing)
      .addClass(openNavClass);

    if (!target) {
      // Show top level nav
      cache.$mobileNavContainer
        .removeClass(classes.thirdNavShowing)
        .removeClass(classes.subNavShowing);
    }

    /* if going back to first subnav, focus is on whole header */
    var $container = menuLevel === 1 ? cache.$sectionHeader : $targetMenu;

    var $menuTitle = $targetMenu.find("[data-menu-title=" + menuLevel + "]");
    var $elementToFocus = $menuTitle ? $menuTitle : $targetMenu;

    // Focusing an item in the subnav early forces element into view and breaks the animation.
    cache.$mobileNavContainer.one(
      "TransitionEnd.subnavToggle webkitTransitionEnd.subnavToggle transitionend.subnavToggle oTransitionEnd.subnavToggle",
      function () {
        slate.a11y.trapFocus({
          $container: $container,
          $elementToFocus: $elementToFocus,
          namespace: "subNavFocus",
        });

        cache.$mobileNavContainer.off(".subnavToggle");
        isTransitioning = false;
      }
    );

    // Match height of subnav
    cache.$pageContainer.css({
      transform: "translateY(" + translateMenuHeight + "px)",
    });

    $activeSubNav.removeClass(classes.subNavClosing);
  }

  return {
    init: init,
    closeMobileNav: closeMobileNav,
  };
})(jQuery);

window.theme = window.theme || {};

theme.Search = (function () {
  var selectors = {
    search: ".search",
    searchSubmit: ".search__submit",
    searchInput: ".search__input",

    siteHeader: ".site-header",
    siteHeaderSearchToggle: ".site-header__search-toggle",
    siteHeaderSearch: ".site-header__search",

    searchDrawer: ".search-bar",
    searchDrawerInput: ".search-bar__input",

    searchHeader: ".search-header",
    searchHeaderInput: ".search-header__input",
    searchHeaderSubmit: ".search-header__submit",

    searchResultSubmit: "#SearchResultSubmit",
    searchResultInput: "#SearchInput",
    searchResultMessage: "[data-search-error-message]",

    mobileNavWrapper: ".mobile-nav-wrapper",
  };

  var classes = {
    focus: "search--focus",
    hidden: "hide",
    mobileNavIsOpen: "js-menu--is-open",
  };

  function init() {
    if (!$(selectors.siteHeader).length) {
      return;
    }

    this.$searchResultInput = $(selectors.searchResultInput);
    this.$searchErrorMessage = $(selectors.searchResultMessage);

    initDrawer();

    var isSearchPage =
      slate.utils.getParameterByName("q") !== null &&
      window.location.pathname === "/search";

    if (isSearchPage) {
      validateSearchResultForm.call(this);
    }

    $(selectors.searchResultSubmit).on(
      "click",
      validateSearchResultForm.bind(this)
    );

    $(selectors.searchHeaderInput)
      .add(selectors.searchHeaderSubmit)
      .on("focus blur", function () {
        $(selectors.searchHeader).toggleClass(classes.focus);
      });

    $(selectors.siteHeaderSearchToggle).on("click", function () {
      var searchHeight = $(selectors.siteHeader).outerHeight();
      var searchOffset = $(selectors.siteHeader).offset().top - searchHeight;

      $(selectors.searchDrawer).css({
        height: searchHeight + "px",
        top: searchOffset + "px",
      });
    });
  }

  function initDrawer() {
    // Add required classes to HTML
    $("#PageContainer").addClass("drawer-page-content");
    $(".js-drawer-open-top")
      .attr("aria-controls", "SearchDrawer")
      .attr("aria-expanded", "false")
      .attr("aria-haspopup", "dialog");

    theme.SearchDrawer = new theme.Drawers("SearchDrawer", "top", {
      onDrawerOpen: searchDrawerFocus,
      onDrawerClose: searchDrawerFocusClose,
    });
  }

  function searchDrawerFocus() {
    searchFocus($(selectors.searchDrawerInput));

    if ($(selectors.mobileNavWrapper).hasClass(classes.mobileNavIsOpen)) {
      theme.MobileNav.closeMobileNav();
    }
  }

  function searchFocus($el) {
    $el.focus();
    // set selection range hack for iOS
    $el[0].setSelectionRange(0, $el[0].value.length);
  }

  function searchDrawerFocusClose() {
    $(selectors.siteHeaderSearchToggle).focus();
  }

  /**
   * Remove the aria-attributes and hide the error messages
   */
  function hideErrorMessage() {
    this.$searchErrorMessage.addClass(classes.hidden);
    this.$searchResultInput
      .removeAttr("aria-describedby")
      .removeAttr("aria-invalid");
  }

  /**
   * Add the aria-attributes and show the error messages
   */
  function showErrorMessage() {
    this.$searchErrorMessage.removeClass(classes.hidden);
    this.$searchResultInput
      .attr("aria-describedby", "error-search-form")
      .attr("aria-invalid", true);
  }

  function validateSearchResultForm(evt) {
    var isInputValueEmpty = this.$searchResultInput.val().trim().length === 0;

    if (!isInputValueEmpty) {
      hideErrorMessage.call(this);
      return;
    }

    if (typeof evt !== "undefined") {
      evt.preventDefault();
    }

    searchFocus(this.$searchResultInput);
    showErrorMessage.call(this);
  }

  return {
    init: init,
  };
})();

(function () {
  var selectors = {
    backButton: ".return-link",
  };

  var $backButton = $(selectors.backButton);

  if (!document.referrer || !$backButton.length || !window.history.length) {
    return;
  }

  $backButton.one("click", function (evt) {
    evt.preventDefault();

    var referrerDomain = urlDomain(document.referrer);
    var shopDomain = urlDomain(window.location.href);

    if (shopDomain === referrerDomain) {
      history.back();
    }

    return false;
  });

  function urlDomain(url) {
    var anchor = document.createElement("a");
    anchor.ref = url;

    return anchor.hostname;
  }
})();

theme.Slideshow = (function () {
  this.$slideshow = null;
  var classes = {
    wrapper: "slideshow-wrapper",
    slideshow: "slideshow",
    currentSlide: "slick-current",
    video: "slideshow__video",
    videoBackground: "slideshow__video--background",
    closeVideoBtn: "slideshow__video-control--close",
    pauseButton: "slideshow__pause",
    isPaused: "is-paused",
  };

  function slideshow(el) {
    this.$slideshow = $(el);
    this.$wrapper = this.$slideshow.closest("." + classes.wrapper);
    this.$pause = this.$wrapper.find("." + classes.pauseButton);

    this.settings = {
      accessibility: true,
      arrows: false,
      dots: true,
      fade: true,
      draggable: true,
      touchThreshold: 20,
      autoplay: this.$slideshow.data("autoplay"),
      autoplaySpeed: this.$slideshow.data("speed"),
    };

    this.$slideshow.on("beforeChange", beforeChange.bind(this));
    this.$slideshow.on("init", slideshowA11y.bind(this));
    this.$slideshow.slick(this.settings);

    this.$pause.on("click", this.togglePause.bind(this));
  }

  function slideshowA11y(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    var $wrapper = this.$wrapper;
    var autoplay = this.settings.autoplay;

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr("aria-live");

    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    $wrapper.on("focusin", function (evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.attr("aria-live", "polite");

      if (autoplay) {
        $slider.slick("slickPause");
      }
    });

    // Resume autoplay
    $wrapper.on("focusout", function (evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.removeAttr("aria-live");

      if (autoplay) {
        // Manual check if the focused element was the video close button
        // to ensure autoplay does not resume when focus goes inside YouTube iframe
        if ($(evt.target).hasClass(classes.closeVideoBtn)) {
          return;
        }

        $slider.slick("slickPlay");
      }
    });

    // Add arrow key support when focused
    if (obj.$dots) {
      obj.$dots.on("keydown", function (evt) {
        if (evt.which === 37) {
          $slider.slick("slickPrev");
        }

        if (evt.which === 39) {
          $slider.slick("slickNext");
        }

        // Update focus on newly selected tab
        if (evt.which === 37 || evt.which === 39) {
          obj.$dots.find(".slick-active button").focus();
        }
      });
    }
  }

  function beforeChange(event, slick, currentSlide, nextSlide) {
    var $slider = slick.$slider;
    var $currentSlide = $slider.find("." + classes.currentSlide);
    var $nextSlide = $slider.find(
      '.slideshow__slide[data-slick-index="' + nextSlide + '"]'
    );

    if (isVideoInSlide($currentSlide)) {
      var $currentVideo = $currentSlide.find("." + classes.video);
      var currentVideoId = $currentVideo.attr("id");
      theme.SlideshowVideo.pauseVideo(currentVideoId);
      $currentVideo.attr("tabindex", "-1");
    }

    if (isVideoInSlide($nextSlide)) {
      var $video = $nextSlide.find("." + classes.video);
      var videoId = $video.attr("id");
      var isBackground = $video.hasClass(classes.videoBackground);
      if (isBackground) {
        theme.SlideshowVideo.playVideo(videoId);
      } else {
        $video.attr("tabindex", "0");
      }
    }
  }

  function isVideoInSlide($slide) {
    return $slide.find("." + classes.video).length;
  }

  slideshow.prototype.togglePause = function () {
    var slideshowSelector = getSlideshowId(this.$pause);
    if (this.$pause.hasClass(classes.isPaused)) {
      this.$pause.removeClass(classes.isPaused);
      $(slideshowSelector).slick("slickPlay");
    } else {
      this.$pause.addClass(classes.isPaused);
      $(slideshowSelector).slick("slickPause");
    }
  };

  function getSlideshowId($el) {
    return "#Slideshow-" + $el.data("id");
  }

  return slideshow;
})();

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.SlideshowVideo.loadVideos();
}

theme.SlideshowVideo = (function () {
  var autoplayCheckComplete = false;
  var autoplayAvailable = false;
  var playOnClickChecked = false;
  var playOnClick = false;
  var youtubeLoaded = false;
  var videos = {};
  var videoPlayers = [];
  var videoOptions = {
    ratio: 16 / 9,
    playerVars: {
      // eslint-disable-next-line camelcase
      iv_load_policy: 3,
      modestbranding: 1,
      autoplay: 0,
      controls: 0,
      showinfo: 0,
      wmode: "opaque",
      branding: 0,
      autohide: 0,
      rel: 0,
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerChange,
    },
  };
  var classes = {
    playing: "video-is-playing",
    paused: "video-is-paused",
    loading: "video-is-loading",
    loaded: "video-is-loaded",
    slideshowWrapper: "slideshow-wrapper",
    slide: "slideshow__slide",
    slideBackgroundVideo: "slideshow__slide--background-video",
    slideDots: "slick-dots",
    videoChrome: "slideshow__video--chrome",
    videoBackground: "slideshow__video--background",
    playVideoBtn: "slideshow__video-control--play",
    closeVideoBtn: "slideshow__video-control--close",
    currentSlide: "slick-current",
    slickClone: "slick-cloned",
    supportsAutoplay: "autoplay",
    supportsNoAutoplay: "no-autoplay",
  };

  /**
   * Public functions
   */
  function init($video) {
    if (!$video.length) {
      return;
    }

    videos[$video.attr("id")] = {
      id: $video.attr("id"),
      videoId: $video.data("id"),
      type: $video.data("type"),
      status: $video.data("type") === "chrome" ? "closed" : "background", // closed, open, background
      videoSelector: $video.attr("id"),
      $parentSlide: $video.closest("." + classes.slide),
      $parentSlideshowWrapper: $video.closest("." + classes.slideshowWrapper),
      controls: $video.data("type") === "background" ? 0 : 1,
      slideshow: $video.data("slideshow"),
    };

    if (!youtubeLoaded) {
      // This code loads the IFrame Player API code asynchronously.
      var tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      var firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }

  function customPlayVideo(playerId) {
    // Do not autoplay just because the slideshow asked you to.
    // If the slideshow asks to play a video, make sure
    // we have done the playOnClick check first
    if (!playOnClickChecked && !playOnClick) {
      return;
    }

    if (playerId && typeof videoPlayers[playerId].playVideo === "function") {
      privatePlayVideo(playerId);
    }
  }

  function pauseVideo(playerId) {
    if (
      videoPlayers[playerId] &&
      typeof videoPlayers[playerId].pauseVideo === "function"
    ) {
      videoPlayers[playerId].pauseVideo();
    }
  }

  function loadVideos() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var args = $.extend({}, videoOptions, videos[key]);
        args.playerVars.controls = args.controls;
        videoPlayers[key] = new YT.Player(key, args);
      }
    }

    initEvents();
    youtubeLoaded = true;
  }

  function loadVideo(key) {
    if (!youtubeLoaded) {
      return;
    }
    var args = $.extend({}, videoOptions, videos[key]);
    args.playerVars.controls = args.controls;
    videoPlayers[key] = new YT.Player(key, args);

    initEvents();
  }

  /**
   * Private functions
   */

  function privatePlayVideo(id, clicked) {
    var videoData = videos[id];
    var player = videoPlayers[id];
    var $slide = videos[id].$parentSlide;

    if (playOnClick) {
      // playOnClick means we are probably on mobile (no autoplay).
      // setAsPlaying will show the iframe, requiring another click
      // to play the video.
      setAsPlaying(videoData);
    } else if (clicked || (autoplayCheckComplete && autoplayAvailable)) {
      // Play if autoplay is available or clicked to play
      $slide.removeClass(classes.loading);
      setAsPlaying(videoData);
      player.playVideo();
      return;
    }

    // Check for autoplay if not already done
    if (!autoplayCheckComplete) {
      autoplayCheckFunction(player, $slide);
    }
  }

  function setAutoplaySupport(supported) {
    var supportClass = supported
      ? classes.supportsAutoplay
      : classes.supportsNoAutoplay;
    $(document.documentElement).addClass(supportClass);

    if (!supported) {
      playOnClick = true;
    }

    autoplayCheckComplete = true;
  }

  function autoplayCheckFunction(player, $slide) {
    // attempt to play video
    player.playVideo();

    autoplayTest(player)
      .then(function () {
        setAutoplaySupport(true);
      })
      .fail(function () {
        // No autoplay available (or took too long to start playing).
        // Show fallback image. Stop video for safety.
        setAutoplaySupport(false);
        player.stopVideo();
      })
      .always(function () {
        autoplayCheckComplete = true;
        $slide.removeClass(classes.loading);
      });
  }

  function autoplayTest(player) {
    var deferred = $.Deferred();
    var wait;
    var timeout;

    wait = setInterval(function () {
      if (player.getCurrentTime() <= 0) {
        return;
      }

      autoplayAvailable = true;
      clearInterval(wait);
      clearTimeout(timeout);
      deferred.resolve();
    }, 500);

    timeout = setTimeout(function () {
      clearInterval(wait);
      deferred.reject();
    }, 4000); // subjective. test up to 8 times over 4 seconds

    return deferred;
  }

  function playOnClickCheck() {
    // Bail early for a few instances:
    // - small screen
    // - device sniff mobile browser

    if (playOnClickChecked) {
      return;
    }

    if ($(window).width() < 750) {
      playOnClick = true;
    } else if (window.mobileCheck()) {
      playOnClick = true;
    }

    if (playOnClick) {
      // No need to also do the autoplay check
      setAutoplaySupport(false);
    }

    playOnClickChecked = true;
  }

  // The API will call this function when each video player is ready
  function onPlayerReady(evt) {
    evt.target.setPlaybackQuality("hd1080");
    var videoData = getVideoOptions(evt);

    playOnClickCheck();

    // Prevent tabbing through YouTube player controls until visible
    $("#" + videoData.id).attr("tabindex", "-1");

    sizeBackgroundVideos();

    // Customize based on options from the video ID
    switch (videoData.type) {
      case "background-chrome":
      case "background":
        evt.target.mute();
        // Only play the video if it is in the active slide
        if (videoData.$parentSlide.hasClass(classes.currentSlide)) {
          privatePlayVideo(videoData.id);
        }
        break;
    }

    videoData.$parentSlide.addClass(classes.loaded);
  }

  function onPlayerChange(evt) {
    var videoData = getVideoOptions(evt);

    switch (evt.data) {
      case 0: // ended
        setAsFinished(videoData);
        break;
      case 1: // playing
        setAsPlaying(videoData);
        break;
      case 2: // paused
        setAsPaused(videoData);
        break;
    }
  }

  function setAsFinished(videoData) {
    switch (videoData.type) {
      case "background":
        videoPlayers[videoData.id].seekTo(0);
        break;
      case "background-chrome":
        videoPlayers[videoData.id].seekTo(0);
        closeVideo(videoData.id);
        break;
      case "chrome":
        closeVideo(videoData.id);
        break;
    }
  }

  function setAsPlaying(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    $slide.removeClass(classes.loading);

    // Do not change element visibility if it is a background video
    if (videoData.status === "background") {
      return;
    }

    $("#" + videoData.id).attr("tabindex", "0");

    switch (videoData.type) {
      case "chrome":
      case "background-chrome":
        $slideshow.removeClass(classes.paused).addClass(classes.playing);
        $slide.removeClass(classes.paused).addClass(classes.playing);
        break;
    }

    // Update focus to the close button so we stay within the slide
    $slide.find("." + classes.closeVideoBtn).focus();
  }

  function setAsPaused(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    if (videoData.type === "background-chrome") {
      closeVideo(videoData.id);
      return;
    }

    // YT's events fire after our click event. This status flag ensures
    // we don't interact with a closed or background video.
    if (videoData.status !== "closed" && videoData.type !== "background") {
      $slideshow.addClass(classes.paused);
      $slide.addClass(classes.paused);
    }

    if (videoData.type === "chrome" && videoData.status === "closed") {
      $slideshow.removeClass(classes.paused);
      $slide.removeClass(classes.paused);
    }

    $slideshow.removeClass(classes.playing);
    $slide.removeClass(classes.playing);
  }

  function closeVideo(playerId) {
    var videoData = videos[playerId];
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;
    var classesToRemove = [classes.pause, classes.playing].join(" ");

    $("#" + videoData.id).attr("tabindex", "-1");

    videoData.status = "closed";

    switch (videoData.type) {
      case "background-chrome":
        videoPlayers[playerId].mute();
        setBackgroundVideo(playerId);
        break;
      case "chrome":
        videoPlayers[playerId].stopVideo();
        setAsPaused(videoData); // in case the video is already paused
        break;
    }

    $slideshow.removeClass(classesToRemove);
    $slide.removeClass(classesToRemove);
  }

  function getVideoOptions(evt) {
    return videos[evt.target.h.id];
  }

  function startVideoOnClick(playerId) {
    var videoData = videos[playerId];
    // add loading class to slide
    videoData.$parentSlide.addClass(classes.loading);

    videoData.status = "open";

    switch (videoData.type) {
      case "background-chrome":
        unsetBackgroundVideo(playerId, videoData);
        videoPlayers[playerId].unMute();
        privatePlayVideo(playerId, true);
        break;
      case "chrome":
        privatePlayVideo(playerId, true);
        break;
    }

    // esc to close video player
    $(document).on("keydown.videoPlayer", function (evt) {
      if (evt.keyCode === 27) {
        closeVideo(playerId);
      }
    });
  }

  function sizeBackgroundVideos() {
    $("." + classes.videoBackground).each(function (index, el) {
      sizeBackgroundVideo($(el));
    });
  }

  function sizeBackgroundVideo($player) {
    var $slide = $player.closest("." + classes.slide);
    // Ignore cloned slides
    if ($slide.hasClass(classes.slickClone)) {
      return;
    }
    var slideWidth = $slide.width();
    var playerWidth = $player.width();
    var playerHeight = $player.height();

    // when screen aspect ratio differs from video, video must center and underlay one dimension
    if (slideWidth / videoOptions.ratio < playerHeight) {
      playerWidth = Math.ceil(playerHeight * videoOptions.ratio); // get new player width
      $player
        .width(playerWidth)
        .height(playerHeight)
        .css({
          left: (slideWidth - playerWidth) / 2,
          top: 0,
        }); // player width is greater, offset left; reset top
    } else {
      // new video width < window width (gap to right)
      playerHeight = Math.ceil(slideWidth / videoOptions.ratio); // get new player height
      $player
        .width(slideWidth)
        .height(playerHeight)
        .css({
          left: 0,
          top: (playerHeight - playerHeight) / 2,
        }); // player height is greater, offset top; reset left
    }

    $player.prepareTransition().addClass(classes.loaded);
  }

  function unsetBackgroundVideo(playerId) {
    // Switch the background-chrome to a chrome-only player once played
    $("#" + playerId)
      .removeAttr("style")
      .removeClass(classes.videoBackground)
      .addClass(classes.videoChrome);

    videos[playerId].$parentSlideshowWrapper
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].$parentSlide
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].status = "open";
  }

  function setBackgroundVideo(playerId) {
    // Switch back to background-chrome when closed
    var $player = $("#" + playerId)
      .addClass(classes.videoBackground)
      .removeClass(classes.videoChrome);

    videos[playerId].$parentSlide.addClass(classes.slideBackgroundVideo);

    videos[playerId].status = "background";
    sizeBackgroundVideo($player);
  }

  function initEvents() {
    $(document).on(
      "click.videoPlayer",
      "." + classes.playVideoBtn,
      function (evt) {
        var playerId = $(evt.currentTarget).data("controls");
        startVideoOnClick(playerId);
      }
    );

    $(document).on(
      "click.videoPlayer",
      "." + classes.closeVideoBtn,
      function (evt) {
        var playerId = $(evt.currentTarget).data("controls");
        closeVideo(playerId);
      }
    );

    // Listen to resize to keep a background-size:cover-like layout
    $(window).on(
      "resize.videoPlayer",
      $.debounce(250, function () {
        if (youtubeLoaded) {
          sizeBackgroundVideos();
        }
      })
    );
  }

  function removeEvents() {
    $(document).off(".videoPlayer");
    $(window).off(".videoPlayer");
  }

  return {
    init: init,
    loadVideos: loadVideos,
    loadVideo: loadVideo,
    playVideo: customPlayVideo,
    pauseVideo: pauseVideo,
    removeEvents: removeEvents,
  };
})();

window.theme = window.theme || {};

theme.FormStatus = (function () {
  var selectors = {
    statusMessage: "[data-form-status]",
  };

  function init() {
    this.$statusMessage = $(selectors.statusMessage);

    if (!this.$statusMessage) return;

    this.$statusMessage.focus();
  }

  return {
    init: init,
  };
})();

/* ================ TEMPLATES ================ */
(function () {
  var $filterBy = $("#BlogTagFilter");

  if (!$filterBy.length) {
    return;
  }

  $filterBy.on("change", function () {
    location.href = $(this).val();
  });
})();

window.theme = theme || {};

theme.customerTemplates = (function () {
  function initEventListeners() {
    // Show reset password form
    $("#RecoverPassword").on("click", function (evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

    // Hide reset password form
    $("#HideRecoverPasswordLink").on("click", function (evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */
  function toggleRecoverPasswordForm() {
    $("#RecoverPasswordForm").toggleClass("hide");
    $("#CustomerLoginForm").toggleClass("hide");
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    var $formState = $(".reset-password-success");

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $("#ResetSuccess").removeClass("hide");
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $("#AddressNewForm");

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        "AddressCountryNew",
        "AddressProvinceNew",
        {
          hideElement: "AddressProvinceContainerNew",
        }
      );
    }

    // Initialize each edit form's country/province selector
    $(".address-country-option").each(function () {
      var formId = $(this).data("form-id");
      var countrySelector = "AddressCountry_" + formId;
      var provinceSelector = "AddressProvince_" + formId;
      var containerSelector = "AddressProvinceContainer_" + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector,
      });
    });

    // Toggle new/edit address forms
    $(".address-new-toggle").on("click", function () {
      $newAddressForm.toggleClass("hide");
    });

    $(".address-edit-toggle").on("click", function () {
      var formId = $(this).data("form-id");
      $("#EditAddress_" + formId).toggleClass("hide");
    });

    $(".address-delete").on("click", function () {
      var $el = $(this);
      var formId = $el.data("form-id");
      var confirmMessage = $el.data("confirm-message");

      // eslint-disable-next-line no-alert
      if (
        confirm(
          confirmMessage || "Are you sure you wish to delete this address?"
        )
      ) {
        Shopify.postLink("/account/addresses/" + formId, {
          parameters: { _method: "delete" },
        });
      }
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === "#recover") {
      toggleRecoverPasswordForm();
    }
  }

  return {
    init: function () {
      checkUrlHash();
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    },
  };
})();

/*================ SECTIONS ================*/
window.theme = window.theme || {};

theme.Cart = (function () {
  var selectors = {
    edit: ".js-edit-toggle",
    inputQty: ".cart__qty-input",
    thumbnails: ".cart__image",
    item: ".cart__row",
  };

  var config = {
    showClass: "cart__update--show",
    showEditClass: "cart__edit--active",
    cartNoCookies: "cart--no-cookies",
  };

  function Cart(container) {
    this.$container = $(container);
    this.$edit = $(selectors.edit, this.$container);
    this.$inputQuantities = $(selectors.inputQty, this.$container);
    this.$thumbnails = $(selectors.thumbnails, this.$container);

    if (!this.cookiesEnabled()) {
      this.$container.addClass(config.cartNoCookies);
    }

    this.$edit.on("click", this._onEditClick);
    this.$inputQuantities.on("change", this._handleInputQty);

    this.$thumbnails.css("cursor", "pointer");
    this.$thumbnails.on("click", this._handleThumbnailClick);
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    onUnload: function () {
      this.$edit.off("click", this._onEditClick);
    },

    _onEditClick: function (evt) {
      var $evtTarget = $(evt.target);
      var $updateLine = $("." + $evtTarget.data("target"));
      var isExpanded = $evtTarget.attr("aria-expanded") === "true";

      $evtTarget
        .toggleClass(config.showEditClass)
        .attr("aria-expanded", !isExpanded);
      $updateLine.toggleClass(config.showClass);
    },

    _handleInputQty: function (evt) {
      var $input = $(evt.target);
      var value = $input.val();
      var itemKey = $input.data("quantity-item");
      var $itemQtyInputs = $("[data-quantity-item=" + itemKey + "]");
      $itemQtyInputs.val(value);
    },

    _handleThumbnailClick: function (evt) {
      var url = $(evt.target).data("item-url");

      window.location.href = url;
    },

    cookiesEnabled: function () {
      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled) {
        document.cookie = "testcookie";
        cookieEnabled = document.cookie.indexOf("testcookie") !== -1;
      }
      return cookieEnabled;
    },
  });

  return Cart;
})();

window.theme = window.theme || {};

theme.Filters = (function () {
  var settings = {
    // Breakpoints from src/stylesheets/global/variables.scss.liquid
    mediaQueryMediumUp: "screen and (min-width: 750px)",
  };

  var constants = {
    SORT_BY: "sort_by",
  };

  var selectors = {
    mainContent: "#MainContent",
    filterSelection: "#FilterTags",
    sortSelection: "#SortBy",
    defaultSort: "#DefaultSortBy",
  };

  function Filters(container) {
    var $container = (this.$container = $(container));

    this.$filterSelect = $(selectors.filterSelection, $container);
    this.$sortSelect = $(selectors.sortSelection, $container);
    this.$selects = $(selectors.filterSelection, $container).add(
      $(selectors.sortSelection, $container)
    );

    this.defaultSort = this._getDefaultSortValue();
    this.$selects.removeClass("hidden");

    this.$filterSelect.on("change", this._onFilterChange.bind(this));
    this.$sortSelect.on("change", this._onSortChange.bind(this));
    this._initBreakpoints();
  }

  Filters.prototype = _.assignIn({}, Filters.prototype, {
    _initBreakpoints: function () {
      var self = this;

      enquire.register(settings.mediaQueryMediumUp, {
        match: function () {
          self._resizeSelect(self.$selects);
        },
      });
    },

    _onSortChange: function () {
      var sort = this._sortValue();
      var url = window.location.href.replace(window.location.search, "");
      var queryStringValue = slate.utils.getParameterByName("q");
      var query = queryStringValue !== null ? queryStringValue : "";

      if (sort.length) {
        var urlStripped = url.replace(window.location.hash, "");
        query = query !== "" ? "?q=" + query + "&" : "?";

        window.location.href =
          urlStripped + query + sort + selectors.mainContent;
      } else {
        // clean up our url if the sort value is blank for default
        window.location.href = url;
      }
    },

    _onFilterChange: function () {
      var filter = this._getFilterValue();

      // remove the 'page' parameter to go to the first page of results
      var search = document.location.search.replace(/\?(page=\w+)?&?/, "");

      // only add the search parameters to the url if they exist
      search = search !== "" ? "?" + search : "";

      document.location.href = filter + search + selectors.mainContent;
    },

    _getFilterValue: function () {
      return this.$filterSelect.val();
    },

    _getSortValue: function () {
      return this.$sortSelect.val() || this.defaultSort;
    },

    _getDefaultSortValue: function () {
      return $(selectors.defaultSort, this.$container).val();
    },

    _sortValue: function () {
      var sort = this._getSortValue();
      var query = "";

      if (sort !== this.defaultSort) {
        query = constants.SORT_BY + "=" + sort;
      }

      return query;
    },

    _resizeSelect: function ($selection) {
      $selection.each(function () {
        var $this = $(this);
        var arrowWidth = 10;
        // create test element
        var text = $this.find("option:selected").text();
        var $test = $("<span>").html(text);

        // add to body, get width, and get out
        $test.appendTo("body");
        var width = $test.width();
        $test.remove();

        // set select width
        $this.width(width + arrowWidth);
      });
    },

    onUnload: function () {
      this.$filterSelect.off("change", this._onFilterChange);
      this.$sortSelect.off("change", this._onSortChange);
    },
  });

  return Filters;
})();

window.theme = window.theme || {};

theme.HeaderSection = (function () {
  function Header() {
    theme.Header.init();
    theme.MobileNav.init();
    theme.Search.init();
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    onUnload: function () {
      theme.Header.unload();
    },
  });

  return Header;
})();

theme.Maps = (function () {
  var config = {
    zoom: 14,
  };
  var apiStatus = null;
  var mapsToLoad = [];

  var errors = {
    addressNoResults: theme.strings.addressNoResults,
    addressQueryLimit: theme.strings.addressQueryLimit,
    addressError: theme.strings.addressError,
    authError: theme.strings.authError,
  };

  var selectors = {
    section: '[data-section-type="map"]',
    map: "[data-map]",
    mapOverlay: "[data-map-overlay]",
  };

  var classes = {
    mapError: "map-section--load-error",
    errorMsg: "map-section__error errors text-center",
  };

  // Global function called by Google on auth errors.
  // Show an auto error message on all map instances.
  // eslint-disable-next-line camelcase, no-unused-vars
  window.gm_authFailure = function () {
    if (!Shopify.designMode) {
      return;
    }

    $(selectors.section).addClass(classes.mapError);
    $(selectors.map).remove();
    $(selectors.mapOverlay).after(
      '<div class="' +
        classes.errorMsg +
        '">' +
        theme.strings.authError +
        "</div>"
    );
  };

  function Map(container) {
    this.$container = $(container);
    this.$map = this.$container.find(selectors.map);
    this.key = this.$map.data("api-key");

    if (typeof this.key === "undefined") {
      return;
    }

    if (apiStatus === "loaded") {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== "loading") {
        apiStatus = "loading";
        if (typeof window.google === "undefined") {
          $.getScript(
            "https://maps.googleapis.com/maps/api/js?key=" + this.key
          ).then(function () {
            apiStatus = "loaded";
            initAllMaps();
          });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function (index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data("address-setting");

    geocoder.geocode({ address: address }, function (results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function () {
      var $map = this.$map;

      return geolocate($map)
        .then(
          function (results) {
            var mapOptions = {
              zoom: config.zoom,
              center: results[0].geometry.location,
              draggable: false,
              clickableIcons: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true,
            };

            var map = (this.map = new google.maps.Map($map[0], mapOptions));
            var center = (this.center = map.getCenter());

            //eslint-disable-next-line no-unused-vars
            var marker = new google.maps.Marker({
              map: map,
              position: map.getCenter(),
            });

            google.maps.event.addDomListener(
              window,
              "resize",
              $.debounce(250, function () {
                google.maps.event.trigger(map, "resize");
                map.setCenter(center);
                $map.removeAttr("style");
              })
            );
          }.bind(this)
        )
        .fail(function () {
          var errorMessage;

          switch (status) {
            case "ZERO_RESULTS":
              errorMessage = errors.addressNoResults;
              break;
            case "OVER_QUERY_LIMIT":
              errorMessage = errors.addressQueryLimit;
              break;
            case "REQUEST_DENIED":
              errorMessage = errors.authError;
              break;
            default:
              errorMessage = errors.addressError;
              break;
          }

          // Show errors only to merchant in the editor.
          if (Shopify.designMode) {
            $map
              .parent()
              .addClass(classes.mapError)
              .html(
                '<div class="' +
                  classes.errorMsg +
                  '">' +
                  errorMessage +
                  "</div>"
              );
          }
        });
    },

    onUnload: function () {
      if (this.$map.length === 0) {
        return;
      }
      google.maps.event.clearListeners(this.map, "resize");
    },
  });

  return Map;
})();

/* eslint-disable no-new */
theme.Product = (function () {
  function Product(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr("data-section-id");

    this.settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      mediaQueryMediumUp: "screen and (min-width: 750px)",
      mediaQuerySmall: "screen and (max-width: 749px)",
      bpSmall: false,
      enableHistoryState: $container.data("enable-history-state") || false,
      namespace: ".slideshow-" + sectionId,
      sectionId: sectionId,
      sliderActive: false,
      zoomEnabled: false,
    };

    this.selectors = {
      addToCart: "#AddToCart-" + sectionId,
      addToCartText: "#AddToCartText-" + sectionId,
      errorQuantityMessage: "#error-quantity-" + sectionId,
      quantity: "#Quantity-" + sectionId,
      SKU: ".variant-sku",
      productStatus: "[data-product-status]",
      originalSelectorId: "#ProductSelect-" + sectionId,
      productImageWraps: ".product-single__photo",
      productThumbImages: ".product-single__thumbnail--" + sectionId,
      productThumbs: ".product-single__thumbnails-" + sectionId,
      productFeaturedImage: ".product-featured-img",
      productThumbsWrapper: ".thumbnails-wrapper",
      saleLabel: ".product-price__sale-label-" + sectionId,
      singleOptionSelector: ".single-option-selector-" + sectionId,
      shopifyPaymentButton: ".shopify-payment-button",
      priceContainer: "[data-price]",
      regularPrice: "[data-regular-price]",
      salePrice: "[data-sale-price]",
    };

    this.classes = {
      hidden: "hide",
      productOnSale: "price--on-sale",
      productUnavailable: "price--unavailable",
    };

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$("#ProductJson-" + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(
      document.getElementById("ProductJson-" + sectionId).innerHTML
    );

    this.settings.zoomEnabled = $(this.selectors.productImageWraps).hasClass(
      "js-zoom-enabled"
    );

    this._initBreakpoints();
    this._stringOverrides();
    this._initVariants();
    this._initImageSwitch();
    this._initAddToCart();
    this._setActiveThumbnail();
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    _stringOverrides: function () {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    _initBreakpoints: function () {
      var self = this;

      enquire.register(this.settings.mediaQuerySmall, {
        match: function () {
          // initialize thumbnail slider on mobile if more than three thumbnails
          if ($(self.selectors.productThumbImages).length > 3) {
            self._initThumbnailSlider();
          }

          // destroy image zooming if enabled
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function () {
              _destroyZoom(this);
            });
          }

          self.settings.bpSmall = true;
        },
        unmatch: function () {
          if (self.settings.sliderActive) {
            self._destroyThumbnailSlider();
          }

          self.settings.bpSmall = false;
        },
      });

      enquire.register(this.settings.mediaQueryMediumUp, {
        match: function () {
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function () {
              _enableZoom(this);
            });
          }
        },
      });
    },

    _initVariants: function () {
      var options = {
        $container: this.$container,
        enableHistoryState:
          this.$container.data("enable-history-state") || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject,
      };

      this.variants = new slate.Variants(options);

      this.$container.on(
        "variantChange" + this.settings.namespace,
        this._updateAvailability.bind(this)
      );
      this.$container.on(
        "variantImageChange" + this.settings.namespace,
        this._updateImages.bind(this)
      );
      this.$container.on(
        "variantPriceChange" + this.settings.namespace,
        this._updatePrice.bind(this)
      );
      this.$container.on(
        "variantSKUChange" + this.settings.namespace,
        this._updateSKU.bind(this)
      );
    },

    _initImageSwitch: function () {
      if (!$(this.selectors.productThumbImages).length) {
        return;
      }

      var self = this;

      $(this.selectors.productThumbImages)
        .on("click", function (evt) {
          evt.preventDefault();
          var $el = $(this);

          var imageId = $el.data("thumbnail-id");

          self._switchImage(imageId);
          self._setActiveThumbnail(imageId);
        })
        .on("keyup", self._handleImageFocus.bind(self));
    },

    _initAddToCart: function () {
      var self = this;
      var $quantityInput = $(self.selectors.quantity);

      if ($quantityInput.length === 0) return;

      $(self.selectors.addToCart).on("click", function (evt) {
        var isInvalidQuantity = $quantityInput.val() <= 0;

        $(self.selectors.errorQuantityMessage).toggleClass(
          self.classes.hidden,
          !isInvalidQuantity
        );

        if (isInvalidQuantity) {
          $quantityInput
            .attr(
              "aria-describedby",
              "error-quantity-" + self.settings.sectionId
            )
            .attr("aria-invalid", true);
          $(self.selectors.errorQuantityMessage).focus();
          evt.preventDefault();
        } else {
          $quantityInput
            .removeAttr("aria-describedby")
            .removeAttr("aria-invalid");
        }
      });
    },

    _setActiveThumbnail: function (imageId) {
      var activeClass = "active-thumb";

      // If there is no element passed, find it by the current product image
      if (typeof imageId === "undefined") {
        imageId = $(this.selectors.productImageWraps + ":not('.hide')").data(
          "image-id"
        );
      }

      var $thumbnail = $(
        this.selectors.productThumbImages +
          "[data-thumbnail-id='" +
          imageId +
          "']"
      );

      $(this.selectors.productThumbImages)
        .removeClass(activeClass)
        .removeAttr("aria-current");

      $thumbnail.addClass(activeClass);
      $thumbnail.attr("aria-current", true);
    },

    _switchImage: function (imageId) {
      var $newImage = $(
        this.selectors.productImageWraps + "[data-image-id='" + imageId + "']",
        this.$container
      );
      var $otherImages = $(
        this.selectors.productImageWraps +
          ":not([data-image-id='" +
          imageId +
          "'])",
        this.$container
      );

      $newImage.removeClass(this.classes.hidden);
      $otherImages.addClass(this.classes.hidden);
    },

    _handleImageFocus: function (evt) {
      if (evt.keyCode !== slate.utils.keyboardKeys.ENTER) return;

      $(this.selectors.productFeaturedImage + ":visible").focus();
    },

    _initThumbnailSlider: function () {
      var options = {
        slidesToShow: 4,
        slidesToScroll: 3,
        infinite: false,
        prevArrow: ".thumbnails-slider__prev--" + this.settings.sectionId,
        nextArrow: ".thumbnails-slider__next--" + this.settings.sectionId,
        responsive: [
          {
            breakpoint: 321,
            settings: {
              slidesToShow: 3,
            },
          },
        ],
      };

      $(this.selectors.productThumbs).slick(options);

      // Accessibility concerns not yet fixed in Slick Slider
      $(this.selectors.productThumbsWrapper, this.$container)
        .find(".slick-list")
        .removeAttr("aria-live");
      $(this.selectors.productThumbsWrapper, this.$container)
        .find(".slick-disabled")
        .removeAttr("aria-disabled");

      this.settings.sliderActive = true;
    },

    _destroyThumbnailSlider: function () {
      $(this.selectors.productThumbs).slick("unslick");
      this.settings.sliderActive = false;

      // Accessibility concerns not yet fixed in Slick Slider
      $(this.selectors.productThumbsWrapper, this.$container)
        .find('[tabindex="-1"]')
        .removeAttr("tabindex");
    },

    _liveRegionText: function (variant) {
      // Dummy content for live region
      var liveRegionText = "[Availability] [Regular] [$$] [Sale] [$]";

      if (!variant) {
        liveRegionText = theme.strings.unavailable;
        return liveRegionText;
      }

      // Update availability
      var availability = variant.available ? "" : theme.strings.soldOut + ",";
      liveRegionText = liveRegionText.replace("[Availability]", availability);

      // Update pricing information
      var regularLabel = "";
      var regularPrice = theme.Currency.formatMoney(
        variant.price,
        theme.moneyFormat
      );
      var saleLabel = "";
      var salePrice = "";

      if (variant.compare_at_price > variant.price) {
        regularLabel = theme.strings.regularPrice;
        regularPrice =
          theme.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          ) + ",";
        saleLabel = theme.strings.sale;
        salePrice = theme.Currency.formatMoney(
          variant.price,
          theme.moneyFormat
        );
      }

      liveRegionText = liveRegionText
        .replace("[Regular]", regularLabel)
        .replace("[$$]", regularPrice)
        .replace("[Sale]", saleLabel)
        .replace("[$]", salePrice)
        .trim();

      return liveRegionText;
    },

    _updateLiveRegion: function (evt) {
      var variant = evt.variant;
      var liveRegion = this.container.querySelector(
        this.selectors.productStatus
      );
      liveRegion.textContent = this._liveRegionText(variant);
      liveRegion.setAttribute("aria-hidden", false);

      // hide content from accessibility tree after announcement
      setTimeout(function () {
        liveRegion.setAttribute("aria-hidden", true);
      }, 1000);
    },

    _updateAddToCart: function (evt) {
      var variant = evt.variant;

      if (variant) {
        if (variant.available) {
          $(this.selectors.addToCart).prop("disabled", false);
          $(this.selectors.addToCartText).text(theme.strings.addToCart);
          $(this.selectors.shopifyPaymentButton, this.$container).show();
        } else {
          // The variant doesn't exist, disable submit button and change the text.
          // This may be an error or notice that a specific variant is not available.
          $(this.selectors.addToCart).prop("disabled", true);
          $(this.selectors.addToCartText).text(theme.strings.soldOut);
          $(this.selectors.shopifyPaymentButton, this.$container).hide();
        }
      } else {
        $(this.selectors.addToCart).prop("disabled", true);
        $(this.selectors.addToCartText).text(theme.strings.unavailable);
        $(this.selectors.shopifyPaymentButton, this.$container).hide();
      }
    },

    _updateAvailability: function (evt) {
      // update form submit
      this._updateAddToCart(evt);
      // update live region
      this._updateLiveRegion(evt);

      this._updatePrice(evt);
    },

    _updateImages: function (evt) {
      var variant = evt.variant;
      var imageId = variant.featured_image.id;

      this._switchImage(imageId);
      this._setActiveThumbnail(imageId);
    },

    _updatePrice: function (evt) {
      var variant = evt.variant;

      var $priceContainer = $(this.selectors.priceContainer, this.$container);
      var $regularPrice = $(this.selectors.regularPrice, $priceContainer);
      var $salePrice = $(this.selectors.salePrice, $priceContainer);

      // Reset product price state
      $priceContainer
        .removeClass(this.classes.productUnavailable)
        .removeClass(this.classes.productOnSale)
        .removeAttr("aria-hidden");

      // Unavailable
      if (!variant) {
        $priceContainer
          .addClass(this.classes.productUnavailable)
          .attr("aria-hidden", true);
        return;
      }

      // On sale
      if (variant.compare_at_price > variant.price) {
        $regularPrice.html(
          theme.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          )
        );
        $salePrice.html(
          theme.Currency.formatMoney(variant.price, theme.moneyFormat)
        );
        $priceContainer.addClass(this.classes.productOnSale);
      } else {
        // Regular price
        $regularPrice.html(
          theme.Currency.formatMoney(variant.price, theme.moneyFormat)
        );
      }
    },

    _updateSKU: function (evt) {
      var variant = evt.variant;

      // Update the sku
      $(this.selectors.SKU).html(variant.sku);
    },

    onUnload: function () {
      this.$container.off(this.settings.namespace);
    },
  });

  function _enableZoom(el) {
    var zoomUrl = $(el).data("zoom");
    $(el).zoom({
      url: zoomUrl,
    });
  }

  function _destroyZoom(el) {
    $(el).trigger("zoom.destroy");
  }

  return Product;
})();

theme.Quotes = (function () {
  var config = {
    mediaQuerySmall: "screen and (max-width: 749px)",
    mediaQueryMediumUp: "screen and (min-width: 750px)",
    slideCount: 0,
  };
  var defaults = {
    accessibility: true,
    arrows: false,
    dots: true,
    autoplay: false,
    touchThreshold: 20,
    slidesToShow: 3,
    slidesToScroll: 3,
  };

  function Quotes(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr("data-section-id");
    var wrapper = (this.wrapper = ".quotes-wrapper");
    var slider = (this.slider = "#Quotes-" + sectionId);
    var $slider = $(slider, wrapper);

    var sliderActive = false;
    var mobileOptions = $.extend({}, defaults, {
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
    });

    config.slideCount = $slider.data("count");

    // Override slidesToShow/Scroll if there are not enough blocks
    if (config.slideCount < defaults.slidesToShow) {
      defaults.slidesToShow = config.slideCount;
      defaults.slidesToScroll = config.slideCount;
    }

    $slider.on("init", this.a11y.bind(this));

    enquire.register(config.mediaQuerySmall, {
      match: function () {
        initSlider($slider, mobileOptions);
      },
    });

    enquire.register(config.mediaQueryMediumUp, {
      match: function () {
        initSlider($slider, defaults);
      },
    });

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick("unslick");
        sliderActive = false;
      }

      sliderObj.slick(args);
      sliderActive = true;
    }
  }

  Quotes.prototype = _.assignIn({}, Quotes.prototype, {
    onUnload: function () {
      enquire.unregister(config.mediaQuerySmall);
      enquire.unregister(config.mediaQueryMediumUp);

      $(this.slider, this.wrapper).slick("unslick");
    },

    onBlockSelect: function (evt) {
      // Ignore the cloned version
      var $slide = $(
        ".quotes-slide--" + evt.detail.blockId + ":not(.slick-cloned)"
      );
      var slideIndex = $slide.data("slick-index");

      // Go to selected slide, pause autoplay
      $(this.slider, this.wrapper).slick("slickGoTo", slideIndex);
    },

    a11y: function (event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr("aria-live");

      // When an element in the slider is focused set aria-live
      $wrapper.on("focusin", function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr("aria-live", "polite");
        }
      });

      // Remove aria-live
      $wrapper.on("focusout", function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr("aria-live");
        }
      });
    },
  });

  return Quotes;
})();

theme.slideshows = {};

theme.SlideshowSection = (function () {
  function SlideshowSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr("data-section-id");
    var slideshow = (this.slideshow = "#Slideshow-" + sectionId);

    $(".slideshow__video", slideshow).each(function () {
      var $el = $(this);
      theme.SlideshowVideo.init($el);
      theme.SlideshowVideo.loadVideo($el.attr("id"));
    });

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn(
  {},
  theme.SlideshowSection.prototype,
  {
    onUnload: function () {
      delete theme.slideshows[this.slideshow];
    },

    onBlockSelect: function (evt) {
      var $slideshow = $(this.slideshow);

      // Ignore the cloned version
      var $slide = $(
        ".slideshow__slide--" + evt.detail.blockId + ":not(.slick-cloned)"
      );
      var slideIndex = $slide.data("slick-index");

      // Go to selected slide, pause autoplay
      $slideshow.slick("slickGoTo", slideIndex).slick("slickPause");
    },

    onBlockDeselect: function () {
      // Resume autoplay
      $(this.slideshow).slick("slickPlay");
    },
  }
);

$(document).ready(function () {
  var sections = new theme.Sections();

  sections.register("cart-template", theme.Cart);
  sections.register("product", theme.Product);
  sections.register("collection-template", theme.Filters);
  sections.register("product-template", theme.Product);
  sections.register("header-section", theme.HeaderSection);
  sections.register("map", theme.Maps);
  sections.register("slideshow-section", theme.SlideshowSection);
  sections.register("quotes", theme.Quotes);
});

theme.init = function () {
  theme.customerTemplates.init();

  // Theme-specific selectors to make tables scrollable
  var tableSelectors = ".rte table," + ".custom__item-inner--html table";

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: "scrollable-wrapper",
  });

  // Theme-specific selectors to make iframes responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"],' +
    '.custom__item-inner--html iframe[src*="youtube.com/embed"],' +
    '.custom__item-inner--html iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: "video-wrapper",
  });

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $(".in-page-link").on("click", function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on("click", function (evt) {
    evt.preventDefault();
  });

  slate.a11y.accessibleLinks({
    messages: {
      newWindow: theme.strings.newWindow,
      external: theme.strings.external,
      newWindowExternal: theme.strings.newWindowExternal,
    },
    $links: $("a:not([aria-describedby], .product-single__thumbnail)"),
  });

  theme.FormStatus.init();
};

$(theme.init);

/**********Custom js home page header.js**********/

$(document).ready(function () {
  $(".link-shop").mouseover(function () {
    $(".link-about").removeClass("active");
    $(".link-about .header-link--subitems").slideUp(500);

    $(this).addClass("active");
    $(".header-link--tabs").slideDown(500);
  });

  $(".header-link--tabs").mouseleave(function () {
    $(".link-shop").removeClass("active");
    $(this).slideUp(500);
  });

  $(".link-shop").click(function () {
    $(".link-about").removeClass("active");
    $(".link-about .header-link--subitems").slideUp(500);
  });

  $(".link-about").click(function () {
    $(".link-shop").removeClass("active");
    $(".header-link--tabs").slideUp(500);
    $(this).toggleClass("active");
    $(".header-link--subitems").slideToggle(500);
  });

  $("ul.tabs li").click(function () {
    var tab_id = $(this).attr("data-tab");

    $("ul.tabs li").removeClass("current");
    $(".tab-content").removeClass("current");

    $(this).addClass("current");
    $("#" + tab_id).addClass("current");
  });

  // hoem video
  function video() {
    var winHeight = $(window).outerHeight();
    var header = $("header").outerHeight();
    var homeVideo = $(".home-video");

    $(".scroll").css({
      bottom: header,
    });
  }

  video();

  // product
  function productCheckout() {
    var h = $("header").outerHeight();
    var winH = $(window).outerHeight();
    var modcart = $(".mod-cart, .mod-cart-main");

    modcart.css({
      top: h,
    });

    $(".cart").click(function () {
      setTimeout(function () {
        $("html, body").toggleClass("toggle-overflow");
      }, 200);

      $(".mod-cart-main").toggleClass("active");
    });

    // for home page
    // $('.cart').click(function() {
    //     $(".pg").bind("mousewheel", function() {
    //         return false;
    //     });
    // });
  }

  productCheckout();

  // menu open
  $(".bars, .menu-bar").click(function () {
    $(".menu-side").addClass("active");
    $(".menu-overlay").addClass("active");
  });

  $(".close").click(function () {
    $(".menu-side").removeClass("active");
    $(".menu-overlay").removeClass("active");
  });

  // checkout open
  $(".cart").click(function () {
    $(".mod-cart").toggleClass("mod-cart-slide");
  });
var showmenunew=1;
  $(".menu").click(function () {
    $(".menu-side").addClass("active");
    $(".menu-overlay").addClass("active");
    $(".menu").removeClass("on");

  });

  $(".close").click(function () {
    $(".menu-side").removeClass("active");
    $(".menu-overlay").removeClass("active");
   // $(".menu").addClass("on");
  });

  $(window).resize(function () {
    video();
    productCheckout();
  });

  /************Page slide home page**************/
  // $('#pageSlide').pageSlide();
  //$('#pageSlide').pageSlide();
  // if ($(window).outerWidth() >= 768) {
  //$('#pageSlide').pageSlide();
  //}
  /*************ENDS HOME PAGE*****************/

  /**********************ONE PAGE JS ENDS************************/

  /******************about js**************/
  $(".lazy").slick({
    dots: false,
    infinite: true,
    speed: 500,
    fade: false,
    cssEase: "linear",
    arrows: true,
    slidesToShow: 1,
  });
  $(window).load(function () {
    $(".collection-right-filter .collection-header").slick({
      dots: false,
      infinite: true,
      speed: 500,
      fade: false,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      autoplay: true,
      autoplaySpeed: 3500,
    });
  });

  // accodion
  $(".kona--beans").click(function () {
    $(".kona--beans-pragrap").slideToggle();
  });

  $(".best-people").click(function () {
    $(".people-pragrap").slideToggle();
  });

  $(".tastings").click(function () {
    $(".tastings-pragrap").slideToggle();
  });

  $(".process").click(function () {
    $(".process-pragrap").slideToggle();
  });

  // menu
  function menuScroll() {
    var subH = $(".header-link--subitems").outerHeight();
    var sth = $(".sticky-header").outerHeight();
    var sum = subH + sth;

    $(".header-link--subitems a").click(function () {
      $(".header-link--subitems a").removeClass("active");
      $(this).addClass("active");
    });

    $(".about-middle-page").css({
      "margin-top": sum,
    });

    $('a[href^="#"]').click(function (e) {
      $("html,body").animate(
        {
          scrollTop: $(this.hash).offset().top - (sum - 1),
        },
        1000
      );
      return false;
      e.preventDefault();
    });
  }

  //menuScroll();

  // video
  $(".popup-vimeo").click(function () {
    $(".about-video").css("display", "block");
    $(".overlay").css("display", "none");
    $(".play").hide();
  });

  $(".popup-vimeo").click(function () {
    if ($("video").get(0).paused) {
      $("video").get(0).play();
    } else {
      $("video").get(0).pause();
    }
  });

  $(window).resize(function () {
    menuScroll();
  });

  /*******************About JS ands***************/

  /******************CLUB HEADER******************/
  // club header
  function clubHeader() {
    var winH = $(window).outerHeight();
    var h = $("header").outerHeight();
    var clBan = $(".club-banner");

    clBan.css({
      height: winH - h,
    });
  }

  clubHeader();

  // accordion
  function accordion() {
    $("#one .faq-panel--heading").click(function () {
      $(this).toggleClass("active");
      $("#one .faq-panel--body").toggleClass("active");
      $("#one .faq-panel--body").slideToggle("active");
    });

    $("#two .faq-panel--heading").click(function () {
      $(this).toggleClass("active");
      $("#two .faq-panel--body").toggleClass("active");
      $("#two .faq-panel--body").slideToggle("active");
    });

    $("#three .faq-panel--heading").click(function () {
      $(this).toggleClass("active");
      $("#three .faq-panel--body").toggleClass("active");
      $("#three .faq-panel--body").slideToggle("active");
    });
  }

  accordion();

  $(window).resize(function () {
    clubHeader();
    accordion();
  });
});

/*************************MEET US***************************************/
equalheight = function (container) {
  var currentTallest = 0,
    currentRowStart = 0,
    rowDivs = new Array(),
    $el,
    topPosition = 0;
  $(container).each(function () {
    $el = $(this);
    $($el).height("auto");
    topPostion = $el.position().top;

    if (currentRowStart != topPostion) {
      for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
        rowDivs[currentDiv].height(currentTallest);
      }
      rowDivs.length = 0; // empty the array
      currentRowStart = topPostion;
      currentTallest = $el.height();
      rowDivs.push($el);
    } else {
      rowDivs.push($el);
      currentTallest =
        currentTallest < $el.height() ? $el.height() : currentTallest;
    }
    for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
      rowDivs[currentDiv].height(currentTallest);
    }
  });
};

$(window).load(function () {
  equalheight(".col-detail--info .col-detail--info-title");
  equalheight(".col-detail--info .col-detail--info-address");
  equalheight(".col-detail--info .col-detail--info-number");
  equalheight(".col-detail--info .col-detail--info-link");
});

$(window).resize(function () {
  equalheight(".col-detail--info .col-detail--info-title");
  equalheight(".col-detail--info .col-detail--info-address");
  equalheight(".col-detail--info .col-detail--info-number");
  equalheight(".col-detail--info .col-detail--info-link");
});
function equal_height() {
  // Equal Card Height and Text Height
  $(".equal-height").jQueryEqualHeight(
    ".main-shop-product-main .product-details .main-shop-product--specification"
  );
  $(".equal-height").jQueryEqualHeight(
    ".main-shop-product-main .main-shop-product--name"
  );
}
$(window).on("load", function (event) {
  equal_height();
});
$(window).resize(function (event) {
  equal_height();
});

/***************loadmore****************/
$(document).ready(function () {
  $(".cwptwModal-close").click(function () {
    console.log("cwptwModal-close");
    $(".cwptwModal-close").first().trigger("click");
    //window.location.href = "https://buddhascup.com/collections/shop";
  });
  console.log("ready!");

  var vid = document.getElementById("abouslidevdo");

  if (vid) {
    vid.play();
  }

  var cookieValue = Cookies.get("test202012_p");
  //console.log(cookieValue);
  if (cookieValue == "1") {
    $(".promo-popup").hide();
  } else {
    setTimeout(function () {
      $(".promo-popup").show();
    }, 0);
  }
  $(".close-btn").click(function () {
    $(".promo-popup").hide();
    Cookies.set("test202012_p", "1", { expires: 1 });
  });
  $(".cwptwModal-close").click(function () {
    $(".promo-popup").hide();
    Cookies.set("test202012_p", "1", { expires: 1 });
    //window.location.href = "https://buddhascup.com/collections/shop";
  });

  /**********Menu**************
  $(".menu").click(function () {
    $(".menu-side").addClass("active");
    $(".menu-overlay").addClass("active");
    $(".menu").removeClass("on");
  });

  $(".close").click(function () {
    $(".menu-side").removeClass("active");
    $(".menu-overlay").removeClass("active");
    $(".menu").addClass("on");
  });
*/
  /*************************/

  $(".viewmore1").click(function () {
    var txt = $(".showmore1").is(":visible") ? "view more" : "view less";
    $(".viewmore1").text(txt);
    $(".showmore1").slideToggle();
    $(".main-shop-product--name").css("height", "inherit");
    $(".main-shop-product--specification").css("height", "inherit");
  });

  $(".viewmore2").click(function () {
    var txt = $(".showmore2").is(":visible") ? "view more" : "view less";
    $(".viewmore2").text(txt);
    $(".showmore2").slideToggle();
    $(".main-shop-product--name").css("height", "inherit");
    $(".main-shop-product--specification").css("height", "inherit");
  });
  $(".viewmore3").click(function () {
    var txt = $(".showmore3").is(":visible") ? "view more" : "view less";
    $(".viewmore3").text(txt);
    $(".showmore3").slideToggle();
    $(".main-shop-product--name").css("height", "inherit");
    $(".main-shop-product--specification").css("height", "inherit");
  });

  $(".rem").click(function () {
    var proid = $(this).attr("lang");

    window.location.href = "/cart/change?line=" + proid + "&quantity=0";
  });
  /*
  $("#brandname").change(function(){

    var pro = $(this).val();
    var htmltoload 	=	'';
    console.log('aaa');
    if(pro=='1517882245187')
    {
    	htmltoload=' <option value="">size</option><option value="13595230732355">8 oz Buttered Rum Roast Ground</option><option value="13595230699587">16 oz Buttered Rum Roast Whole Bean</option>';
    }
  	else if(pro=='1517882474563')
    {
    	htmltoload=' <option value="">size</option><option value="13595234140227">16 oz Dark Roast Whole Bean</option>';
    }
    else if(pro=='1517883490371')
    {
    	htmltoload=' <option value="">size</option><option value="13595241644099">16 oz Medium/Dark Roast Whole Bean</option>';
    }
    else if(pro=='1517883064387')
    {
    	htmltoload=' <option value="">size</option><option value="13595236139075">8 oz Whole Bean</option>';
    }
    else if(pro=='1517883424835')
    {
    	htmltoload=' <option value="">size</option><option value="13595239809091">8 oz Medium Roast Ground</option><option value="13595239743555">16 oz Medium Roast Whole Bean</option>';
    }
    else if(pro=='1517881753667')
    {
    	htmltoload=' <option value="">size</option><option value="13595229159491">8 oz Ground Roast</option><option value="13595229126723">16 oz Whole Bean</option>';
    }
    else if(pro=='1517882441795')
    {
    	htmltoload=' <option value="">size</option><option value="13595234107459">16 oz Medium Roast Whole Bean</option>';
    }
    else if(pro=='1517883293763')
    {
    	htmltoload=' <option value="">size</option><option value="13595236696131">8 oz Medium Roast Ground</option><option value="13595236663363">16 oz Medium Roast Whole Bean</option>';
    }
    else if(pro=='1517882638403')
    {
    	htmltoload=' <option value="">size</option><option value="13595234598979">8 oz Whole Bean</option><option value="13595234631747">8 oz Ground Roast</option><option value="13595234566211">16 oz Whole Bean</option>';
    }
    else if(pro=='1517882277955')
    {
    	htmltoload=' <option value="">size</option><option value="13595230896195">8 oz Medium/Dark Ground</option><option value="13595230830659">16 oz Medium/Dark Whole Bean</option>';
    }
    else if(pro=='1517883195459')
    {
    	htmltoload=' <option value="">size</option><option value="13595236532291">8 oz Medium/Dark Whole Bean</option>';
    }
    else if(pro=='1517883359299')
    {
    	htmltoload=' <option value="">size</option><option value="13595238924355">2 oz Med/Dark Ground</option><option value="13595238989891">8 oz Med/Dark Ground</option><option value="13595239022659">8 oz Med/Dark Whole Bean DECAF</option><option value="13595238957123">16 oz Med/Dark Whole Bean</option><option value="13595239055427">2 lb Med/Dark Whole Bean</option><option value="13595239088195">5 lb Med/Dark Whole Bean</option>';
    }
    	$("#size").html(htmltoload);
  });

  $('#add-to-cart-button-subscrption').click(function(){

  var variant_id	=	$("#size").val();
  var quantity		=	$("#qty").val();
  var shipping_interval_frequency	=	$("#qty").val();
  var shipping_interval_unit_type	=	'Months';
  var subscription_id	=	"151503";


   addItemToCart (variant_id, quantity, shipping_interval_frequency, shipping_interval_unit_type, subscription_id);
})

function addItemToCart (variant_id, quantity, shipping_interval_frequency, shipping_interval_unit_type, subscription_id) {
  data = {
      "quantity": quantity,
      "id": variant_id,
      "properties[shipping_interval_frequency]": shipping_interval_frequency,
	"properties[shipping_interval_unit_type]": shipping_interval_unit_type,
	"properties[subscription_id]": subscription_id
    }
  $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() {
          window.location.href = '/cart';
      }
  });
}*/
});

$(document).ready(function () {
  $(".menu-bar a").on("click", function () {
    $("body").toggleClass("open-menu");
  });

  //     if( $(window).width() <= 767 ) {

  //       $('.header-logos-inner').slick({
  //         infinite: false,
  //         slidesToShow: 2,
  //         slidesToScroll: 1,
  //         autoplay:true,
  //         infinite:true,
  //         arrows: false
  //       });
  //     }

  $(document).ready(function () {
    if (navigator.userAgent.indexOf("Mac OS X") != -1) {
      $("body").addClass("mac");
    } else {
      $("body").addClass("pc");
    }
  });
});
$(window).scroll(function () {
  var scroll = $(window).scrollTop();
  if (scroll >= 500) {
    $("body").removeClass("open-menu");
  } else {
    $("body").removeClass("open-menu");
  }
});

$(document).ready(function () {
    // $(".accordion a").click(function () {
    //     $(".accordion a").removeClass("active"); // Remove "active" class from all elements
    //     $(".content").removeClass("active"); // Slide up all content elements
    //     $(this).toggleClass("active"); // Add "active" class to the clicked element
    //     $(this).next(".content").toggleClass("active"); // Slide down the content of the clicked element
    // });


    $(".accordion a").click(function () {
        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(this).next(".content").slideUp(400);
        } else {
            $(".accordion a").removeClass("active"); // Remove "active" class from all elements
            $(".content").slideUp(400); // Slide up all content elements
            $(this).addClass("active"); // Add "active" class to the clicked element
            $(this).next(".content").slideDown(400); // Slide down the content of the clicked element
        }
    });


});
$(document).ready(function () {
  $(".header-link--items.link-brands").click(function () {
    $(".header-link--items.link-brands").toggleClass("active");
  });
});

// Tours page review slider
$(".tours-our-guests-slider").slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  adaptiveHeight: true,
  arrows: true,
  responsive: [
    {
      breakpoint: 1023,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});
$(document).ready(function () {
  if ($(window).width() <= 767) {
    $(".mob-filter-btn a").click(function () {
      $("body").toggleClass("open-left-filter");
    });
    $(".collection-pfs-filter-show-result button").click(function () {
      $("body").removeClass("open-left-filter");
    });
    $(".menu-overlay").click(function () {
      $("body").removeClass("open-left-filter");
    });
  }
});

$(document).ready(function () {
  var hash = window.location.hash.substr(1);

  if (hash == "rum-cakes-gift-sets") {
    console.log(hash);
    $(".products-box1 ul li").removeClass("active");
    $(".rum-cakes-gift-sets").parent().parent().addClass("active");
    //$( ".holiday-gift-packs" ).trigger( "click" );

    var filterList = {
      init: function () {
        $("#portfoliolist").mixItUp({
          selectors: {
            target: ".portfolio",
            filter: ".filter",
          },
          load: {
            filter: ".rum-cakes-gift-sets",
          },
        });
      },
    };
    filterList.init();
  }
  /**********************************************************/
  if (hash == "the-coffee") {
    $(".products-box1 ul li").removeClass("active");
    $(".the-coffee").parent().parent().addClass("active");
    var filterList = {
      init: function () {
        $("#portfoliolist").mixItUp({
          selectors: {
            target: ".portfolio",
            filter: ".filter",
          },
          load: {
            filter: ".the-coffee",
          },
        });
      },
    };
    if($(".portfoliolist").lenth>0){
    filterList.init();
    }
  }

  /**************************.holiday-gift-packs********************************/
  if (hash == "holiday-gift-packs") {
    $(".products-box1 ul li").removeClass("active");
    $(".holiday-gift-packs").parent().parent().addClass("active");
    var filterList = {
      init: function () {
        $("#portfoliolist").mixItUp({
          selectors: {
            target: ".portfolio",
            filter: ".filter",
          },
          load: {
            filter: ".holiday-gift-packs",
          },
        });
      },
    };
    filterList.init();
  }

  /************************the-tea**********************************/
  if (hash == "the-tea") {
    $(".products-box1 ul li").removeClass("active");
    $(".the-tea").parent().parent().addClass("active");
    var filterList = {
      init: function () {
        $("#portfoliolist").mixItUp({
          selectors: {
            target: ".portfolio",
            filter: ".filter",
          },
          load: {
            filter: ".the-tea",
          },
        });
      },
    };
    filterList.init();
  }

  /**************************gift-sets********************************/
  if (hash == "gift-sets") {
    $(".products-box1 ul li").removeClass("active");
    $(".gift-sets").parent().parent().addClass("active");
    var filterList = {
      init: function () {
        $("#portfoliolist").mixItUp({
          selectors: {
            target: ".portfolio",
            filter: ".filter",
          },
          load: {
            filter: ".gift-sets",
          },
        });
      },
    };
    filterList.init();
  }
  /**************************macadamia-nuts********************************/
  if (hash == "macadamia-nuts") {
    $(".products-box1 ul li").removeClass("active");
    $(".macadamia-nuts").parent().parent().addClass("active");
    var filterList = {
      init: function () {
        $("#portfoliolist").mixItUp({
          selectors: {
            target: ".portfolio",
            filter: ".filter",
          },
          load: {
            filter: ".macadamia-nuts",
          },
        });
      },
    };
    filterList.init();
  }
  /***********************chocolate-coffee-beans***********************************/
  if (hash == "chocolate-coffee-beans") {
    $(".products-box1 ul li").removeClass("active");
    $(".chocolate-coffee-beans").parent().parent().addClass("active");
    var filterList = {
      init: function () {
        $("#portfoliolist").mixItUp({
          selectors: {
            target: ".portfolio",
            filter: ".filter",
          },
          load: {
            filter: ".chocolate-coffee-beans",
          },
        });
      },
    };
    filterList.init();
  }
  /***************************.t-shirts*******************************/
  if (hash == "t-shirts") {
    $(".products-box1 ul li").removeClass("active");
    $(".t-shirts").parent().parent().addClass("active");
    var filterList = {
      init: function () {
        $("#portfoliolist").mixItUp({
          selectors: {
            target: ".portfolio",
            filter: ".filter",
          },
          load: {
            filter: ".t-shirts",
          },
        });
      },
    };
    filterList.init();
  }
  /******************************totes-and-sacks****************************/
  if (hash == "totes-and-sacks") {
    $(".products-box1 ul li").removeClass("active");
    $(".totes-and-sacks").parent().parent().addClass("active");
    var filterList = {
      init: function () {
        $("#portfoliolist").mixItUp({
          selectors: {
            target: ".portfolio",
            filter: ".filter",
          },
          load: {
            filter: ".totes-and-sacks",
          },
        });
      },
    };
    filterList.init();
  }
  /**************************hawaiian-turmeric********************************/
  if (hash == "hawaiian-turmeric") {
    $(".products-box1 ul li").removeClass("active");
    $(".hawaiian-turmeric").parent().parent().addClass("active");
    var filterList = {
      init: function () {
        $("#portfoliolist").mixItUp({
          selectors: {
            target: ".portfolio",
            filter: ".filter",
          },
          load: {
            filter: ".hawaiian-turmeric",
          },
        });
      },
    };
    filterList.init();
  }
  /************************mugs**********************************/
  if (hash == "mugs") {
    $(".products-box1 ul li").removeClass("active");
    $(".mugs").parent().parent().addClass("active");
    var filterList = {
      init: function () {
        $("#portfoliolist").mixItUp({
          selectors: {
            target: ".portfolio",
            filter: ".filter",
          },
          load: {
            filter: ".mugs",
          },
        });
      },
    };
    filterList.init();
  }
  /**************************soap********************************/
  if (hash == "soap") {
    $(".products-box1 ul li").removeClass("active");
    $(".soap").parent().parent().addClass("active");
    var filterList = {
      init: function () {
        $("#portfoliolist").mixItUp({
          selectors: {
            target: ".portfolio",
            filter: ".filter",
          },
          load: {
            filter: ".soap",
          },
        });
      },
    };
    filterList.init();
  }

  /*************************gift-cards*********************************/
  if (hash == "gift-cards") {
    $(".products-box1 ul li").removeClass("active");
    $(".gift-cards").parent().parent().addClass("active");

    var filterList = {
      init: function () {
        $("#portfoliolist").mixItUp({
          selectors: {
            target: ".portfolio",
            filter: ".filter",
          },
          load: {
            filter: ".gift-cards",
          },
        });
      },
    };
    filterList.init();
  }

  if (hash == "medium-roast-coffees") {
    $(".products-box1 ul li").removeClass("active");
    $(".medium-roast-coffees").parent().parent().addClass("active");

    var filterList = {
      init: function () {
        $("#portfoliolist").mixItUp({
          selectors: {
            target: ".portfolio",
            filter: ".filter",
          },
          load: {
            filter: ".medium-roast-coffees",
          },
        });
      },
    };
    filterList.init();
  }

  $(".filter").click(function () {
    var showresultcount = $(".all").length;
    if (showresultcount > 0) {
      $(".collection-filter-error-msg").hide().html("");
      $("#showresultcount")
        .show()
        .html("SHOW " + showresultcount + " RESULTS");
    }
    // $(this).parent().parent().toggleClass('active');
    console.log($(this).parent().parent().parent().parent());
    if ($(this).parent().parent().parent().parent().hasClass("products-box1")) {
      $(".products-box1 ul li").removeClass("active");
      console.log($(this).parent().parent());
      $(this).parent().parent().addClass("active");
    }
    if ($(this).parent().parent().parent().parent().hasClass("products-box2")) {
      $(".products-box2 ul li").removeClass("active");
      $(this).parent().parent().addClass("active");
    }
    if ($(this).parent().parent().parent().parent().hasClass("products-box3")) {
      $(".products-box3 ul li").removeClass("active");
      $(this).parent().parent().addClass("active");
    }
    /**********************************************************/

    var slectedfilter = $(this).data("filter");
    //  var slectedfilter = slectedfilter.replace(".");
    var showresultcount = $(slectedfilter).length;
    if (showresultcount > 0) {
      $(".collection-filter-error-msg").hide().html("");
      $("#showresultcount")
        .show()
        .html("SHOW " + showresultcount + " RESULTS");
    } else {
      $(".collection-filter-error-msg").show().html("NO RESULTS MATCH FILTERS");
      $("#showresultcount").hide().html("");
    }
  });
});

// class detect
$(document).ready(function () {
  if (navigator.userAgent.indexOf("Mac OS X") != -1) {
    $("body").addClass("mac");
  } else {
    $("body").addClass("pc");
  }
});

// LEFT STICKY
/*
 * HC-Sticky
 */
("use strict");
!(function (t, e) {
  if ("object" == typeof module && "object" == typeof module.exports) {
    if (!t.document) throw new Error("HC-Sticky requires a browser to run.");
    module.exports = e(t);
  } else
    "function" == typeof define && define.amd
      ? define("hcSticky", [], e(t))
      : e(t);
})("undefined" != typeof window ? window : this, function (V) {
  var i,
    n,
    Q = V.document,
    U = {
      top: 0,
      bottom: 0,
      bottomEnd: 0,
      innerTop: 0,
      innerSticker: null,
      stickyClass: "sticky",
      stickTo: null,
      followScroll: !0,
      responsive: null,
      mobileFirst: !1,
      onStart: null,
      onStop: null,
      onBeforeResize: null,
      onResize: null,
      resizeDebounce: 100,
      disable: !1,
    },
    Y = function (t, e, o) {
      console.warn(
        "%cHC Sticky:%c " +
          o +
          "%c '" +
          t +
          "'%c is now deprecated and will be removed. Use%c '" +
          e +
          "'%c instead.",
        "color: #fa253b",
        "color: default",
        "color: #5595c6",
        "color: default",
        "color: #5595c6",
        "color: default"
      );
    },
    $ = function (n, f) {
      var o = this;
      if (((f = f || {}), !(n = "string" == typeof n ? Q.querySelector(n) : n)))
        return !1;
      f.queries && Y("queries", "responsive", "option"),
        f.queryFlow && Y("queryFlow", "mobileFirst", "option");
      var p = {},
        u = $.Helpers,
        s = n.parentNode;
      "static" === u.getStyle(s, "position") && (s.style.position = "relative");
      function d(t) {
        (u.isEmptyObject((t = t || {})) && !u.isEmptyObject(p)) ||
          (p = Object.assign({}, U, p, t));
      }
      function t() {
        return p.disable;
      }
      function e() {
        var t,
          e = p.responsive || p.queries;
        if (e) {
          var o = V.innerWidth;
          if (((t = f), (p = Object.assign({}, U, t || {})).mobileFirst))
            for (var i in e) i <= o && !u.isEmptyObject(e[i]) && d(e[i]);
          else {
            var n,
              s = [];
            for (n in e) {
              var r = {};
              (r[n] = e[n]), s.push(r);
            }
            for (var l = s.length - 1; 0 <= l; l--) {
              var a = s[l],
                c = Object.keys(a)[0];
              o <= c && !u.isEmptyObject(a[c]) && d(a[c]);
            }
          }
        }
      }
      function i() {
        var t, e, o, i;
        (I.css =
          ((t = n),
          (e = u.getCascadedStyle(t)),
          (o = u.getStyle(t)),
          (i = {
            height: t.offsetHeight + "px",
            left: e.left,
            right: e.right,
            top: e.top,
            bottom: e.bottom,
            position: o.position,
            display: o.display,
            verticalAlign: o.verticalAlign,
            boxSizing: o.boxSizing,
            marginLeft: e.marginLeft,
            marginRight: e.marginRight,
            marginTop: e.marginTop,
            marginBottom: e.marginBottom,
            paddingLeft: e.paddingLeft,
            paddingRight: e.paddingRight,
          }),
          e.float && (i.float = e.float || "none"),
          e.cssFloat && (i.cssFloat = e.cssFloat || "none"),
          o.MozBoxSizing && (i.MozBoxSizing = o.MozBoxSizing),
          (i.width =
            "auto" !== e.width
              ? e.width
              : "border-box" === i.boxSizing || "border-box" === i.MozBoxSizing
              ? t.offsetWidth + "px"
              : o.width),
          i)),
          P.init(),
          (y = !(
            !p.stickTo ||
            !(
              "document" === p.stickTo ||
              (p.stickTo.nodeType && 9 === p.stickTo.nodeType) ||
              ("object" == typeof p.stickTo &&
                p.stickTo instanceof
                  ("undefined" != typeof HTMLDocument
                    ? HTMLDocument
                    : Document))
            )
          )),
          (h = p.stickTo ? (y ? Q : u.getElement(p.stickTo)) : s),
          (z = (R = function () {
            var t =
                n.offsetHeight +
                (parseInt(I.css.marginTop) || 0) +
                (parseInt(I.css.marginBottom) || 0),
              e = (z || 0) - t;
            return -1 <= e && e <= 1 ? z : t;
          })()),
          (v = (H = function () {
            return y
              ? Math.max(
                  Q.documentElement.clientHeight,
                  Q.body.scrollHeight,
                  Q.documentElement.scrollHeight,
                  Q.body.offsetHeight,
                  Q.documentElement.offsetHeight
                )
              : h.offsetHeight;
          })()),
          (S = y ? 0 : u.offset(h).top),
          (w = p.stickTo ? (y ? 0 : u.offset(s).top) : S),
          (E = V.innerHeight),
          (N = n.offsetTop - (parseInt(I.css.marginTop) || 0)),
          (b = u.getElement(p.innerSticker)),
          (L =
            isNaN(p.top) && -1 < p.top.indexOf("%")
              ? (parseFloat(p.top) / 100) * E
              : p.top),
          (k =
            isNaN(p.bottom) && -1 < p.bottom.indexOf("%")
              ? (parseFloat(p.bottom) / 100) * E
              : p.bottom),
          (x = b ? b.offsetTop : p.innerTop || 0),
          (T =
            isNaN(p.bottomEnd) && -1 < p.bottomEnd.indexOf("%")
              ? (parseFloat(p.bottomEnd) / 100) * E
              : p.bottomEnd),
          (j = S - L + x + N);
      }
      function r() {
        (z = R()), (v = H()), (O = S + v - L - T), (C = E < z);
        var t,
          e = V.pageYOffset || Q.documentElement.scrollTop,
          o = u.offset(n).top,
          i = o - e;
        (B = e < F ? "up" : "down"),
          (A = e - F),
          j < (F = e)
            ? O + L + (C ? k : 0) - (p.followScroll && C ? 0 : L) <=
              e +
                z -
                x -
                (E - (j - x) < z - x && p.followScroll && 0 < (t = z - E - x)
                  ? t
                  : 0)
              ? I.release({
                  position: "absolute",
                  bottom: w + s.offsetHeight - O - L,
                })
              : C && p.followScroll
              ? "down" == B
                ? i + z + k <= E + 0.9
                  ? I.stick({ bottom: k })
                  : "fixed" === I.position &&
                    I.release({ position: "absolute", top: o - L - j - A + x })
                : Math.ceil(i + x) < 0 && "fixed" === I.position
                ? I.release({ position: "absolute", top: o - L - j + x - A })
                : e + L - x <= o && I.stick({ top: L - x })
              : I.stick({ top: L - x })
            : I.release({ stop: !0 });
      }
      function l() {
        M && (V.removeEventListener("scroll", r, u.supportsPassive), (M = !1));
      }
      function a() {
        null !== n.offsetParent && "none" !== u.getStyle(n, "display")
          ? (i(),
            v < z
              ? l()
              : (r(),
                M ||
                  (V.addEventListener("scroll", r, u.supportsPassive),
                  (M = !0))))
          : l();
      }
      function c() {
        (n.style.position = ""),
          (n.style.left = ""),
          (n.style.top = ""),
          (n.style.bottom = ""),
          (n.style.width = ""),
          n.classList
            ? n.classList.remove(p.stickyClass)
            : (n.className = n.className.replace(
                new RegExp(
                  "(^|\\b)" + p.stickyClass.split(" ").join("|") + "(\\b|$)",
                  "gi"
                ),
                " "
              )),
          (I.css = {}),
          !(I.position = null) === P.isAttached && P.detach();
      }
      function g() {
        c(), e(), (t() ? l : a)();
      }
      function m() {
        q && (V.removeEventListener("resize", W, u.supportsPassive), (q = !1)),
          l();
      }
      var y,
        h,
        b,
        v,
        S,
        w,
        E,
        L,
        k,
        x,
        T,
        j,
        O,
        C,
        z,
        N,
        H,
        R,
        A,
        B,
        I = {
          css: {},
          position: null,
          stick: function (t) {
            (t = t || {}),
              u.hasClass(n, p.stickyClass) ||
                (!1 === P.isAttached && P.attach(),
                (I.position = "fixed"),
                (n.style.position = "fixed"),
                (n.style.left = P.offsetLeft + "px"),
                (n.style.width = P.width),
                void 0 === t.bottom
                  ? (n.style.bottom = "auto")
                  : (n.style.bottom = t.bottom + "px"),
                void 0 === t.top
                  ? (n.style.top = "auto")
                  : (n.style.top = t.top + "px"),
                n.classList
                  ? n.classList.add(p.stickyClass)
                  : (n.className += " " + p.stickyClass),
                p.onStart && p.onStart.call(n, Object.assign({}, p)));
          },
          release: function (t) {
            var e;
            ((t = t || {}).stop = t.stop || !1),
              (!0 !== t.stop &&
                "fixed" !== I.position &&
                null !== I.position &&
                ((void 0 === t.top && void 0 === t.bottom) ||
                  (void 0 !== t.top &&
                    (parseInt(u.getStyle(n, "top")) || 0) === t.top) ||
                  (void 0 !== t.bottom &&
                    (parseInt(u.getStyle(n, "bottom")) || 0) === t.bottom))) ||
                (!0 === t.stop
                  ? !0 === P.isAttached && P.detach()
                  : !1 === P.isAttached && P.attach(),
                (e = t.position || I.css.position),
                (I.position = e),
                (n.style.position = e),
                (n.style.left =
                  !0 === t.stop ? I.css.left : P.positionLeft + "px"),
                (n.style.width = ("absolute" !== e ? I.css : P).width),
                void 0 === t.bottom
                  ? (n.style.bottom = !0 === t.stop ? "" : "auto")
                  : (n.style.bottom = t.bottom + "px"),
                void 0 === t.top
                  ? (n.style.top = !0 === t.stop ? "" : "auto")
                  : (n.style.top = t.top + "px"),
                n.classList
                  ? n.classList.remove(p.stickyClass)
                  : (n.className = n.className.replace(
                      new RegExp(
                        "(^|\\b)" +
                          p.stickyClass.split(" ").join("|") +
                          "(\\b|$)",
                        "gi"
                      ),
                      " "
                    )),
                p.onStop && p.onStop.call(n, Object.assign({}, p)));
          },
        },
        P = {
          el: Q.createElement("div"),
          offsetLeft: null,
          positionLeft: null,
          width: null,
          isAttached: !1,
          init: function () {
            for (var t in ((P.el.className = "sticky-spacer"), I.css))
              P.el.style[t] = I.css[t];
            P.el.style["z-index"] = "-1";
            var e = u.getStyle(n);
            (P.offsetLeft = u.offset(n).left - (parseInt(e.marginLeft) || 0)),
              (P.positionLeft = u.position(n).left),
              (P.width = u.getStyle(n, "width"));
          },
          attach: function () {
            s.insertBefore(P.el, n), (P.isAttached = !0);
          },
          detach: function () {
            (P.el = s.removeChild(P.el)), (P.isAttached = !1);
          },
        },
        F = V.pageYOffset || Q.documentElement.scrollTop,
        M = !1,
        q = !1,
        D = function () {
          p.onBeforeResize && p.onBeforeResize.call(n, Object.assign({}, p)),
            g(),
            p.onResize && p.onResize.call(n, Object.assign({}, p));
        },
        W = p.resizeDebounce ? u.debounce(D, p.resizeDebounce) : D,
        D = function () {
          q || (V.addEventListener("resize", W, u.supportsPassive), (q = !0)),
            e(),
            (t() ? l : a)();
        };
      (this.options = function (t) {
        return t ? p[t] : Object.assign({}, p);
      }),
        (this.refresh = g),
        (this.update = function (t) {
          d(t), (f = Object.assign({}, f, t || {})), g();
        }),
        (this.attach = D),
        (this.detach = m),
        (this.destroy = function () {
          m(), c();
        }),
        (this.triggerMethod = function (t, e) {
          "function" == typeof o[t] && o[t](e);
        }),
        (this.reinit = function () {
          Y("reinit", "refresh", "method"), g();
        }),
        d(f),
        D(),
        V.addEventListener("load", g);
    };
  return (
    void 0 !== V.jQuery &&
      ((i = V.jQuery),
      (n = "hcSticky"),
      i.fn.extend({
        hcSticky: function (e, o) {
          return this.length
            ? "options" === e
              ? i.data(this.get(0), n).options()
              : this.each(function () {
                  var t = i.data(this, n);
                  t
                    ? t.triggerMethod(e, o)
                    : ((t = new $(this, e)), i.data(this, n, t));
                })
            : this;
        },
      })),
    (V.hcSticky = V.hcSticky || $),
    $
  );
}),
  (function (a) {
    var t = a.hcSticky,
      c = a.document;
    "function" != typeof Object.assign &&
      Object.defineProperty(Object, "assign", {
        value: function (t, e) {
          if (null == t)
            throw new TypeError("Cannot convert undefined or null to object");
          for (var o = Object(t), i = 1; i < arguments.length; i++) {
            var n = arguments[i];
            if (null != n)
              for (var s in n)
                Object.prototype.hasOwnProperty.call(n, s) && (o[s] = n[s]);
          }
          return o;
        },
        writable: !0,
        configurable: !0,
      }),
      Array.prototype.forEach ||
        (Array.prototype.forEach = function (t) {
          var e, o;
          if (null == this) throw new TypeError("this is null or not defined");
          var i,
            n = Object(this),
            s = n.length >>> 0;
          if ("function" != typeof t)
            throw new TypeError(t + " is not a function");
          for (1 < arguments.length && (e = arguments[1]), o = 0; o < s; )
            o in n && ((i = n[o]), t.call(e, i, o, n)), o++;
        });
    var e = !1;
    try {
      var o = Object.defineProperty({}, "passive", {
        get: function () {
          e = { passive: !1 };
        },
      });
      a.addEventListener("testPassive", null, o),
        a.removeEventListener("testPassive", null, o);
    } catch (t) {}
    function n(t, e) {
      return a.getComputedStyle
        ? e
          ? c.defaultView.getComputedStyle(t, null).getPropertyValue(e)
          : c.defaultView.getComputedStyle(t, null)
        : t.currentStyle
        ? e
          ? t.currentStyle[
              e.replace(/-\w/g, function (t) {
                return t.toUpperCase().replace("-", "");
              })
            ]
          : t.currentStyle
        : void 0;
    }
    function s(t) {
      var e = t.getBoundingClientRect(),
        o = a.pageYOffset || c.documentElement.scrollTop,
        t = a.pageXOffset || c.documentElement.scrollLeft;
      return { top: e.top + o, left: e.left + t };
    }
    t.Helpers = {
      supportsPassive: e,
      isEmptyObject: function (t) {
        for (var e in t) return !1;
        return !0;
      },
      debounce: function (i, n, s) {
        var r;
        return function () {
          var t = this,
            e = arguments,
            o = s && !r;
          clearTimeout(r),
            (r = setTimeout(function () {
              (r = null), s || i.apply(t, e);
            }, n)),
            o && i.apply(t, e);
        };
      },
      hasClass: function (t, e) {
        return t.classList
          ? t.classList.contains(e)
          : new RegExp("(^| )" + e + "( |$)", "gi").test(t.className);
      },
      offset: s,
      position: function (t) {
        var e = t.offsetParent,
          o = s(e),
          i = s(t),
          e = n(e),
          t = n(t);
        return (
          (o.top += parseInt(e.borderTopWidth) || 0),
          (o.left += parseInt(e.borderLeftWidth) || 0),
          {
            top: i.top - o.top - (parseInt(t.marginTop) || 0),
            left: i.left - o.left - (parseInt(t.marginLeft) || 0),
          }
        );
      },
      getElement: function (t) {
        var e = null;
        return (
          "string" == typeof t
            ? (e = c.querySelector(t))
            : a.jQuery && t instanceof a.jQuery && t.length
            ? (e = t[0])
            : t instanceof Element && (e = t),
          e
        );
      },
      getStyle: n,
      getCascadedStyle: function (t) {
        var e,
          o = t.cloneNode(!0);
        (o.style.display = "none"),
          Array.prototype.slice
            .call(o.querySelectorAll('input[type="radio"]'))
            .forEach(function (t) {
              t.removeAttribute("name");
            }),
          t.parentNode.insertBefore(o, t.nextSibling),
          o.currentStyle
            ? (e = o.currentStyle)
            : a.getComputedStyle &&
              (e = c.defaultView.getComputedStyle(o, null));
        var i,
          n,
          s,
          r = {};
        for (i in e)
          !isNaN(i) ||
            ("string" != typeof e[i] && "number" != typeof e[i]) ||
            (r[i] = e[i]);
        if (Object.keys(r).length < 3)
          for (var l in ((r = {}), e))
            isNaN(l) ||
              (r[
                e[l].replace(/-\w/g, function (t) {
                  return t.toUpperCase().replace("-", "");
                })
              ] = e.getPropertyValue(e[l]));
        return (
          r.margin || "auto" !== r.marginLeft
            ? r.margin ||
              r.marginLeft !== r.marginRight ||
              r.marginLeft !== r.marginTop ||
              r.marginLeft !== r.marginBottom ||
              (r.margin = r.marginLeft)
            : (r.margin = "auto"),
          r.margin ||
            "0px" !== r.marginLeft ||
            "0px" !== r.marginRight ||
            ((s =
              (n = t.offsetLeft - t.parentNode.offsetLeft) -
              (parseInt(r.left) || 0) -
              (parseInt(r.right) || 0)),
            (0 !=
              (s =
                t.parentNode.offsetWidth -
                t.offsetWidth -
                n -
                (parseInt(r.right) || 0) +
                (parseInt(r.left) || 0) -
                s) &&
              1 != s) ||
              (r.margin = "auto")),
          o.parentNode.removeChild(o),
          (o = null),
          r
        );
      },
    };
  })(window);
// SCROLL HEADER FIXED
// if( $(window).width() >= 767 ) {
// $(window).scroll(function() {
//     var scroll = $(window).scrollTop();
//     if (scroll >= 150) {
//         $(".collection-left-filter").addClass("left-filter-sticky");
//     } else {
//         $(".collection-left-filter").removeClass("left-filter-sticky");
//     }
// });
// }
("use strict");

var Sticky = new hcSticky(".collection-left-filter", {
  stickTo: "#Collection",
  responsive: {
    767: {
      disable: true,
    },
  },
});

// FLITER LEFT CLICK SHOW HIDE
$(function () {
  var filterList = {
    init: function () {
      // MixItUp plugin
      // http://mixitup.io
      $("#portfoliolist").mixItUp({
        selectors: {
          target: ".portfolio",
          filter: ".filter",
        },
        load: {
          filter: ".shop",
        },
      });
    },
  };

  // Run the show!
  filterList.init();
});

$(document).ready(function () {
  var toTop = $(".filter");

  toTop.on("click", function () {
    $("html, body").animate({
      scrollTop: $("html, body").offset().top,
    });
  });
});

!(function (a, b) {
  "use strict";
  (a.MixItUp = function () {
    var b = this;
    b._execAction("_constructor", 0),
      a.extend(b, {
        selectors: {
          target: ".mix",
          filter: ".filter",
          sort: ".sort",
        },
        animation: {
          enable: !0,
          effects: "fade scale",
          duration: 600,
          easing: "ease",
          perspectiveDistance: "3000",
          perspectiveOrigin: "50% 50%",
          queue: !0,
          queueLimit: 1,
          animateChangeLayout: !1,
          animateResizeContainer: !0,
          animateResizeTargets: !1,
          staggerSequence: !1,
          reverseOut: !1,
        },
        callbacks: {
          onMixLoad: !1,
          onMixStart: !1,
          onMixBusy: !1,
          onMixEnd: !1,
          onMixFail: !1,
          _user: !1,
        },
        controls: {
          enable: !0,
          live: !1,
          toggleFilterButtons: !1,
          toggleLogic: "or",
          activeClass: "active",
        },
        layout: {
          display: "inline-block",
          containerClass: "",
          containerClassFail: "fail",
        },
        load: {
          filter: "all",
          sort: !1,
        },
        _$body: null,
        _$container: null,
        _$targets: null,
        _$parent: null,
        _$sortButtons: null,
        _$filterButtons: null,
        _suckMode: !1,
        _mixing: !1,
        _sorting: !1,
        _clicking: !1,
        _loading: !0,
        _changingLayout: !1,
        _changingClass: !1,
        _changingDisplay: !1,
        _origOrder: [],
        _startOrder: [],
        _newOrder: [],
        _activeFilter: null,
        _toggleArray: [],
        _toggleString: "",
        _activeSort: "default:asc",
        _newSort: null,
        _startHeight: null,
        _newHeight: null,
        _incPadding: !0,
        _newDisplay: null,
        _newClass: null,
        _targetsBound: 0,
        _targetsDone: 0,
        _queue: [],
        _$show: a(),
        _$hide: a(),
      }),
      b._execAction("_constructor", 1);
  }),
    (a.MixItUp.prototype = {
      constructor: a.MixItUp,
      _instances: {},
      _handled: {
        _filter: {},
        _sort: {},
      },
      _bound: {
        _filter: {},
        _sort: {},
      },
      _actions: {},
      _filters: {},
      extend: function (b) {
        for (var c in b) a.MixItUp.prototype[c] = b[c];
      },
      addAction: function (b, c, d, e) {
        a.MixItUp.prototype._addHook("_actions", b, c, d, e);
      },
      addFilter: function (b, c, d, e) {
        a.MixItUp.prototype._addHook("_filters", b, c, d, e);
      },
      _addHook: function (b, c, d, e, f) {
        var g = a.MixItUp.prototype[b],
          h = {};
        (f = 1 === f || "post" === f ? "post" : "pre"),
          (h[c] = {}),
          (h[c][f] = {}),
          (h[c][f][d] = e),
          a.extend(!0, g, h);
      },
      _init: function (b, c) {
        var d = this;
        if (
          (d._execAction("_init", 0, arguments),
          c && a.extend(!0, d, c),
          (d._$body = a("body")),
          (d._domNode = b),
          (d._$container = a(b)),
          d._$container.addClass(d.layout.containerClass),
          (d._id = b.id),
          d._platformDetect(),
          (d._brake = d._getPrefixedCSS("transition", "none")),
          d._refresh(!0),
          (d._$parent = d._$targets.parent().length
            ? d._$targets.parent()
            : d._$container),
          d.load.sort &&
            ((d._newSort = d._parseSort(d.load.sort)),
            (d._newSortString = d.load.sort),
            (d._activeSort = d.load.sort),
            d._sort(),
            d._printSort()),
          (d._activeFilter =
            "all" === d.load.filter
              ? d.selectors.target
              : "none" === d.load.filter
              ? ""
              : d.load.filter),
          d.controls.enable && d._bindHandlers(),
          d.controls.toggleFilterButtons)
        ) {
          d._buildToggleArray();
          for (var e = 0; e < d._toggleArray.length; e++)
            d._updateControls(
              {
                filter: d._toggleArray[e],
                sort: d._activeSort,
              },
              !0
            );
        } else
          d.controls.enable &&
            d._updateControls({
              filter: d._activeFilter,
              sort: d._activeSort,
            });
        d._filter(),
          (d._init = !0),
          d._$container.data("mixItUp", d),
          d._execAction("_init", 1, arguments),
          d._buildState(),
          d._$targets.css(d._brake),
          d._goMix(d.animation.enable);
      },
      _platformDetect: function () {
        var a = this,
          c = ["Webkit", "Moz", "O", "ms"],
          d = ["webkit", "moz"],
          e = window.navigator.appVersion.match(/Chrome\/(\d+)\./) || !1,
          f = "undefined" != typeof InstallTrigger,
          g = function (a) {
            for (var b = 0; b < c.length; b++)
              if (c[b] + "Transition" in a.style)
                return {
                  prefix: "-" + c[b].toLowerCase() + "-",
                  vendor: c[b],
                };
            return "transition" in a.style ? "" : !1;
          },
          h = g(a._domNode);
        a._execAction("_platformDetect", 0),
          (a._chrome = e ? parseInt(e[1], 10) : !1),
          (a._ff = f
            ? parseInt(window.navigator.userAgent.match(/rv:([^)]+)\)/)[1])
            : !1),
          (a._prefix = h.prefix),
          (a._vendor = h.vendor),
          (a._suckMode = window.atob && a._prefix ? !1 : !0),
          a._suckMode && (a.animation.enable = !1),
          a._ff && a._ff <= 4 && (a.animation.enable = !1);
        for (var i = 0; i < d.length && !window.requestAnimationFrame; i++)
          window.requestAnimationFrame = window[d[i] + "RequestAnimationFrame"];
        "function" != typeof Object.getPrototypeOf &&
          ("object" == typeof "test".__proto__
            ? (Object.getPrototypeOf = function (a) {
                return a.__proto__;
              })
            : (Object.getPrototypeOf = function (a) {
                return a.constructor.prototype;
              })),
          a._domNode.nextElementSibling === b &&
            Object.defineProperty(Element.prototype, "nextElementSibling", {
              get: function () {
                for (var a = this.nextSibling; a; ) {
                  if (1 === a.nodeType) return a;
                  a = a.nextSibling;
                }
                return null;
              },
            }),
          a._execAction("_platformDetect", 1);
      },
      _refresh: function (a, c) {
        var d = this;
        d._execAction("_refresh", 0, arguments),
          (d._$targets = d._$container.find(d.selectors.target));
        for (var e = 0; e < d._$targets.length; e++) {
          var f = d._$targets[e];
          if (f.dataset === b || c) {
            f.dataset = {};
            for (var g = 0; g < f.attributes.length; g++) {
              var h = f.attributes[g],
                i = h.name,
                j = h.value;
              if (i.indexOf("data-") > -1) {
                var k = d._helpers._camelCase(i.substring(5, i.length));
                f.dataset[k] = j;
              }
            }
          }
          f.mixParent === b && (f.mixParent = d._id);
        }
        if (
          (d._$targets.length && a) ||
          (!d._origOrder.length && d._$targets.length)
        ) {
          d._origOrder = [];
          for (var e = 0; e < d._$targets.length; e++) {
            var f = d._$targets[e];
            d._origOrder.push(f);
          }
        }
        d._execAction("_refresh", 1, arguments);
      },
      _bindHandlers: function () {
        var c = this,
          d = a.MixItUp.prototype._bound._filter,
          e = a.MixItUp.prototype._bound._sort;
        c._execAction("_bindHandlers", 0),
          c.controls.live
            ? c._$body
                .on("click.mixItUp." + c._id, c.selectors.sort, function () {
                  c._processClick(a(this), "sort");
                })
                .on("click.mixItUp." + c._id, c.selectors.filter, function () {
                  c._processClick(a(this), "filter");
                })
            : ((c._$sortButtons = a(c.selectors.sort)),
              (c._$filterButtons = a(c.selectors.filter)),
              c._$sortButtons.on("click.mixItUp." + c._id, function () {
                c._processClick(a(this), "sort");
              }),
              c._$filterButtons.on("click.mixItUp." + c._id, function () {
                c._processClick(a(this), "filter");
              })),
          (d[c.selectors.filter] =
            d[c.selectors.filter] === b ? 1 : d[c.selectors.filter] + 1),
          (e[c.selectors.sort] =
            e[c.selectors.sort] === b ? 1 : e[c.selectors.sort] + 1),
          c._execAction("_bindHandlers", 1);
      },
      _processClick: function (c, d) {
        var e = this,
          f = function (c, d, f) {
            var g = a.MixItUp.prototype;
            (g._handled["_" + d][e.selectors[d]] =
              g._handled["_" + d][e.selectors[d]] === b
                ? 1
                : g._handled["_" + d][e.selectors[d]] + 1),
              g._handled["_" + d][e.selectors[d]] ===
                g._bound["_" + d][e.selectors[d]] &&
                (c[(f ? "remove" : "add") + "Class"](e.controls.activeClass),
                delete g._handled["_" + d][e.selectors[d]]);
          };
        if (
          (e._execAction("_processClick", 0, arguments),
          !e._mixing ||
            (e.animation.queue && e._queue.length < e.animation.queueLimit))
        ) {
          if (((e._clicking = !0), "sort" === d)) {
            var g = c.attr("data-sort");
            (!c.hasClass(e.controls.activeClass) || g.indexOf("random") > -1) &&
              (a(e.selectors.sort).removeClass(e.controls.activeClass),
              f(c, d),
              e.sort(g));
          }
          if ("filter" === d) {
            var h,
              i = c.attr("data-filter"),
              j = "or" === e.controls.toggleLogic ? "," : "";
            e.controls.toggleFilterButtons
              ? (e._buildToggleArray(),
                c.hasClass(e.controls.activeClass)
                  ? (f(c, d, !0),
                    (h = e._toggleArray.indexOf(i)),
                    e._toggleArray.splice(h, 1))
                  : (f(c, d), e._toggleArray.push(i)),
                (e._toggleArray = a.grep(e._toggleArray, function (a) {
                  return a;
                })),
                (e._toggleString = e._toggleArray.join(j)),
                e.filter(e._toggleString))
              : c.hasClass(e.controls.activeClass) ||
                (a(e.selectors.filter).removeClass(e.controls.activeClass),
                f(c, d),
                e.filter(i));
          }
          e._execAction("_processClick", 1, arguments);
        } else
          "function" == typeof e.callbacks.onMixBusy &&
            e.callbacks.onMixBusy.call(e._domNode, e._state, e),
            e._execAction("_processClickBusy", 1, arguments);
      },
      _buildToggleArray: function () {
        var a = this,
          b = a._activeFilter.replace(/\s/g, "");
        if (
          (a._execAction("_buildToggleArray", 0, arguments),
          "or" === a.controls.toggleLogic)
        )
          a._toggleArray = b.split(",");
        else {
          (a._toggleArray = b.split(".")),
            !a._toggleArray[0] && a._toggleArray.shift();
          for (var c, d = 0; (c = a._toggleArray[d]); d++)
            a._toggleArray[d] = "." + c;
        }
        a._execAction("_buildToggleArray", 1, arguments);
      },
      _updateControls: function (c, d) {
        var e = this,
          f = {
            filter: c.filter,
            sort: c.sort,
          },
          g = function (a, b) {
            try {
              d && "filter" === h && "none" !== f.filter && "" !== f.filter
                ? a.filter(b).addClass(e.controls.activeClass)
                : a
                    .removeClass(e.controls.activeClass)
                    .filter(b)
                    .addClass(e.controls.activeClass);
            } catch (c) {}
          },
          h = "filter",
          i = null;
        e._execAction("_updateControls", 0, arguments),
          c.filter === b && (f.filter = e._activeFilter),
          c.sort === b && (f.sort = e._activeSort),
          f.filter === e.selectors.target && (f.filter = "all");
        for (var j = 0; 2 > j; j++)
          (i = e.controls.live ? a(e.selectors[h]) : e["_$" + h + "Buttons"]),
            i && g(i, "[data-" + h + '="' + f[h] + '"]'),
            (h = "sort");
        e._execAction("_updateControls", 1, arguments);
      },
      _filter: function () {
        var b = this;
        b._execAction("_filter", 0);
        for (var c = 0; c < b._$targets.length; c++) {
          var d = a(b._$targets[c]);
          d.is(b._activeFilter)
            ? (b._$show = b._$show.add(d))
            : (b._$hide = b._$hide.add(d));
        }
        b._execAction("_filter", 1);
      },
      _sort: function () {
        var a = this,
          b = function (a) {
            for (var b = a.slice(), c = b.length, d = c; d--; ) {
              var e = parseInt(Math.random() * c),
                f = b[d];
              (b[d] = b[e]), (b[e] = f);
            }
            return b;
          };
        a._execAction("_sort", 0), (a._startOrder = []);
        for (var c = 0; c < a._$targets.length; c++) {
          var d = a._$targets[c];
          a._startOrder.push(d);
        }
        switch (a._newSort[0].sortBy) {
          case "default":
            a._newOrder = a._origOrder;
            break;
          case "random":
            a._newOrder = b(a._startOrder);
            break;
          case "custom":
            a._newOrder = a._newSort[0].order;
            break;
          default:
            a._newOrder = a._startOrder.concat().sort(function (b, c) {
              return a._compare(b, c);
            });
        }
        a._execAction("_sort", 1);
      },
      _compare: function (a, b, c) {
        c = c ? c : 0;
        var d = this,
          e = d._newSort[c].order,
          f = function (a) {
            return a.dataset[d._newSort[c].sortBy] || 0;
          },
          g = isNaN(1 * f(a)) ? f(a).toLowerCase() : 1 * f(a),
          h = isNaN(1 * f(b)) ? f(b).toLowerCase() : 1 * f(b);
        return h > g
          ? "asc" === e
            ? -1
            : 1
          : g > h
          ? "asc" === e
            ? 1
            : -1
          : g === h && d._newSort.length > c + 1
          ? d._compare(a, b, c + 1)
          : 0;
      },
      _printSort: function (a) {
        var b = this,
          c = a ? b._startOrder : b._newOrder,
          d = b._$parent[0].querySelectorAll(b.selectors.target),
          e = d.length ? d[d.length - 1].nextElementSibling : null,
          f = document.createDocumentFragment();
        b._execAction("_printSort", 0, arguments);
        for (var g = 0; g < d.length; g++) {
          var h = d[g],
            i = h.nextSibling;
          "absolute" !== h.style.position &&
            (i && "#text" === i.nodeName && b._$parent[0].removeChild(i),
            b._$parent[0].removeChild(h));
        }
        for (var g = 0; g < c.length; g++) {
          var j = c[g];
          if (
            "default" !== b._newSort[0].sortBy ||
            "desc" !== b._newSort[0].order ||
            a
          )
            f.appendChild(j), f.appendChild(document.createTextNode(" "));
          else {
            var k = f.firstChild;
            f.insertBefore(j, k),
              f.insertBefore(document.createTextNode(" "), j);
          }
        }
        e ? b._$parent[0].insertBefore(f, e) : b._$parent[0].appendChild(f),
          b._execAction("_printSort", 1, arguments);
      },
      _parseSort: function (a) {
        for (
          var b = this,
            c = "string" == typeof a ? a.split(" ") : [a],
            d = [],
            e = 0;
          e < c.length;
          e++
        ) {
          var f = "string" == typeof a ? c[e].split(":") : ["custom", c[e]],
            g = {
              sortBy: b._helpers._camelCase(f[0]),
              order: f[1] || "asc",
            };
          if ((d.push(g), "default" === g.sortBy || "random" === g.sortBy))
            break;
        }
        return b._execFilter("_parseSort", d, arguments);
      },
      _parseEffects: function () {
        var a = this,
          b = {
            opacity: "",
            transformIn: "",
            transformOut: "",
            filter: "",
          },
          c = function (b, c, d) {
            if (a.animation.effects.indexOf(b) > -1) {
              if (c) {
                var e = a.animation.effects.indexOf(b + "(");
                if (e > -1) {
                  var f = a.animation.effects.substring(e),
                    g = /\(([^)]+)\)/.exec(f),
                    h = g[1];
                  return {
                    val: h,
                  };
                }
              }
              return !0;
            }
            return !1;
          },
          d = function (a, b) {
            return b
              ? "-" === a.charAt(0)
                ? a.substr(1, a.length)
                : "-" + a
              : a;
          },
          e = function (a, e) {
            for (
              var f = [
                  ["scale", ".01"],
                  ["translateX", "20px"],
                  ["translateY", "20px"],
                  ["translateZ", "20px"],
                  ["rotateX", "90deg"],
                  ["rotateY", "90deg"],
                  ["rotateZ", "180deg"],
                ],
                g = 0;
              g < f.length;
              g++
            ) {
              var h = f[g][0],
                i = f[g][1],
                j = e && "scale" !== h;
              b[a] += c(h) ? h + "(" + d(c(h, !0).val || i, j) + ") " : "";
            }
          };
        return (
          (b.opacity = c("fade") ? c("fade", !0).val || "0" : "1"),
          e("transformIn"),
          a.animation.reverseOut
            ? e("transformOut", !0)
            : (b.transformOut = b.transformIn),
          (b.transition = {}),
          (b.transition = a._getPrefixedCSS(
            "transition",
            "all " +
              a.animation.duration +
              "ms " +
              a.animation.easing +
              ", opacity " +
              a.animation.duration +
              "ms linear"
          )),
          (a.animation.stagger = c("stagger") ? !0 : !1),
          (a.animation.staggerDuration = parseInt(
            c("stagger") && c("stagger", !0).val ? c("stagger", !0).val : 100
          )),
          a._execFilter("_parseEffects", b)
        );
      },
      _buildState: function (a) {
        var b = this,
          c = {};
        return (
          b._execAction("_buildState", 0),
          (c = {
            activeFilter: "" === b._activeFilter ? "none" : b._activeFilter,
            activeSort:
              a && b._newSortString ? b._newSortString : b._activeSort,
            fail: !b._$show.length && "" !== b._activeFilter,
            $targets: b._$targets,
            $show: b._$show,
            $hide: b._$hide,
            totalTargets: b._$targets.length,
            totalShow: b._$show.length,
            totalHide: b._$hide.length,
            display: a && b._newDisplay ? b._newDisplay : b.layout.display,
          }),
          a
            ? b._execFilter("_buildState", c)
            : ((b._state = c), void b._execAction("_buildState", 1))
        );
      },
      _goMix: function (a) {
        var b = this,
          c = function () {
            b._chrome && 31 === b._chrome && f(b._$parent[0]),
              b._setInter(),
              d();
          },
          d = function () {
            var a = window.pageYOffset,
              c = window.pageXOffset;
            document.documentElement.scrollHeight;
            b._getInterMixData(),
              b._setFinal(),
              b._getFinalMixData(),
              window.pageYOffset !== a && window.scrollTo(c, a),
              b._prepTargets(),
              window.requestAnimationFrame
                ? requestAnimationFrame(e)
                : setTimeout(function () {
                    e();
                  }, 20);
          },
          e = function () {
            b._animateTargets(), 0 === b._targetsBound && b._cleanUp();
          },
          f = function (a) {
            var b = a.parentElement,
              c = document.createElement("div"),
              d = document.createDocumentFragment();
            b.insertBefore(c, a), d.appendChild(a), b.replaceChild(a, c);
          },
          g = b._buildState(!0);
        b._execAction("_goMix", 0, arguments),
          !b.animation.duration && (a = !1),
          (b._mixing = !0),
          b._$container.removeClass(b.layout.containerClassFail),
          "function" == typeof b.callbacks.onMixStart &&
            b.callbacks.onMixStart.call(b._domNode, b._state, g, b),
          b._$container.trigger("mixStart", [b._state, g, b]),
          b._getOrigMixData(),
          a && !b._suckMode
            ? window.requestAnimationFrame
              ? requestAnimationFrame(c)
              : c()
            : b._cleanUp(),
          b._execAction("_goMix", 1, arguments);
      },
      _getTargetData: function (a, b) {
        var c,
          d = this;
        (a.dataset[b + "PosX"] = a.offsetLeft),
          (a.dataset[b + "PosY"] = a.offsetTop),
          d.animation.animateResizeTargets &&
            ((c = d._suckMode
              ? {
                  marginBottom: "",
                  marginRight: "",
                }
              : window.getComputedStyle(a)),
            (a.dataset[b + "MarginBottom"] = parseInt(c.marginBottom)),
            (a.dataset[b + "MarginRight"] = parseInt(c.marginRight)),
            (a.dataset[b + "Width"] = a.offsetWidth),
            (a.dataset[b + "Height"] = a.offsetHeight));
      },
      _getOrigMixData: function () {
        var a = this,
          b = a._suckMode
            ? {
                boxSizing: "",
              }
            : window.getComputedStyle(a._$parent[0]),
          c = b.boxSizing || b[a._vendor + "BoxSizing"];
        (a._incPadding = "border-box" === c),
          a._execAction("_getOrigMixData", 0),
          !a._suckMode && (a.effects = a._parseEffects()),
          (a._$toHide = a._$hide.filter(":visible")),
          (a._$toShow = a._$show.filter(":hidden")),
          (a._$pre = a._$targets.filter(":visible")),
          (a._startHeight = a._incPadding
            ? a._$parent.outerHeight()
            : a._$parent.height());
        for (var d = 0; d < a._$pre.length; d++) {
          var e = a._$pre[d];
          a._getTargetData(e, "orig");
        }
        a._execAction("_getOrigMixData", 1);
      },
      _setInter: function () {
        var a = this;
        a._execAction("_setInter", 0),
          a._changingLayout && a.animation.animateChangeLayout
            ? (a._$toShow.css("display", a._newDisplay),
              a._changingClass &&
                a._$container
                  .removeClass(a.layout.containerClass)
                  .addClass(a._newClass))
            : a._$toShow.css("display", a.layout.display),
          a._execAction("_setInter", 1);
      },
      _getInterMixData: function () {
        var a = this;
        a._execAction("_getInterMixData", 0);
        for (var b = 0; b < a._$toShow.length; b++) {
          var c = a._$toShow[b];
          a._getTargetData(c, "inter");
        }
        for (var b = 0; b < a._$pre.length; b++) {
          var c = a._$pre[b];
          a._getTargetData(c, "inter");
        }
        a._execAction("_getInterMixData", 1);
      },
      _setFinal: function () {
        var a = this;
        a._execAction("_setFinal", 0),
          a._sorting && a._printSort(),
          a._$toHide.removeStyle("display"),
          a._changingLayout &&
            a.animation.animateChangeLayout &&
            a._$pre.css("display", a._newDisplay),
          a._execAction("_setFinal", 1);
      },
      _getFinalMixData: function () {
        var a = this;
        a._execAction("_getFinalMixData", 0);
        for (var b = 0; b < a._$toShow.length; b++) {
          var c = a._$toShow[b];
          a._getTargetData(c, "final");
        }
        for (var b = 0; b < a._$pre.length; b++) {
          var c = a._$pre[b];
          a._getTargetData(c, "final");
        }
        (a._newHeight = a._incPadding
          ? a._$parent.outerHeight()
          : a._$parent.height()),
          a._sorting && a._printSort(!0),
          a._$toShow.removeStyle("display"),
          a._$pre.css("display", a.layout.display),
          a._changingClass &&
            a.animation.animateChangeLayout &&
            a._$container
              .removeClass(a._newClass)
              .addClass(a.layout.containerClass),
          a._execAction("_getFinalMixData", 1);
      },
      _prepTargets: function () {
        var b = this,
          c = {
            _in: b._getPrefixedCSS("transform", b.effects.transformIn),
            _out: b._getPrefixedCSS("transform", b.effects.transformOut),
          };
        b._execAction("_prepTargets", 0),
          b.animation.animateResizeContainer &&
            b._$parent.css("height", b._startHeight + "px");
        for (var d = 0; d < b._$toShow.length; d++) {
          var e = b._$toShow[d],
            f = a(e);
          (e.style.opacity = b.effects.opacity),
            (e.style.display =
              b._changingLayout && b.animation.animateChangeLayout
                ? b._newDisplay
                : b.layout.display),
            f.css(c._in),
            b.animation.animateResizeTargets &&
              ((e.style.width = e.dataset.finalWidth + "px"),
              (e.style.height = e.dataset.finalHeight + "px"),
              (e.style.marginRight =
                -(e.dataset.finalWidth - e.dataset.interWidth) +
                1 * e.dataset.finalMarginRight +
                "px"),
              (e.style.marginBottom =
                -(e.dataset.finalHeight - e.dataset.interHeight) +
                1 * e.dataset.finalMarginBottom +
                "px"));
        }
        for (var d = 0; d < b._$pre.length; d++) {
          var e = b._$pre[d],
            f = a(e),
            g = {
              x: e.dataset.origPosX - e.dataset.interPosX,
              y: e.dataset.origPosY - e.dataset.interPosY,
            },
            c = b._getPrefixedCSS(
              "transform",
              "translate(" + g.x + "px," + g.y + "px)"
            );
          f.css(c),
            b.animation.animateResizeTargets &&
              ((e.style.width = e.dataset.origWidth + "px"),
              (e.style.height = e.dataset.origHeight + "px"),
              e.dataset.origWidth - e.dataset.finalWidth &&
                (e.style.marginRight =
                  -(e.dataset.origWidth - e.dataset.interWidth) +
                  1 * e.dataset.origMarginRight +
                  "px"),
              e.dataset.origHeight - e.dataset.finalHeight &&
                (e.style.marginBottom =
                  -(e.dataset.origHeight - e.dataset.interHeight) +
                  1 * e.dataset.origMarginBottom +
                  "px"));
        }
        b._execAction("_prepTargets", 1);
      },
      _animateTargets: function () {
        var b = this;
        b._execAction("_animateTargets", 0),
          (b._targetsDone = 0),
          (b._targetsBound = 0),
          b._$parent
            .css(
              b._getPrefixedCSS(
                "perspective",
                b.animation.perspectiveDistance + "px"
              )
            )
            .css(
              b._getPrefixedCSS(
                "perspective-origin",
                b.animation.perspectiveOrigin
              )
            ),
          b.animation.animateResizeContainer &&
            b._$parent
              .css(
                b._getPrefixedCSS(
                  "transition",
                  "height " + b.animation.duration + "ms ease"
                )
              )
              .css("height", b._newHeight + "px");
        for (var c = 0; c < b._$toShow.length; c++) {
          var d = b._$toShow[c],
            e = a(d),
            f = {
              x: d.dataset.finalPosX - d.dataset.interPosX,
              y: d.dataset.finalPosY - d.dataset.interPosY,
            },
            g = b._getDelay(c),
            h = {};
          d.style.opacity = "";
          for (var i = 0; 2 > i; i++) {
            var j = 0 === i ? (j = b._prefix) : "";
            b._ff &&
              b._ff <= 20 &&
              ((h[j + "transition-property"] = "all"),
              (h[j + "transition-timing-function"] = b.animation.easing + "ms"),
              (h[j + "transition-duration"] = b.animation.duration + "ms")),
              (h[j + "transition-delay"] = g + "ms"),
              (h[j + "transform"] = "translate(" + f.x + "px," + f.y + "px)");
          }
          (b.effects.transform || b.effects.opacity) && b._bindTargetDone(e),
            b._ff && b._ff <= 20
              ? e.css(h)
              : e.css(b.effects.transition).css(h);
        }
        for (var c = 0; c < b._$pre.length; c++) {
          var d = b._$pre[c],
            e = a(d),
            f = {
              x: d.dataset.finalPosX - d.dataset.interPosX,
              y: d.dataset.finalPosY - d.dataset.interPosY,
            },
            g = b._getDelay(c);
          (d.dataset.finalPosX !== d.dataset.origPosX ||
            d.dataset.finalPosY !== d.dataset.origPosY) &&
            b._bindTargetDone(e),
            e.css(
              b._getPrefixedCSS(
                "transition",
                "all " +
                  b.animation.duration +
                  "ms " +
                  b.animation.easing +
                  " " +
                  g +
                  "ms"
              )
            ),
            e.css(
              b._getPrefixedCSS(
                "transform",
                "translate(" + f.x + "px," + f.y + "px)"
              )
            ),
            b.animation.animateResizeTargets &&
              (d.dataset.origWidth - d.dataset.finalWidth &&
                1 * d.dataset.finalWidth &&
                ((d.style.width = d.dataset.finalWidth + "px"),
                (d.style.marginRight =
                  -(d.dataset.finalWidth - d.dataset.interWidth) +
                  1 * d.dataset.finalMarginRight +
                  "px")),
              d.dataset.origHeight - d.dataset.finalHeight &&
                1 * d.dataset.finalHeight &&
                ((d.style.height = d.dataset.finalHeight + "px"),
                (d.style.marginBottom =
                  -(d.dataset.finalHeight - d.dataset.interHeight) +
                  1 * d.dataset.finalMarginBottom +
                  "px")));
        }
        b._changingClass &&
          b._$container
            .removeClass(b.layout.containerClass)
            .addClass(b._newClass);
        for (var c = 0; c < b._$toHide.length; c++) {
          for (
            var d = b._$toHide[c], e = a(d), g = b._getDelay(c), k = {}, i = 0;
            2 > i;
            i++
          ) {
            var j = 0 === i ? (j = b._prefix) : "";
            (k[j + "transition-delay"] = g + "ms"),
              (k[j + "transform"] = b.effects.transformOut),
              (k.opacity = b.effects.opacity);
          }
          e.css(b.effects.transition).css(k),
            (b.effects.transform || b.effects.opacity) && b._bindTargetDone(e);
        }
        b._execAction("_animateTargets", 1);
      },
      _bindTargetDone: function (b) {
        var c = this,
          d = b[0];
        c._execAction("_bindTargetDone", 0, arguments),
          d.dataset.bound ||
            ((d.dataset.bound = !0),
            c._targetsBound++,
            b.on(
              "webkitTransitionEnd.mixItUp transitionend.mixItUp",
              function (e) {
                (e.originalEvent.propertyName.indexOf("transform") > -1 ||
                  e.originalEvent.propertyName.indexOf("opacity") > -1) &&
                  a(e.originalEvent.target).is(c.selectors.target) &&
                  (b.off(".mixItUp"), (d.dataset.bound = ""), c._targetDone());
              }
            )),
          c._execAction("_bindTargetDone", 1, arguments);
      },
      _targetDone: function () {
        var a = this;
        a._execAction("_targetDone", 0),
          a._targetsDone++,
          a._targetsDone === a._targetsBound && a._cleanUp(),
          a._execAction("_targetDone", 1);
      },
      _cleanUp: function () {
        var b = this,
          c = b.animation.animateResizeTargets
            ? "transform opacity width height margin-bottom margin-right"
            : "transform opacity",
          d = function () {
            b._$targets.removeStyle("transition", b._prefix);
          };
        b._execAction("_cleanUp", 0),
          b._changingLayout
            ? b._$show.css("display", b._newDisplay)
            : b._$show.css("display", b.layout.display),
          b._$targets.css(b._brake),
          b._$targets
            .removeStyle(c, b._prefix)
            .removeAttr(
              "data-inter-pos-x data-inter-pos-y data-final-pos-x data-final-pos-y data-orig-pos-x data-orig-pos-y data-orig-height data-orig-width data-final-height data-final-width data-inter-width data-inter-height data-orig-margin-right data-orig-margin-bottom data-inter-margin-right data-inter-margin-bottom data-final-margin-right data-final-margin-bottom"
            ),
          b._$hide.removeStyle("display"),
          b._$parent.removeStyle(
            "height transition perspective-distance perspective perspective-origin-x perspective-origin-y perspective-origin perspectiveOrigin",
            b._prefix
          ),
          b._sorting &&
            (b._printSort(),
            (b._activeSort = b._newSortString),
            (b._sorting = !1)),
          b._changingLayout &&
            (b._changingDisplay &&
              ((b.layout.display = b._newDisplay), (b._changingDisplay = !1)),
            b._changingClass &&
              (b._$parent
                .removeClass(b.layout.containerClass)
                .addClass(b._newClass),
              (b.layout.containerClass = b._newClass),
              (b._changingClass = !1)),
            (b._changingLayout = !1)),
          b._refresh(),
          b._buildState(),
          b._state.fail && b._$container.addClass(b.layout.containerClassFail),
          (b._$show = a()),
          (b._$hide = a()),
          window.requestAnimationFrame && requestAnimationFrame(d),
          (b._mixing = !1),
          "function" == typeof b.callbacks._user &&
            b.callbacks._user.call(b._domNode, b._state, b),
          "function" == typeof b.callbacks.onMixEnd &&
            b.callbacks.onMixEnd.call(b._domNode, b._state, b),
          b._$container.trigger("mixEnd", [b._state, b]),
          b._state.fail &&
            ("function" == typeof b.callbacks.onMixFail &&
              b.callbacks.onMixFail.call(b._domNode, b._state, b),
            b._$container.trigger("mixFail", [b._state, b])),
          b._loading &&
            ("function" == typeof b.callbacks.onMixLoad &&
              b.callbacks.onMixLoad.call(b._domNode, b._state, b),
            b._$container.trigger("mixLoad", [b._state, b])),
          b._queue.length &&
            (b._execAction("_queue", 0),
            b.multiMix(b._queue[0][0], b._queue[0][1], b._queue[0][2]),
            b._queue.splice(0, 1)),
          b._execAction("_cleanUp", 1),
          (b._loading = !1);
      },
      _getPrefixedCSS: function (a, b, c) {
        var d = this,
          e = {},
          f = "",
          g = -1;
        for (g = 0; 2 > g; g++)
          (f = 0 === g ? d._prefix : ""),
            c ? (e[f + a] = f + b) : (e[f + a] = b);
        return d._execFilter("_getPrefixedCSS", e, arguments);
      },
      _getDelay: function (a) {
        var b = this,
          c =
            "function" == typeof b.animation.staggerSequence
              ? b.animation.staggerSequence.call(b._domNode, a, b._state)
              : a,
          d = b.animation.stagger ? c * b.animation.staggerDuration : 0;
        return b._execFilter("_getDelay", d, arguments);
      },
      _parseMultiMixArgs: function (a) {
        for (
          var b = this,
            c = {
              command: null,
              animate: b.animation.enable,
              callback: null,
            },
            d = 0;
          d < a.length;
          d++
        ) {
          var e = a[d];
          null !== e &&
            ("object" == typeof e || "string" == typeof e
              ? (c.command = e)
              : "boolean" == typeof e
              ? (c.animate = e)
              : "function" == typeof e && (c.callback = e));
        }
        return b._execFilter("_parseMultiMixArgs", c, arguments);
      },
      _parseInsertArgs: function (b) {
        for (
          var c = this,
            d = {
              index: 0,
              $object: a(),
              multiMix: {
                filter: c._state.activeFilter,
              },
              callback: null,
            },
            e = 0;
          e < b.length;
          e++
        ) {
          var f = b[e];
          "number" == typeof f
            ? (d.index = f)
            : "object" == typeof f && f instanceof a
            ? (d.$object = f)
            : "object" == typeof f && c._helpers._isElement(f)
            ? (d.$object = a(f))
            : "object" == typeof f && null !== f
            ? (d.multiMix = f)
            : "boolean" != typeof f || f
            ? "function" == typeof f && (d.callback = f)
            : (d.multiMix = !1);
        }
        return c._execFilter("_parseInsertArgs", d, arguments);
      },
      _execAction: function (a, b, c) {
        var d = this,
          e = b ? "post" : "pre";
        if (!d._actions.isEmptyObject && d._actions.hasOwnProperty(a))
          for (var f in d._actions[a][e]) d._actions[a][e][f].call(d, c);
      },
      _execFilter: function (a, b, c) {
        var d = this;
        if (d._filters.isEmptyObject || !d._filters.hasOwnProperty(a)) return b;
        for (var e in d._filters[a]) return d._filters[a][e].call(d, c);
      },
      _helpers: {
        _camelCase: function (a) {
          return a.replace(/-([a-z])/g, function (a) {
            return a[1].toUpperCase();
          });
        },
        _isElement: function (a) {
          return window.HTMLElement
            ? a instanceof HTMLElement
            : null !== a && 1 === a.nodeType && "string" === a.nodeName;
        },
      },
      isMixing: function () {
        var a = this;
        return a._execFilter("isMixing", a._mixing);
      },
      filter: function () {
        var a = this,
          b = a._parseMultiMixArgs(arguments);
        a._clicking && (a._toggleString = ""),
          a.multiMix(
            {
              filter: b.command,
            },
            b.animate,
            b.callback
          );
      },
      sort: function () {
        var a = this,
          b = a._parseMultiMixArgs(arguments);
        a.multiMix(
          {
            sort: b.command,
          },
          b.animate,
          b.callback
        );
      },
      changeLayout: function () {
        var a = this,
          b = a._parseMultiMixArgs(arguments);
        a.multiMix(
          {
            changeLayout: b.command,
          },
          b.animate,
          b.callback
        );
      },
      multiMix: function () {
        var a = this,
          c = a._parseMultiMixArgs(arguments);
        if ((a._execAction("multiMix", 0, arguments), a._mixing))
          a.animation.queue && a._queue.length < a.animation.queueLimit
            ? (a._queue.push(arguments),
              a.controls.enable && !a._clicking && a._updateControls(c.command),
              a._execAction("multiMixQueue", 1, arguments))
            : ("function" == typeof a.callbacks.onMixBusy &&
                a.callbacks.onMixBusy.call(a._domNode, a._state, a),
              a._$container.trigger("mixBusy", [a._state, a]),
              a._execAction("multiMixBusy", 1, arguments));
        else {
          a.controls.enable &&
            !a._clicking &&
            (a.controls.toggleFilterButtons && a._buildToggleArray(),
            a._updateControls(c.command, a.controls.toggleFilterButtons)),
            a._queue.length < 2 && (a._clicking = !1),
            delete a.callbacks._user,
            c.callback && (a.callbacks._user = c.callback);
          var d = c.command.sort,
            e = c.command.filter,
            f = c.command.changeLayout;
          a._refresh(),
            d &&
              ((a._newSort = a._parseSort(d)),
              (a._newSortString = d),
              (a._sorting = !0),
              a._sort()),
            e !== b &&
              ((e = "all" === e ? a.selectors.target : e),
              (a._activeFilter = e)),
            a._filter(),
            f &&
              ((a._newDisplay =
                "string" == typeof f ? f : f.display || a.layout.display),
              (a._newClass = f.containerClass || ""),
              (a._newDisplay !== a.layout.display ||
                a._newClass !== a.layout.containerClass) &&
                ((a._changingLayout = !0),
                (a._changingClass = a._newClass !== a.layout.containerClass),
                (a._changingDisplay = a._newDisplay !== a.layout.display))),
            a._$targets.css(a._brake),
            a._goMix(
              c.animate ^ a.animation.enable ? c.animate : a.animation.enable
            ),
            a._execAction("multiMix", 1, arguments);
        }
      },
      insert: function () {
        var a = this,
          b = a._parseInsertArgs(arguments),
          c = "function" == typeof b.callback ? b.callback : null,
          d = document.createDocumentFragment(),
          e = (function () {
            return (
              a._refresh(),
              a._$targets.length
                ? b.index < a._$targets.length || !a._$targets.length
                  ? a._$targets[b.index]
                  : a._$targets[a._$targets.length - 1].nextElementSibling
                : a._$parent[0].children[0]
            );
          })();
        if ((a._execAction("insert", 0, arguments), b.$object)) {
          for (var f = 0; f < b.$object.length; f++) {
            var g = b.$object[f];
            d.appendChild(g), d.appendChild(document.createTextNode(" "));
          }
          a._$parent[0].insertBefore(d, e);
        }
        a._execAction("insert", 1, arguments),
          "object" == typeof b.multiMix && a.multiMix(b.multiMix, c);
      },
      prepend: function () {
        var a = this,
          b = a._parseInsertArgs(arguments);
        a.insert(0, b.$object, b.multiMix, b.callback);
      },
      append: function () {
        var a = this,
          b = a._parseInsertArgs(arguments);
        a.insert(a._state.totalTargets, b.$object, b.multiMix, b.callback);
      },
      getOption: function (a) {
        var c = this,
          d = function (a, c) {
            for (
              var d = c.split("."),
                e = d.pop(),
                f = d.length,
                g = 1,
                h = d[0] || c;
              (a = a[h]) && f > g;

            )
              (h = d[g]), g++;
            return a !== b ? (a[e] !== b ? a[e] : a) : void 0;
          };
        return a ? c._execFilter("getOption", d(c, a), arguments) : c;
      },
      setOptions: function (b) {
        var c = this;
        c._execAction("setOptions", 0, arguments),
          "object" == typeof b && a.extend(!0, c, b),
          c._execAction("setOptions", 1, arguments);
      },
      getState: function () {
        var a = this;
        return a._execFilter("getState", a._state, a);
      },
      forceRefresh: function () {
        var a = this;
        a._refresh(!1, !0);
      },
      destroy: function (b) {
        var c = this,
          d = a.MixItUp.prototype._bound._filter,
          e = a.MixItUp.prototype._bound._sort;
        c._execAction("destroy", 0, arguments),
          c._$body
            .add(a(c.selectors.sort))
            .add(a(c.selectors.filter))
            .off(".mixItUp");
        for (var f = 0; f < c._$targets.length; f++) {
          var g = c._$targets[f];
          b && (g.style.display = ""), delete g.mixParent;
        }
        c._execAction("destroy", 1, arguments),
          d[c.selectors.filter] && d[c.selectors.filter] > 1
            ? d[c.selectors.filter]--
            : 1 === d[c.selectors.filter] && delete d[c.selectors.filter],
          e[c.selectors.sort] && e[c.selectors.sort] > 1
            ? e[c.selectors.sort]--
            : 1 === e[c.selectors.sort] && delete e[c.selectors.sort],
          delete a.MixItUp.prototype._instances[c._id];
      },
    }),
    (a.fn.mixItUp = function () {
      var c,
        d = arguments,
        e = [],
        f = function (b, c) {
          var d = new a.MixItUp(),
            e = function () {
              return ("00000" + ((16777216 * Math.random()) << 0).toString(16))
                .substr(-6)
                .toUpperCase();
            };
          d._execAction("_instantiate", 0, arguments),
            (b.id = b.id ? b.id : "MixItUp" + e()),
            d._instances[b.id] || ((d._instances[b.id] = d), d._init(b, c)),
            d._execAction("_instantiate", 1, arguments);
        };
      return (
        (c = this.each(function () {
          if (d && "string" == typeof d[0]) {
            var c = a.MixItUp.prototype._instances[this.id];
            if ("isLoaded" === d[0]) e.push(c ? !0 : !1);
            else {
              var g = c[d[0]](d[1], d[2], d[3]);
              g !== b && e.push(g);
            }
          } else f(this, d[0]);
        })),
        e.length ? (e.length > 1 ? e : e[0]) : c
      );
    }),
    (a.fn.removeStyle = function (c, d) {
      return (
        (d = d ? d : ""),
        this.each(function () {
          for (var e = this, f = c.split(" "), g = 0; g < f.length; g++)
            for (var h = 0; 4 > h; h++) {
              switch (h) {
                case 0:
                  var i = f[g];
                  break;
                case 1:
                  var i = a.MixItUp.prototype._helpers._camelCase(i);
                  break;
                case 2:
                  var i = d + f[g];
                  break;
                case 3:
                  var i = a.MixItUp.prototype._helpers._camelCase(d + f[g]);
              }
              if (
                (e.style[i] !== b &&
                  "unknown" != typeof e.style[i] &&
                  e.style[i].length > 0 &&
                  (e.style[i] = ""),
                !d && 1 === h)
              )
                break;
            }
          e.attributes &&
            e.attributes.style &&
            e.attributes.style !== b &&
            "" === e.attributes.style.value &&
            e.attributes.removeNamedItem("style");
        })
      );
    });
})(jQuery);

jQuery(document).on("click", ".scrollbtn", function () {
  var scrollID = jQuery(this).attr("data-scroll-id");
  $("html, body").animate(
    {
      scrollTop: $("#" + scrollID).offset().top,
    },
    1200
  );
});

//Countdown Timer

// $(document).ready(function () {
// const second = document.getElementById("second");
// const minute = document.getElementById("minute");
// const hour = document.getElementById("hour");
// const day = document.getElementById("day");
// const wrapper = document.getElementById("wrapper");

// setInterval(function(){
//   let secondNum = +second.innerText;
//   let minuteNum = +minute.innerText;
//   let hourNum = +hour.innerText;
//   let dayNum = +day.innerText;

//   second.innerText = secondNum - 1;

//   if(second.innerText == -1){
//     second.innerText = 59;
//     minute.innerText = minuteNum - 1;
//   }

//   if(minute.innerText == -1){
//     minute.innerText = 59;
//     hour.innerText = hourNum - 1;
//   }

//   if(hour.innerText == -1){
//     hour.innerText = 23;
//     day.innerText = dayNum - 1;
//   }

// }, 1000)

// });

// NEW SHOP PAGE PRODUCT FILTER TABBING
$(document).ready(function () {
  var $btns = $(".btn").click(function () {
    if (this.id == "all") {
      $("#parent > div").fadeIn(450);
    } else {
      var $el = $("." + this.id).fadeIn(450);
      $("#parent > div").not($el).hide();
    }
    $btns.removeClass("active");
    $(this).addClass("active");
  });
});

// $(document).ready(function () {
//     $(".header-product-list a").click(function () {
//       console.log($(this).attr('href'));
//        location.replace($(this).attr('href'));
//       location.reload(true);
//     });
// });

// scroll
$(".medium-dark-roast-btn").click(function () {
  $("#b").addClass("active");
  $("#b").trigger("click");
  $("html, body").animate(
    {
      scrollTop: $($(this).attr("href")).offset().top - 200,
    },
    500
  );
  return false;
});

$(".medium-rost-btn").click(function () {
  $("#c").addClass("active");
  $("#c").trigger("click");
  $("html, body").animate(
    {
      scrollTop: $($(this).attr("href")).offset().top - 200,
    },
    500
  );
  return false;
});

$(".shop-top-selleter-btn").click(function () {
  $("#all").addClass("active");
  $("#all").trigger("click");
  $("html, body").animate(
    {
      scrollTop: $($(this).attr("href")).offset().top - 200,
    },
    500
  );
  return false;
});

$(".try-kona-sampler-btn, .card-sampler-btn").click(function () {
  $("#a").addClass("active");
  $("#a").trigger("click");
  $("html, body").animate(
    {
      scrollTop: $($(this).attr("href")).offset().top - 200,
    },
    500
  );
  return false;
});

/* commented it on july 1st to stop scrolling off  header bar...*/
$(document).ready(function () {
   gsap.utils.toArray("#free-shipping-barbottom").forEach((line, i) => {
      const links = line.querySelectorAll("p"),
        tl = horizontalLoop(links, {
          repeat: -1,
          speed: 1 + i * 0.5,
          paddingRight: parseFloat(
            gsap.getProperty(links[0], "marginRight", "px")
          ), // otherwise first element would be right up against the last when it loops. In this layout, the spacing is done with marginRight.
        });
      links.forEach((link) => {
        link.addEventListener("mouseenter", () => tl.pause());
        link.addEventListener("mouseleave", () => tl.resume());
      });
    });
   if ($(window).width() < 575) {
     gsap.utils.toArray(".mobile-site-header-label").forEach((line, i) => {
     const links = line.querySelectorAll("p"),
       tl = horizontalLoop(links, {
         repeat: -1,
         speed: 1 + i * 0.5,
         paddingRight: parseFloat(
           gsap.getProperty(links[0], "marginRight", "px")
         ), // otherwise first element would be right up against the last when it loops. In this layout, the spacing is done with marginRight.
       });
     links.forEach((link) => {
       link.addEventListener("mouseenter", () => tl.pause());
       link.addEventListener("mouseleave", () => tl.resume());
     });
   });
   }else{
    // gsap.utils.toArray(".free-shipping-bar").forEach((line, i) => {
    //   const links = line.querySelectorAll("p"),
    //     tl = horizontalLoop(links, {
    //       repeat: -1,
    //       speed: 1 + i * 0.5,
    //       paddingRight: parseFloat(
    //         gsap.getProperty(links[0], "marginRight", "px")
    //       ), // otherwise first element would be right up against the last when it loops. In this layout, the spacing is done with marginRight.
    //     });
    //   links.forEach((link) => {
    //     link.addEventListener("mouseenter", () => tl.pause());
    //     link.addEventListener("mouseleave", () => tl.resume());
    //   });
    // });
}
    function horizontalLoop(items, config) {
      items = gsap.utils.toArray(items);
      config = config || {};
      let tl = gsap.timeline({
          repeat: config.repeat,
          paused: config.paused,
          defaults: { ease: "none" },
        }),
        length = items.length,
        startX = items[0].offsetLeft,
        times = [],
        widths = [],
        xPercents = [],
        curIndex = 0,
        pixelsPerSecond = (config.speed || 1) * 50,
        snap =
          config.snap === false ? (v) => v : gsap.utils.snap(config.snap || 1), // some browsers shift by a pixel to accommodate flex layouts, so for example if width is 20% the first element's width might be 242px, and the next 243px, alternating back and forth. So we snap to 5 percentage points to make things look more natural
        totalWidth,
        curX,
        distanceToStart,
        distanceToLoop,
        item,
        i;
      gsap.set(items, {
        // convert "x" to "xPercent" to make things responsive, and populate the widths/xPercents Arrays to make lookups faster.
        xPercent: (i, el) => {
          let w = (widths[i] = parseFloat(gsap.getProperty(el, "width", "px")));
          xPercents[i] = snap(
            (parseFloat(gsap.getProperty(el, "x", "px")) / w) * 100 +
              gsap.getProperty(el, "xPercent")
          );
          return xPercents[i];
        },
      });
      gsap.set(items, { x: 0 });
      totalWidth =
        items[length - 1].offsetLeft +
        (xPercents[length - 1] / 100) * widths[length - 1] -
        startX +
        items[length - 1].offsetWidth *
          gsap.getProperty(items[length - 1], "scaleX") +
        (parseFloat(config.paddingRight) || 0);
      for (i = 0; i < length; i++) {
        item = items[i];
        curX = (xPercents[i] / 100) * widths[i];
        distanceToStart = item.offsetLeft + curX - startX;
        distanceToLoop =
          distanceToStart + widths[i] * gsap.getProperty(item, "scaleX");
        tl.to(
          item,
          {
            xPercent: snap(((curX - distanceToLoop) / widths[i]) * 100),
            duration: distanceToLoop / pixelsPerSecond,
          },
          0
        )
          .fromTo(
            item,
            {
              xPercent: snap(
                ((curX - distanceToLoop + totalWidth) / widths[i]) * 100
              ),
            },
            {
              xPercent: xPercents[i],
              duration:
                (curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond,
              immediateRender: false,
            },
            distanceToLoop / pixelsPerSecond
          )
          .add("label" + i, distanceToStart / pixelsPerSecond);
        times[i] = distanceToStart / pixelsPerSecond;
      }
      function toIndex(index, vars) {
        vars = vars || {};
        Math.abs(index - curIndex) > length / 2 &&
          (index += index > curIndex ? -length : length); // always go in the shortest direction
        let newIndex = gsap.utils.wrap(0, length, index),
          time = times[newIndex];
        if (time > tl.time() !== index > curIndex) {
          // if we're wrapping the timeline's playhead, make the proper adjustments
          vars.modifiers = { time: gsap.utils.wrap(0, tl.duration()) };
          time += tl.duration() * (index > curIndex ? 1 : -1);
        }
        curIndex = newIndex;
        vars.overwrite = true;
        return tl.tweenTo(time, vars);
      }
      tl.next = (vars) => toIndex(curIndex + 1, vars);
      tl.previous = (vars) => toIndex(curIndex - 1, vars);
      tl.current = () => curIndex;
      tl.toIndex = (index, vars) => toIndex(index, vars);
      tl.times = times;
      return tl;
    }

});



// PRODUCT FAQ
document.addEventListener('DOMContentLoaded', () => {
    const tabs = document.querySelectorAll('.products-faq-list h2');
    const contents = document.querySelectorAll('.products-faq-list-body');

    for (let i = 0; i < tabs.length; i++) {
        tabs[i].addEventListener('click', () => {
            const target = tabs[i].getAttribute('data-faq');
            const content = document.getElementById(target);

            // Check if the clicked tab is already active
            if (tabs[i].classList.contains('active')) {
                // Remove active class from the clicked tab and content
                tabs[i].classList.remove('active');
                content.classList.remove('active');
            } else {
                // Remove active class from all tabs and contents
                for (let j = 0; j < tabs.length; j++) {
                    tabs[j].classList.remove('active');
                    contents[j].classList.remove('active');
                }

                // Add active class to the clicked tab and corresponding content
                tabs[i].classList.add('active');
                content.classList.add('active');
            }
        });
    }
});



// PRODUCT PAGE BOTTOM FAQ
  const faqItems = document.querySelectorAll('.faq-item');

    faqItems.forEach(item => {
      const question = item.querySelector('.faq-question');
      const answer = item.querySelector('.faq-answer');
      const arrow = item.querySelector('.arrow');

      question.addEventListener('click', () => {
        const isOpen = answer.classList.contains('open');

        // Close all open answers
        document.querySelectorAll('.faq-answer').forEach(a => a.classList.remove('open'));
        document.querySelectorAll('.faq-question').forEach(a => a.classList.remove('open'));

        // Toggle current item
        if (!isOpen) {
          answer.classList.add('open');
          question.classList.add('open');
        }
      });
    });




// PRODUCT QTY
document.addEventListener('DOMContentLoaded', function() {
  const qtyContainers = document.querySelectorAll('.qty-container');

  qtyContainers.forEach(container => {
    const minusBtn = container.querySelector('.qty-btn-minus');
    const plusBtn = container.querySelector('.qty-btn-plus');
    const qtyInput = container.querySelector('.input-qty');

    // Disable minus button initially
    minusBtn.disabled = true;
    minusBtn.classList.add('disabled');

    minusBtn.addEventListener('click', function() {
      let qty = parseInt(qtyInput.value);
      if (qty > 1) {
        qtyInput.value = qty - 1;
        if (qtyInput.value == 1) {
          minusBtn.disabled = true;
          minusBtn.classList.add('disabled');
        }
      }
    });

    plusBtn.addEventListener('click', function() {
      let qty = parseInt(qtyInput.value);
      qtyInput.value = qty + 1;
      if (qtyInput.value > 1) {
        minusBtn.disabled = false;
        minusBtn.classList.remove('disabled');
      }
    });

    qtyInput.addEventListener('change', function() {
      if (qtyInput.value < 1) {
        qtyInput.value = 1;
      }
      if (qtyInput.value == 1) {
        minusBtn.disabled = true;
        minusBtn.classList.add('disabled');
      } else {
        minusBtn.disabled = false;
        minusBtn.classList.remove('disabled');
      }
    });
  });
});



// product new slider
$(window).on('load', function(){
    $('.product-new-slider-wrap').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      infinite: false,
      speed: 1000,
      asNavFor: '.product-new-thump-slider-wrap',
      arrows: false,
      responsive: [
        {
          breakpoint: 575,
          settings: {
            dots: true,
            arrows: true,
          }
        }
      ]
    });
    $('.product-new-thump-slider-wrap').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: '.product-new-slider-wrap',
      dots: false,
      centerMode: false,
      arrows: false,
      focusOnSelect: true
    });
});


$(window).on('load', function(){
  if($('.tour-choose-package-slider').length > 0) {
    $('.tour-choose-package-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      fade: false,
      dots: false,
      infinite: true,
      speed: 700,
      responsive: [
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 2,
          }
        },
         {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    });
  }

  // if($('.tdn-testimonials-slider').length > 0) {
  //   $('.tdn-testimonials-slider').slick({
  //       slidesToShow: 1,
  //       slidesToScroll: 1,
  //       arrows: true,
  //       fade: false,
  //       dots: false,
  //       infinite: true,
  //       speed: 700
  //     });
  // }


   $(".hero-chat-badge").click(function () {
      $('.hero-chat-modal').addClass("active");
      $('body').addClass("hero-chat-badge-active");
  });
   $(".chatmodal-close").click(function () {
      $('.hero-chat-modal').removeClass("active");
      $('body').removeClass("hero-chat-badge-active");
  });

   $(".tour-demo-new-header-bar, .menu-bar").click(function () {
      $('.menu-side').addClass("active");
      $('body').addClass("tour-demo-new-body-active");
      $('.menu').removeClass("on");
  });
   $(".menu-side .close").click(function () {
      $('.menu-side').removeClass("active");
       $('body').removeClass("tour-demo-new-body-active");
       $('body').removeClass("open-menu");
  });


});



// RELATED PRODUCTS SLIDER
    $(window).on('load', function() {
      if($(window).width() < 1023) {
              if ($('.related-block .product-wrapper .row').length) {
                  $('.related-block .product-wrapper .row').slick({
                      dots: true,
                      arrows: false,
                      infinite: true,
                      slidesToShow: 2,
                      slidesToScroll: 1,
                      autoplay:true,
                      speed: 1000,
                      responsive: [
                          {
                          breakpoint: 575,
                          settings: {
                              slidesToShow: 1,
                              slidesToScroll: 1
                          }
                          }
      
                      ]
                  });
              }
      }
    });


// product new slider
$(window).on('load', function(){
    $('.product-new-slider-wrap').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      infinite: false,
      speed: 1000,
      asNavFor: '.product-new-thump-slider-wrap',
      arrows: false,
      responsive: [
        {
          breakpoint: 575,
          settings: {
            dots: true,
            arrows: true,
          }
        }
      ]
    });
    $('.product-new-thump-slider-wrap').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: '.product-new-slider-wrap',
      dots: false,
      centerMode: false,
      arrows: false,
      focusOnSelect: true
    });



  $('.demo-tour-category_left').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: false,
      infinite: true,
      speed: 1000,
      autoplay: true,
      autoplaySpeed: 2000,
      pauseOnHover: false,
      pauseOnFocus: false,
    });
});

$(window).on('load', function(){
    $(document).on('click', '.address-edit-toggle', function () {
        $('html, body').animate({
            scrollTop: $('.address-edit-toggle').offset().top
        }, 'slow');
    });
});


$(document).on('click', '.add-new-address-btn', function () {
    $('#AddressNewForm').addClass('active');
});
$(document).on('click', '.address-new-toggle', function () {
    $('#AddressNewForm').removeClass('active');
});

// $(document).on('click', '.address-edit-toggle', function () {
//     $('.address-edit-toggle').animate({ scrollTop: 0 }, 'slow');
// });

// ==================================================
// fancyBox v3.5.7
//
// Licensed GPLv3 for open source use
// or fancyBox Commercial License for commercial use
//
// http://fancyapps.com/fancybox/
// Copyright 2019 fancyApps
//
// ==================================================
!function(t,e,n,o){"use strict";function i(t,e){var o,i,a,s=[],r=0;t&&t.isDefaultPrevented()||(t.preventDefault(),e=e||{},t&&t.data&&(e=h(t.data.options,e)),o=e.$target||n(t.currentTarget).trigger("blur"),(a=n.fancybox.getInstance())&&a.$trigger&&a.$trigger.is(o)||(e.selector?s=n(e.selector):(i=o.attr("data-fancybox")||"",i?(s=t.data?t.data.items:[],s=s.length?s.filter('[data-fancybox="'+i+'"]'):n('[data-fancybox="'+i+'"]')):s=[o]),r=n(s).index(o),r<0&&(r=0),a=n.fancybox.open(s,e,r),a.$trigger=o))}if(t.console=t.console||{info:function(t){}},n){if(n.fn.fancybox)return void console.info("fancyBox already initialized");var a={closeExisting:!1,loop:!1,gutter:50,keyboard:!0,preventCaptionOverlap:!0,arrows:!0,infobar:!0,smallBtn:"auto",toolbar:"auto",buttons:["zoom","slideShow","thumbs","close"],idleTime:3,protect:!1,modal:!1,image:{preload:!1},ajax:{settings:{data:{fancybox:!0}}},iframe:{tpl:'<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" allowfullscreen="allowfullscreen" allow="autoplay; fullscreen" src=""></iframe>',preload:!0,css:{},attr:{scrolling:"auto"}},video:{tpl:'<video class="fancybox-video" controls controlsList="nodownload" poster="{{poster}}"><source src="{{src}}" type="{{format}}" />Sorry, your browser doesn\'t support embedded videos, <a href="{{src}}">download</a> and watch with your favorite video player!</video>',format:"",autoStart:!0},defaultType:"image",animationEffect:"zoom",animationDuration:366,zoomOpacity:"auto",transitionEffect:"fade",transitionDuration:366,slideClass:"",baseClass:"",baseTpl:'<div class="fancybox-container" role="dialog" tabindex="-1"><div class="fancybox-bg"></div><div class="fancybox-inner"><div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div><div class="fancybox-toolbar">{{buttons}}</div><div class="fancybox-navigation">{{arrows}}</div><div class="fancybox-stage"></div><div class="fancybox-caption"><div class="fancybox-caption__body"></div></div></div></div>',spinnerTpl:'<div class="fancybox-loading"></div>',errorTpl:'<div class="fancybox-error"><p>{{ERROR}}</p></div>',btnTpl:{download:'<a download data-fancybox-download class="fancybox-button fancybox-button--download" title="{{DOWNLOAD}}" href="javascript:;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.62 17.09V19H5.38v-1.91zm-2.97-6.96L17 11.45l-5 4.87-5-4.87 1.36-1.32 2.68 2.64V5h1.92v7.77z"/></svg></a>',zoom:'<button data-fancybox-zoom class="fancybox-button fancybox-button--zoom" title="{{ZOOM}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.7 17.3l-3-3a5.9 5.9 0 0 0-.6-7.6 5.9 5.9 0 0 0-8.4 0 5.9 5.9 0 0 0 0 8.4 5.9 5.9 0 0 0 7.7.7l3 3a1 1 0 0 0 1.3 0c.4-.5.4-1 0-1.5zM8.1 13.8a4 4 0 0 1 0-5.7 4 4 0 0 1 5.7 0 4 4 0 0 1 0 5.7 4 4 0 0 1-5.7 0z"/></svg></button>',close:'<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"/></svg></button>',arrowLeft:'<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.28 15.7l-1.34 1.37L5 12l4.94-5.07 1.34 1.38-2.68 2.72H19v1.94H8.6z"/></svg></div></button>',arrowRight:'<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.4 12.97l-2.68 2.72 1.34 1.38L19 12l-4.94-5.07-1.34 1.38 2.68 2.72H5v1.94z"/></svg></div></button>',smallBtn:'<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"/></svg></button>'},parentEl:"body",hideScrollbar:!0,autoFocus:!0,backFocus:!0,trapFocus:!0,fullScreen:{autoStart:!1},touch:{vertical:!0,momentum:!0},hash:null,media:{},slideShow:{autoStart:!1,speed:3e3},thumbs:{autoStart:!1,hideOnClose:!0,parentEl:".fancybox-container",axis:"y"},wheel:"auto",onInit:n.noop,beforeLoad:n.noop,afterLoad:n.noop,beforeShow:n.noop,afterShow:n.noop,beforeClose:n.noop,afterClose:n.noop,onActivate:n.noop,onDeactivate:n.noop,clickContent:function(t,e){return"image"===t.type&&"zoom"},clickSlide:"close",clickOutside:"close",dblclickContent:!1,dblclickSlide:!1,dblclickOutside:!1,mobile:{preventCaptionOverlap:!1,idleTime:!1,clickContent:function(t,e){return"image"===t.type&&"toggleControls"},clickSlide:function(t,e){return"image"===t.type?"toggleControls":"close"},dblclickContent:function(t,e){return"image"===t.type&&"zoom"},dblclickSlide:function(t,e){return"image"===t.type&&"zoom"}},lang:"en",i18n:{en:{CLOSE:"Close",NEXT:"Next",PREV:"Previous",ERROR:"The requested content cannot be loaded. <br/> Please try again later.",PLAY_START:"Start slideshow",PLAY_STOP:"Pause slideshow",FULL_SCREEN:"Full screen",THUMBS:"Thumbnails",DOWNLOAD:"Download",SHARE:"Share",ZOOM:"Zoom"},de:{CLOSE:"Schlie&szlig;en",NEXT:"Weiter",PREV:"Zur&uuml;ck",ERROR:"Die angeforderten Daten konnten nicht geladen werden. <br/> Bitte versuchen Sie es sp&auml;ter nochmal.",PLAY_START:"Diaschau starten",PLAY_STOP:"Diaschau beenden",FULL_SCREEN:"Vollbild",THUMBS:"Vorschaubilder",DOWNLOAD:"Herunterladen",SHARE:"Teilen",ZOOM:"Vergr&ouml;&szlig;ern"}}},s=n(t),r=n(e),c=0,l=function(t){return t&&t.hasOwnProperty&&t instanceof n},d=function(){return t.requestAnimationFrame||t.webkitRequestAnimationFrame||t.mozRequestAnimationFrame||t.oRequestAnimationFrame||function(e){return t.setTimeout(e,1e3/60)}}(),u=function(){return t.cancelAnimationFrame||t.webkitCancelAnimationFrame||t.mozCancelAnimationFrame||t.oCancelAnimationFrame||function(e){t.clearTimeout(e)}}(),f=function(){var t,n=e.createElement("fakeelement"),o={transition:"transitionend",OTransition:"oTransitionEnd",MozTransition:"transitionend",WebkitTransition:"webkitTransitionEnd"};for(t in o)if(void 0!==n.style[t])return o[t];return"transitionend"}(),p=function(t){return t&&t.length&&t[0].offsetHeight},h=function(t,e){var o=n.extend(!0,{},t,e);return n.each(e,function(t,e){n.isArray(e)&&(o[t]=e)}),o},g=function(t){var o,i;return!(!t||t.ownerDocument!==e)&&(n(".fancybox-container").css("pointer-events","none"),o={x:t.getBoundingClientRect().left+t.offsetWidth/2,y:t.getBoundingClientRect().top+t.offsetHeight/2},i=e.elementFromPoint(o.x,o.y)===t,n(".fancybox-container").css("pointer-events",""),i)},b=function(t,e,o){var i=this;i.opts=h({index:o},n.fancybox.defaults),n.isPlainObject(e)&&(i.opts=h(i.opts,e)),n.fancybox.isMobile&&(i.opts=h(i.opts,i.opts.mobile)),i.id=i.opts.id||++c,i.currIndex=parseInt(i.opts.index,10)||0,i.prevIndex=null,i.prevPos=null,i.currPos=0,i.firstRun=!0,i.group=[],i.slides={},i.addContent(t),i.group.length&&i.init()};n.extend(b.prototype,{init:function(){var o,i,a=this,s=a.group[a.currIndex],r=s.opts;r.closeExisting&&n.fancybox.close(!0),n("body").addClass("fancybox-active"),!n.fancybox.getInstance()&&!1!==r.hideScrollbar&&!n.fancybox.isMobile&&e.body.scrollHeight>t.innerHeight&&(n("head").append('<style id="fancybox-style-noscroll" type="text/css">.compensate-for-scrollbar{margin-right:'+(t.innerWidth-e.documentElement.clientWidth)+"px;}</style>"),n("body").addClass("compensate-for-scrollbar")),i="",n.each(r.buttons,function(t,e){i+=r.btnTpl[e]||""}),o=n(a.translate(a,r.baseTpl.replace("{{buttons}}",i).replace("{{arrows}}",r.btnTpl.arrowLeft+r.btnTpl.arrowRight))).attr("id","fancybox-container-"+a.id).addClass(r.baseClass).data("FancyBox",a).appendTo(r.parentEl),a.$refs={container:o},["bg","inner","infobar","toolbar","stage","caption","navigation"].forEach(function(t){a.$refs[t]=o.find(".fancybox-"+t)}),a.trigger("onInit"),a.activate(),a.jumpTo(a.currIndex)},translate:function(t,e){var n=t.opts.i18n[t.opts.lang]||t.opts.i18n.en;return e.replace(/\{\{(\w+)\}\}/g,function(t,e){return void 0===n[e]?t:n[e]})},addContent:function(t){var e,o=this,i=n.makeArray(t);n.each(i,function(t,e){var i,a,s,r,c,l={},d={};n.isPlainObject(e)?(l=e,d=e.opts||e):"object"===n.type(e)&&n(e).length?(i=n(e),d=i.data()||{},d=n.extend(!0,{},d,d.options),d.$orig=i,l.src=o.opts.src||d.src||i.attr("href"),l.type||l.src||(l.type="inline",l.src=e)):l={type:"html",src:e+""},l.opts=n.extend(!0,{},o.opts,d),n.isArray(d.buttons)&&(l.opts.buttons=d.buttons),n.fancybox.isMobile&&l.opts.mobile&&(l.opts=h(l.opts,l.opts.mobile)),a=l.type||l.opts.type,r=l.src||"",!a&&r&&((s=r.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i))?(a="video",l.opts.video.format||(l.opts.video.format="video/"+("ogv"===s[1]?"ogg":s[1]))):r.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i)?a="image":r.match(/\.(pdf)((\?|#).*)?$/i)?(a="iframe",l=n.extend(!0,l,{contentType:"pdf",opts:{iframe:{preload:!1}}})):"#"===r.charAt(0)&&(a="inline")),a?l.type=a:o.trigger("objectNeedsType",l),l.contentType||(l.contentType=n.inArray(l.type,["html","inline","ajax"])>-1?"html":l.type),l.index=o.group.length,"auto"==l.opts.smallBtn&&(l.opts.smallBtn=n.inArray(l.type,["html","inline","ajax"])>-1),"auto"===l.opts.toolbar&&(l.opts.toolbar=!l.opts.smallBtn),l.$thumb=l.opts.$thumb||null,l.opts.$trigger&&l.index===o.opts.index&&(l.$thumb=l.opts.$trigger.find("img:first"),l.$thumb.length&&(l.opts.$orig=l.opts.$trigger)),l.$thumb&&l.$thumb.length||!l.opts.$orig||(l.$thumb=l.opts.$orig.find("img:first")),l.$thumb&&!l.$thumb.length&&(l.$thumb=null),l.thumb=l.opts.thumb||(l.$thumb?l.$thumb[0].src:null),"function"===n.type(l.opts.caption)&&(l.opts.caption=l.opts.caption.apply(e,[o,l])),"function"===n.type(o.opts.caption)&&(l.opts.caption=o.opts.caption.apply(e,[o,l])),l.opts.caption instanceof n||(l.opts.caption=void 0===l.opts.caption?"":l.opts.caption+""),"ajax"===l.type&&(c=r.split(/\s+/,2),c.length>1&&(l.src=c.shift(),l.opts.filter=c.shift())),l.opts.modal&&(l.opts=n.extend(!0,l.opts,{trapFocus:!0,infobar:0,toolbar:0,smallBtn:0,keyboard:0,slideShow:0,fullScreen:0,thumbs:0,touch:0,clickContent:!1,clickSlide:!1,clickOutside:!1,dblclickContent:!1,dblclickSlide:!1,dblclickOutside:!1})),o.group.push(l)}),Object.keys(o.slides).length&&(o.updateControls(),(e=o.Thumbs)&&e.isActive&&(e.create(),e.focus()))},addEvents:function(){var e=this;e.removeEvents(),e.$refs.container.on("click.fb-close","[data-fancybox-close]",function(t){t.stopPropagation(),t.preventDefault(),e.close(t)}).on("touchstart.fb-prev click.fb-prev","[data-fancybox-prev]",function(t){t.stopPropagation(),t.preventDefault(),e.previous()}).on("touchstart.fb-next click.fb-next","[data-fancybox-next]",function(t){t.stopPropagation(),t.preventDefault(),e.next()}).on("click.fb","[data-fancybox-zoom]",function(t){e[e.isScaledDown()?"scaleToActual":"scaleToFit"]()}),s.on("orientationchange.fb resize.fb",function(t){t&&t.originalEvent&&"resize"===t.originalEvent.type?(e.requestId&&u(e.requestId),e.requestId=d(function(){e.update(t)})):(e.current&&"iframe"===e.current.type&&e.$refs.stage.hide(),setTimeout(function(){e.$refs.stage.show(),e.update(t)},n.fancybox.isMobile?600:250))}),r.on("keydown.fb",function(t){var o=n.fancybox?n.fancybox.getInstance():null,i=o.current,a=t.keyCode||t.which;if(9==a)return void(i.opts.trapFocus&&e.focus(t));if(!(!i.opts.keyboard||t.ctrlKey||t.altKey||t.shiftKey||n(t.target).is("input,textarea,video,audio,select")))return 8===a||27===a?(t.preventDefault(),void e.close(t)):37===a||38===a?(t.preventDefault(),void e.previous()):39===a||40===a?(t.preventDefault(),void e.next()):void e.trigger("afterKeydown",t,a)}),e.group[e.currIndex].opts.idleTime&&(e.idleSecondsCounter=0,r.on("mousemove.fb-idle mouseleave.fb-idle mousedown.fb-idle touchstart.fb-idle touchmove.fb-idle scroll.fb-idle keydown.fb-idle",function(t){e.idleSecondsCounter=0,e.isIdle&&e.showControls(),e.isIdle=!1}),e.idleInterval=t.setInterval(function(){++e.idleSecondsCounter>=e.group[e.currIndex].opts.idleTime&&!e.isDragging&&(e.isIdle=!0,e.idleSecondsCounter=0,e.hideControls())},1e3))},removeEvents:function(){var e=this;s.off("orientationchange.fb resize.fb"),r.off("keydown.fb .fb-idle"),this.$refs.container.off(".fb-close .fb-prev .fb-next"),e.idleInterval&&(t.clearInterval(e.idleInterval),e.idleInterval=null)},previous:function(t){return this.jumpTo(this.currPos-1,t)},next:function(t){return this.jumpTo(this.currPos+1,t)},jumpTo:function(t,e){var o,i,a,s,r,c,l,d,u,f=this,h=f.group.length;if(!(f.isDragging||f.isClosing||f.isAnimating&&f.firstRun)){if(t=parseInt(t,10),!(a=f.current?f.current.opts.loop:f.opts.loop)&&(t<0||t>=h))return!1;if(o=f.firstRun=!Object.keys(f.slides).length,r=f.current,f.prevIndex=f.currIndex,f.prevPos=f.currPos,s=f.createSlide(t),h>1&&((a||s.index<h-1)&&f.createSlide(t+1),(a||s.index>0)&&f.createSlide(t-1)),f.current=s,f.currIndex=s.index,f.currPos=s.pos,f.trigger("beforeShow",o),f.updateControls(),s.forcedDuration=void 0,n.isNumeric(e)?s.forcedDuration=e:e=s.opts[o?"animationDuration":"transitionDuration"],e=parseInt(e,10),i=f.isMoved(s),s.$slide.addClass("fancybox-slide--current"),o)return s.opts.animationEffect&&e&&f.$refs.container.css("transition-duration",e+"ms"),f.$refs.container.addClass("fancybox-is-open").trigger("focus"),f.loadSlide(s),void f.preload("image");c=n.fancybox.getTranslate(r.$slide),l=n.fancybox.getTranslate(f.$refs.stage),n.each(f.slides,function(t,e){n.fancybox.stop(e.$slide,!0)}),r.pos!==s.pos&&(r.isComplete=!1),r.$slide.removeClass("fancybox-slide--complete fancybox-slide--current"),i?(u=c.left-(r.pos*c.width+r.pos*r.opts.gutter),n.each(f.slides,function(t,o){o.$slide.removeClass("fancybox-animated").removeClass(function(t,e){return(e.match(/(^|\s)fancybox-fx-\S+/g)||[]).join(" ")});var i=o.pos*c.width+o.pos*o.opts.gutter;n.fancybox.setTranslate(o.$slide,{top:0,left:i-l.left+u}),o.pos!==s.pos&&o.$slide.addClass("fancybox-slide--"+(o.pos>s.pos?"next":"previous")),p(o.$slide),n.fancybox.animate(o.$slide,{top:0,left:(o.pos-s.pos)*c.width+(o.pos-s.pos)*o.opts.gutter},e,function(){o.$slide.css({transform:"",opacity:""}).removeClass("fancybox-slide--next fancybox-slide--previous"),o.pos===f.currPos&&f.complete()})})):e&&s.opts.transitionEffect&&(d="fancybox-animated fancybox-fx-"+s.opts.transitionEffect,r.$slide.addClass("fancybox-slide--"+(r.pos>s.pos?"next":"previous")),n.fancybox.animate(r.$slide,d,e,function(){r.$slide.removeClass(d).removeClass("fancybox-slide--next fancybox-slide--previous")},!1)),s.isLoaded?f.revealContent(s):f.loadSlide(s),f.preload("image")}},createSlide:function(t){var e,o,i=this;return o=t%i.group.length,o=o<0?i.group.length+o:o,!i.slides[t]&&i.group[o]&&(e=n('<div class="fancybox-slide"></div>').appendTo(i.$refs.stage),i.slides[t]=n.extend(!0,{},i.group[o],{pos:t,$slide:e,isLoaded:!1}),i.updateSlide(i.slides[t])),i.slides[t]},scaleToActual:function(t,e,o){var i,a,s,r,c,l=this,d=l.current,u=d.$content,f=n.fancybox.getTranslate(d.$slide).width,p=n.fancybox.getTranslate(d.$slide).height,h=d.width,g=d.height;l.isAnimating||l.isMoved()||!u||"image"!=d.type||!d.isLoaded||d.hasError||(l.isAnimating=!0,n.fancybox.stop(u),t=void 0===t?.5*f:t,e=void 0===e?.5*p:e,i=n.fancybox.getTranslate(u),i.top-=n.fancybox.getTranslate(d.$slide).top,i.left-=n.fancybox.getTranslate(d.$slide).left,r=h/i.width,c=g/i.height,a=.5*f-.5*h,s=.5*p-.5*g,h>f&&(a=i.left*r-(t*r-t),a>0&&(a=0),a<f-h&&(a=f-h)),g>p&&(s=i.top*c-(e*c-e),s>0&&(s=0),s<p-g&&(s=p-g)),l.updateCursor(h,g),n.fancybox.animate(u,{top:s,left:a,scaleX:r,scaleY:c},o||366,function(){l.isAnimating=!1}),l.SlideShow&&l.SlideShow.isActive&&l.SlideShow.stop())},scaleToFit:function(t){var e,o=this,i=o.current,a=i.$content;o.isAnimating||o.isMoved()||!a||"image"!=i.type||!i.isLoaded||i.hasError||(o.isAnimating=!0,n.fancybox.stop(a),e=o.getFitPos(i),o.updateCursor(e.width,e.height),n.fancybox.animate(a,{top:e.top,left:e.left,scaleX:e.width/a.width(),scaleY:e.height/a.height()},t||366,function(){o.isAnimating=!1}))},getFitPos:function(t){var e,o,i,a,s=this,r=t.$content,c=t.$slide,l=t.width||t.opts.width,d=t.height||t.opts.height,u={};return!!(t.isLoaded&&r&&r.length)&&(e=n.fancybox.getTranslate(s.$refs.stage).width,o=n.fancybox.getTranslate(s.$refs.stage).height,e-=parseFloat(c.css("paddingLeft"))+parseFloat(c.css("paddingRight"))+parseFloat(r.css("marginLeft"))+parseFloat(r.css("marginRight")),o-=parseFloat(c.css("paddingTop"))+parseFloat(c.css("paddingBottom"))+parseFloat(r.css("marginTop"))+parseFloat(r.css("marginBottom")),l&&d||(l=e,d=o),i=Math.min(1,e/l,o/d),l*=i,d*=i,l>e-.5&&(l=e),d>o-.5&&(d=o),"image"===t.type?(u.top=Math.floor(.5*(o-d))+parseFloat(c.css("paddingTop")),u.left=Math.floor(.5*(e-l))+parseFloat(c.css("paddingLeft"))):"video"===t.contentType&&(a=t.opts.width&&t.opts.height?l/d:t.opts.ratio||16/9,d>l/a?d=l/a:l>d*a&&(l=d*a)),u.width=l,u.height=d,u)},update:function(t){var e=this;n.each(e.slides,function(n,o){e.updateSlide(o,t)})},updateSlide:function(t,e){var o=this,i=t&&t.$content,a=t.width||t.opts.width,s=t.height||t.opts.height,r=t.$slide;o.adjustCaption(t),i&&(a||s||"video"===t.contentType)&&!t.hasError&&(n.fancybox.stop(i),n.fancybox.setTranslate(i,o.getFitPos(t)),t.pos===o.currPos&&(o.isAnimating=!1,o.updateCursor())),o.adjustLayout(t),r.length&&(r.trigger("refresh"),t.pos===o.currPos&&o.$refs.toolbar.add(o.$refs.navigation.find(".fancybox-button--arrow_right")).toggleClass("compensate-for-scrollbar",r.get(0).scrollHeight>r.get(0).clientHeight)),o.trigger("onUpdate",t,e)},centerSlide:function(t){var e=this,o=e.current,i=o.$slide;!e.isClosing&&o&&(i.siblings().css({transform:"",opacity:""}),i.parent().children().removeClass("fancybox-slide--previous fancybox-slide--next"),n.fancybox.animate(i,{top:0,left:0,opacity:1},void 0===t?0:t,function(){i.css({transform:"",opacity:""}),o.isComplete||e.complete()},!1))},isMoved:function(t){var e,o,i=t||this.current;return!!i&&(o=n.fancybox.getTranslate(this.$refs.stage),e=n.fancybox.getTranslate(i.$slide),!i.$slide.hasClass("fancybox-animated")&&(Math.abs(e.top-o.top)>.5||Math.abs(e.left-o.left)>.5))},updateCursor:function(t,e){var o,i,a=this,s=a.current,r=a.$refs.container;s&&!a.isClosing&&a.Guestures&&(r.removeClass("fancybox-is-zoomable fancybox-can-zoomIn fancybox-can-zoomOut fancybox-can-swipe fancybox-can-pan"),o=a.canPan(t,e),i=!!o||a.isZoomable(),r.toggleClass("fancybox-is-zoomable",i),n("[data-fancybox-zoom]").prop("disabled",!i),o?r.addClass("fancybox-can-pan"):i&&("zoom"===s.opts.clickContent||n.isFunction(s.opts.clickContent)&&"zoom"==s.opts.clickContent(s))?r.addClass("fancybox-can-zoomIn"):s.opts.touch&&(s.opts.touch.vertical||a.group.length>1)&&"video"!==s.contentType&&r.addClass("fancybox-can-swipe"))},isZoomable:function(){var t,e=this,n=e.current;if(n&&!e.isClosing&&"image"===n.type&&!n.hasError){if(!n.isLoaded)return!0;if((t=e.getFitPos(n))&&(n.width>t.width||n.height>t.height))return!0}return!1},isScaledDown:function(t,e){var o=this,i=!1,a=o.current,s=a.$content;return void 0!==t&&void 0!==e?i=t<a.width&&e<a.height:s&&(i=n.fancybox.getTranslate(s),i=i.width<a.width&&i.height<a.height),i},canPan:function(t,e){var o=this,i=o.current,a=null,s=!1;return"image"===i.type&&(i.isComplete||t&&e)&&!i.hasError&&(s=o.getFitPos(i),void 0!==t&&void 0!==e?a={width:t,height:e}:i.isComplete&&(a=n.fancybox.getTranslate(i.$content)),a&&s&&(s=Math.abs(a.width-s.width)>1.5||Math.abs(a.height-s.height)>1.5)),s},loadSlide:function(t){var e,o,i,a=this;if(!t.isLoading&&!t.isLoaded){if(t.isLoading=!0,!1===a.trigger("beforeLoad",t))return t.isLoading=!1,!1;switch(e=t.type,o=t.$slide,o.off("refresh").trigger("onReset").addClass(t.opts.slideClass),e){case"image":a.setImage(t);break;case"iframe":a.setIframe(t);break;case"html":a.setContent(t,t.src||t.content);break;case"video":a.setContent(t,t.opts.video.tpl.replace(/\{\{src\}\}/gi,t.src).replace("{{format}}",t.opts.videoFormat||t.opts.video.format||"").replace("{{poster}}",t.thumb||""));break;case"inline":n(t.src).length?a.setContent(t,n(t.src)):a.setError(t);break;case"ajax":a.showLoading(t),i=n.ajax(n.extend({},t.opts.ajax.settings,{url:t.src,success:function(e,n){"success"===n&&a.setContent(t,e)},error:function(e,n){e&&"abort"!==n&&a.setError(t)}})),o.one("onReset",function(){i.abort()});break;default:a.setError(t)}return!0}},setImage:function(t){var o,i=this;setTimeout(function(){var e=t.$image;i.isClosing||!t.isLoading||e&&e.length&&e[0].complete||t.hasError||i.showLoading(t)},50),i.checkSrcset(t),t.$content=n('<div class="fancybox-content"></div>').addClass("fancybox-is-hidden").appendTo(t.$slide.addClass("fancybox-slide--image")),!1!==t.opts.preload&&t.opts.width&&t.opts.height&&t.thumb&&(t.width=t.opts.width,t.height=t.opts.height,o=e.createElement("img"),o.onerror=function(){n(this).remove(),t.$ghost=null},o.onload=function(){i.afterLoad(t)},t.$ghost=n(o).addClass("fancybox-image").appendTo(t.$content).attr("src",t.thumb)),i.setBigImage(t)},checkSrcset:function(e){var n,o,i,a,s=e.opts.srcset||e.opts.image.srcset;if(s){i=t.devicePixelRatio||1,a=t.innerWidth*i,o=s.split(",").map(function(t){var e={};return t.trim().split(/\s+/).forEach(function(t,n){var o=parseInt(t.substring(0,t.length-1),10);if(0===n)return e.url=t;o&&(e.value=o,e.postfix=t[t.length-1])}),e}),o.sort(function(t,e){return t.value-e.value});for(var r=0;r<o.length;r++){var c=o[r];if("w"===c.postfix&&c.value>=a||"x"===c.postfix&&c.value>=i){n=c;break}}!n&&o.length&&(n=o[o.length-1]),n&&(e.src=n.url,e.width&&e.height&&"w"==n.postfix&&(e.height=e.width/e.height*n.value,e.width=n.value),e.opts.srcset=s)}},setBigImage:function(t){var o=this,i=e.createElement("img"),a=n(i);t.$image=a.one("error",function(){o.setError(t)}).one("load",function(){var e;t.$ghost||(o.resolveImageSlideSize(t,this.naturalWidth,this.naturalHeight),o.afterLoad(t)),o.isClosing||(t.opts.srcset&&(e=t.opts.sizes,e&&"auto"!==e||(e=(t.width/t.height>1&&s.width()/s.height()>1?"100":Math.round(t.width/t.height*100))+"vw"),a.attr("sizes",e).attr("srcset",t.opts.srcset)),t.$ghost&&setTimeout(function(){t.$ghost&&!o.isClosing&&t.$ghost.hide()},Math.min(300,Math.max(1e3,t.height/1600))),o.hideLoading(t))}).addClass("fancybox-image").attr("src",t.src).appendTo(t.$content),(i.complete||"complete"==i.readyState)&&a.naturalWidth&&a.naturalHeight?a.trigger("load"):i.error&&a.trigger("error")},resolveImageSlideSize:function(t,e,n){var o=parseInt(t.opts.width,10),i=parseInt(t.opts.height,10);t.width=e,t.height=n,o>0&&(t.width=o,t.height=Math.floor(o*n/e)),i>0&&(t.width=Math.floor(i*e/n),t.height=i)},setIframe:function(t){var e,o=this,i=t.opts.iframe,a=t.$slide;t.$content=n('<div class="fancybox-content'+(i.preload?" fancybox-is-hidden":"")+'"></div>').css(i.css).appendTo(a),a.addClass("fancybox-slide--"+t.contentType),t.$iframe=e=n(i.tpl.replace(/\{rnd\}/g,(new Date).getTime())).attr(i.attr).appendTo(t.$content),i.preload?(o.showLoading(t),e.on("load.fb error.fb",function(e){this.isReady=1,t.$slide.trigger("refresh"),o.afterLoad(t)}),a.on("refresh.fb",function(){var n,o,s=t.$content,r=i.css.width,c=i.css.height;if(1===e[0].isReady){try{n=e.contents(),o=n.find("body")}catch(t){}o&&o.length&&o.children().length&&(a.css("overflow","visible"),s.css({width:"100%","max-width":"100%",height:"9999px"}),void 0===r&&(r=Math.ceil(Math.max(o[0].clientWidth,o.outerWidth(!0)))),s.css("width",r||"").css("max-width",""),void 0===c&&(c=Math.ceil(Math.max(o[0].clientHeight,o.outerHeight(!0)))),s.css("height",c||""),a.css("overflow","auto")),s.removeClass("fancybox-is-hidden")}})):o.afterLoad(t),e.attr("src",t.src),a.one("onReset",function(){try{n(this).find("iframe").hide().unbind().attr("src","//about:blank")}catch(t){}n(this).off("refresh.fb").empty(),t.isLoaded=!1,t.isRevealed=!1})},setContent:function(t,e){var o=this;o.isClosing||(o.hideLoading(t),t.$content&&n.fancybox.stop(t.$content),t.$slide.empty(),l(e)&&e.parent().length?((e.hasClass("fancybox-content")||e.parent().hasClass("fancybox-content"))&&e.parents(".fancybox-slide").trigger("onReset"),t.$placeholder=n("<div>").hide().insertAfter(e),e.css("display","inline-block")):t.hasError||("string"===n.type(e)&&(e=n("<div>").append(n.trim(e)).contents()),t.opts.filter&&(e=n("<div>").html(e).find(t.opts.filter))),t.$slide.one("onReset",function(){n(this).find("video,audio").trigger("pause"),t.$placeholder&&(t.$placeholder.after(e.removeClass("fancybox-content").hide()).remove(),t.$placeholder=null),t.$smallBtn&&(t.$smallBtn.remove(),t.$smallBtn=null),t.hasError||(n(this).empty(),t.isLoaded=!1,t.isRevealed=!1)}),n(e).appendTo(t.$slide),n(e).is("video,audio")&&(n(e).addClass("fancybox-video"),n(e).wrap("<div></div>"),t.contentType="video",t.opts.width=t.opts.width||n(e).attr("width"),t.opts.height=t.opts.height||n(e).attr("height")),t.$content=t.$slide.children().filter("div,form,main,video,audio,article,.fancybox-content").first(),t.$content.siblings().hide(),t.$content.length||(t.$content=t.$slide.wrapInner("<div></div>").children().first()),t.$content.addClass("fancybox-content"),t.$slide.addClass("fancybox-slide--"+t.contentType),o.afterLoad(t))},setError:function(t){t.hasError=!0,t.$slide.trigger("onReset").removeClass("fancybox-slide--"+t.contentType).addClass("fancybox-slide--error"),t.contentType="html",this.setContent(t,this.translate(t,t.opts.errorTpl)),t.pos===this.currPos&&(this.isAnimating=!1)},showLoading:function(t){var e=this;(t=t||e.current)&&!t.$spinner&&(t.$spinner=n(e.translate(e,e.opts.spinnerTpl)).appendTo(t.$slide).hide().fadeIn("fast"))},hideLoading:function(t){var e=this;(t=t||e.current)&&t.$spinner&&(t.$spinner.stop().remove(),delete t.$spinner)},afterLoad:function(t){var e=this;e.isClosing||(t.isLoading=!1,t.isLoaded=!0,e.trigger("afterLoad",t),e.hideLoading(t),!t.opts.smallBtn||t.$smallBtn&&t.$smallBtn.length||(t.$smallBtn=n(e.translate(t,t.opts.btnTpl.smallBtn)).appendTo(t.$content)),t.opts.protect&&t.$content&&!t.hasError&&(t.$content.on("contextmenu.fb",function(t){return 2==t.button&&t.preventDefault(),!0}),"image"===t.type&&n('<div class="fancybox-spaceball"></div>').appendTo(t.$content)),e.adjustCaption(t),e.adjustLayout(t),t.pos===e.currPos&&e.updateCursor(),e.revealContent(t))},adjustCaption:function(t){var e,n=this,o=t||n.current,i=o.opts.caption,a=o.opts.preventCaptionOverlap,s=n.$refs.caption,r=!1;s.toggleClass("fancybox-caption--separate",a),a&&i&&i.length&&(o.pos!==n.currPos?(e=s.clone().appendTo(s.parent()),e.children().eq(0).empty().html(i),r=e.outerHeight(!0),e.empty().remove()):n.$caption&&(r=n.$caption.outerHeight(!0)),o.$slide.css("padding-bottom",r||""))},adjustLayout:function(t){var e,n,o,i,a=this,s=t||a.current;s.isLoaded&&!0!==s.opts.disableLayoutFix&&(s.$content.css("margin-bottom",""),s.$content.outerHeight()>s.$slide.height()+.5&&(o=s.$slide[0].style["padding-bottom"],i=s.$slide.css("padding-bottom"),parseFloat(i)>0&&(e=s.$slide[0].scrollHeight,s.$slide.css("padding-bottom",0),Math.abs(e-s.$slide[0].scrollHeight)<1&&(n=i),s.$slide.css("padding-bottom",o))),s.$content.css("margin-bottom",n))},revealContent:function(t){var e,o,i,a,s=this,r=t.$slide,c=!1,l=!1,d=s.isMoved(t),u=t.isRevealed;return t.isRevealed=!0,e=t.opts[s.firstRun?"animationEffect":"transitionEffect"],i=t.opts[s.firstRun?"animationDuration":"transitionDuration"],i=parseInt(void 0===t.forcedDuration?i:t.forcedDuration,10),!d&&t.pos===s.currPos&&i||(e=!1),"zoom"===e&&(t.pos===s.currPos&&i&&"image"===t.type&&!t.hasError&&(l=s.getThumbPos(t))?c=s.getFitPos(t):e="fade"),"zoom"===e?(s.isAnimating=!0,c.scaleX=c.width/l.width,c.scaleY=c.height/l.height,a=t.opts.zoomOpacity,"auto"==a&&(a=Math.abs(t.width/t.height-l.width/l.height)>.1),a&&(l.opacity=.1,c.opacity=1),n.fancybox.setTranslate(t.$content.removeClass("fancybox-is-hidden"),l),p(t.$content),void n.fancybox.animate(t.$content,c,i,function(){s.isAnimating=!1,s.complete()})):(s.updateSlide(t),e?(n.fancybox.stop(r),o="fancybox-slide--"+(t.pos>=s.prevPos?"next":"previous")+" fancybox-animated fancybox-fx-"+e,r.addClass(o).removeClass("fancybox-slide--current"),t.$content.removeClass("fancybox-is-hidden"),p(r),"image"!==t.type&&t.$content.hide().show(0),void n.fancybox.animate(r,"fancybox-slide--current",i,function(){r.removeClass(o).css({transform:"",opacity:""}),t.pos===s.currPos&&s.complete()},!0)):(t.$content.removeClass("fancybox-is-hidden"),u||!d||"image"!==t.type||t.hasError||t.$content.hide().fadeIn("fast"),void(t.pos===s.currPos&&s.complete())))},getThumbPos:function(t){var e,o,i,a,s,r=!1,c=t.$thumb;return!(!c||!g(c[0]))&&(e=n.fancybox.getTranslate(c),o=parseFloat(c.css("border-top-width")||0),i=parseFloat(c.css("border-right-width")||0),a=parseFloat(c.css("border-bottom-width")||0),s=parseFloat(c.css("border-left-width")||0),r={top:e.top+o,left:e.left+s,width:e.width-i-s,height:e.height-o-a,scaleX:1,scaleY:1},e.width>0&&e.height>0&&r)},complete:function(){var t,e=this,o=e.current,i={};!e.isMoved()&&o.isLoaded&&(o.isComplete||(o.isComplete=!0,o.$slide.siblings().trigger("onReset"),e.preload("inline"),p(o.$slide),o.$slide.addClass("fancybox-slide--complete"),n.each(e.slides,function(t,o){o.pos>=e.currPos-1&&o.pos<=e.currPos+1?i[o.pos]=o:o&&(n.fancybox.stop(o.$slide),o.$slide.off().remove())}),e.slides=i),e.isAnimating=!1,e.updateCursor(),e.trigger("afterShow"),o.opts.video.autoStart&&o.$slide.find("video,audio").filter(":visible:first").trigger("play").one("ended",function(){Document.exitFullscreen?Document.exitFullscreen():this.webkitExitFullscreen&&this.webkitExitFullscreen(),e.next()}),o.opts.autoFocus&&"html"===o.contentType&&(t=o.$content.find("input[autofocus]:enabled:visible:first"),t.length?t.trigger("focus"):e.focus(null,!0)),o.$slide.scrollTop(0).scrollLeft(0))},preload:function(t){var e,n,o=this;o.group.length<2||(n=o.slides[o.currPos+1],e=o.slides[o.currPos-1],e&&e.type===t&&o.loadSlide(e),n&&n.type===t&&o.loadSlide(n))},focus:function(t,o){var i,a,s=this,r=["a[href]","area[href]",'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',"select:not([disabled]):not([aria-hidden])","textarea:not([disabled]):not([aria-hidden])","button:not([disabled]):not([aria-hidden])","iframe","object","embed","video","audio","[contenteditable]",'[tabindex]:not([tabindex^="-"])'].join(",");s.isClosing||(i=!t&&s.current&&s.current.isComplete?s.current.$slide.find("*:visible"+(o?":not(.fancybox-close-small)":"")):s.$refs.container.find("*:visible"),i=i.filter(r).filter(function(){return"hidden"!==n(this).css("visibility")&&!n(this).hasClass("disabled")}),i.length?(a=i.index(e.activeElement),t&&t.shiftKey?(a<0||0==a)&&(t.preventDefault(),i.eq(i.length-1).trigger("focus")):(a<0||a==i.length-1)&&(t&&t.preventDefault(),i.eq(0).trigger("focus"))):s.$refs.container.trigger("focus"))},activate:function(){var t=this;n(".fancybox-container").each(function(){var e=n(this).data("FancyBox");e&&e.id!==t.id&&!e.isClosing&&(e.trigger("onDeactivate"),e.removeEvents(),e.isVisible=!1)}),t.isVisible=!0,(t.current||t.isIdle)&&(t.update(),t.updateControls()),t.trigger("onActivate"),t.addEvents()},close:function(t,e){var o,i,a,s,r,c,l,u=this,f=u.current,h=function(){u.cleanUp(t)};return!u.isClosing&&(u.isClosing=!0,!1===u.trigger("beforeClose",t)?(u.isClosing=!1,d(function(){u.update()}),!1):(u.removeEvents(),a=f.$content,o=f.opts.animationEffect,i=n.isNumeric(e)?e:o?f.opts.animationDuration:0,f.$slide.removeClass("fancybox-slide--complete fancybox-slide--next fancybox-slide--previous fancybox-animated"),!0!==t?n.fancybox.stop(f.$slide):o=!1,f.$slide.siblings().trigger("onReset").remove(),i&&u.$refs.container.removeClass("fancybox-is-open").addClass("fancybox-is-closing").css("transition-duration",i+"ms"),u.hideLoading(f),u.hideControls(!0),u.updateCursor(),"zoom"!==o||a&&i&&"image"===f.type&&!u.isMoved()&&!f.hasError&&(l=u.getThumbPos(f))||(o="fade"),"zoom"===o?(n.fancybox.stop(a),s=n.fancybox.getTranslate(a),c={top:s.top,left:s.left,scaleX:s.width/l.width,scaleY:s.height/l.height,width:l.width,height:l.height},r=f.opts.zoomOpacity,
"auto"==r&&(r=Math.abs(f.width/f.height-l.width/l.height)>.1),r&&(l.opacity=0),n.fancybox.setTranslate(a,c),p(a),n.fancybox.animate(a,l,i,h),!0):(o&&i?n.fancybox.animate(f.$slide.addClass("fancybox-slide--previous").removeClass("fancybox-slide--current"),"fancybox-animated fancybox-fx-"+o,i,h):!0===t?setTimeout(h,i):h(),!0)))},cleanUp:function(e){var o,i,a,s=this,r=s.current.opts.$orig;s.current.$slide.trigger("onReset"),s.$refs.container.empty().remove(),s.trigger("afterClose",e),s.current.opts.backFocus&&(r&&r.length&&r.is(":visible")||(r=s.$trigger),r&&r.length&&(i=t.scrollX,a=t.scrollY,r.trigger("focus"),n("html, body").scrollTop(a).scrollLeft(i))),s.current=null,o=n.fancybox.getInstance(),o?o.activate():(n("body").removeClass("fancybox-active compensate-for-scrollbar"),n("#fancybox-style-noscroll").remove())},trigger:function(t,e){var o,i=Array.prototype.slice.call(arguments,1),a=this,s=e&&e.opts?e:a.current;if(s?i.unshift(s):s=a,i.unshift(a),n.isFunction(s.opts[t])&&(o=s.opts[t].apply(s,i)),!1===o)return o;"afterClose"!==t&&a.$refs?a.$refs.container.trigger(t+".fb",i):r.trigger(t+".fb",i)},updateControls:function(){var t=this,o=t.current,i=o.index,a=t.$refs.container,s=t.$refs.caption,r=o.opts.caption;o.$slide.trigger("refresh"),r&&r.length?(t.$caption=s,s.children().eq(0).html(r)):t.$caption=null,t.hasHiddenControls||t.isIdle||t.showControls(),a.find("[data-fancybox-count]").html(t.group.length),a.find("[data-fancybox-index]").html(i+1),a.find("[data-fancybox-prev]").prop("disabled",!o.opts.loop&&i<=0),a.find("[data-fancybox-next]").prop("disabled",!o.opts.loop&&i>=t.group.length-1),"image"===o.type?a.find("[data-fancybox-zoom]").show().end().find("[data-fancybox-download]").attr("href",o.opts.image.src||o.src).show():o.opts.toolbar&&a.find("[data-fancybox-download],[data-fancybox-zoom]").hide(),n(e.activeElement).is(":hidden,[disabled]")&&t.$refs.container.trigger("focus")},hideControls:function(t){var e=this,n=["infobar","toolbar","nav"];!t&&e.current.opts.preventCaptionOverlap||n.push("caption"),this.$refs.container.removeClass(n.map(function(t){return"fancybox-show-"+t}).join(" ")),this.hasHiddenControls=!0},showControls:function(){var t=this,e=t.current?t.current.opts:t.opts,n=t.$refs.container;t.hasHiddenControls=!1,t.idleSecondsCounter=0,n.toggleClass("fancybox-show-toolbar",!(!e.toolbar||!e.buttons)).toggleClass("fancybox-show-infobar",!!(e.infobar&&t.group.length>1)).toggleClass("fancybox-show-caption",!!t.$caption).toggleClass("fancybox-show-nav",!!(e.arrows&&t.group.length>1)).toggleClass("fancybox-is-modal",!!e.modal)},toggleControls:function(){this.hasHiddenControls?this.showControls():this.hideControls()}}),n.fancybox={version:"3.5.7",defaults:a,getInstance:function(t){var e=n('.fancybox-container:not(".fancybox-is-closing"):last').data("FancyBox"),o=Array.prototype.slice.call(arguments,1);return e instanceof b&&("string"===n.type(t)?e[t].apply(e,o):"function"===n.type(t)&&t.apply(e,o),e)},open:function(t,e,n){return new b(t,e,n)},close:function(t){var e=this.getInstance();e&&(e.close(),!0===t&&this.close(t))},destroy:function(){this.close(!0),r.add("body").off("click.fb-start","**")},isMobile:/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),use3d:function(){var n=e.createElement("div");return t.getComputedStyle&&t.getComputedStyle(n)&&t.getComputedStyle(n).getPropertyValue("transform")&&!(e.documentMode&&e.documentMode<11)}(),getTranslate:function(t){var e;return!(!t||!t.length)&&(e=t[0].getBoundingClientRect(),{top:e.top||0,left:e.left||0,width:e.width,height:e.height,opacity:parseFloat(t.css("opacity"))})},setTranslate:function(t,e){var n="",o={};if(t&&e)return void 0===e.left&&void 0===e.top||(n=(void 0===e.left?t.position().left:e.left)+"px, "+(void 0===e.top?t.position().top:e.top)+"px",n=this.use3d?"translate3d("+n+", 0px)":"translate("+n+")"),void 0!==e.scaleX&&void 0!==e.scaleY?n+=" scale("+e.scaleX+", "+e.scaleY+")":void 0!==e.scaleX&&(n+=" scaleX("+e.scaleX+")"),n.length&&(o.transform=n),void 0!==e.opacity&&(o.opacity=e.opacity),void 0!==e.width&&(o.width=e.width),void 0!==e.height&&(o.height=e.height),t.css(o)},animate:function(t,e,o,i,a){var s,r=this;n.isFunction(o)&&(i=o,o=null),r.stop(t),s=r.getTranslate(t),t.on(f,function(c){(!c||!c.originalEvent||t.is(c.originalEvent.target)&&"z-index"!=c.originalEvent.propertyName)&&(r.stop(t),n.isNumeric(o)&&t.css("transition-duration",""),n.isPlainObject(e)?void 0!==e.scaleX&&void 0!==e.scaleY&&r.setTranslate(t,{top:e.top,left:e.left,width:s.width*e.scaleX,height:s.height*e.scaleY,scaleX:1,scaleY:1}):!0!==a&&t.removeClass(e),n.isFunction(i)&&i(c))}),n.isNumeric(o)&&t.css("transition-duration",o+"ms"),n.isPlainObject(e)?(void 0!==e.scaleX&&void 0!==e.scaleY&&(delete e.width,delete e.height,t.parent().hasClass("fancybox-slide--image")&&t.parent().addClass("fancybox-is-scaling")),n.fancybox.setTranslate(t,e)):t.addClass(e),t.data("timer",setTimeout(function(){t.trigger(f)},o+33))},stop:function(t,e){t&&t.length&&(clearTimeout(t.data("timer")),e&&t.trigger(f),t.off(f).css("transition-duration",""),t.parent().removeClass("fancybox-is-scaling"))}},n.fn.fancybox=function(t){var e;return t=t||{},e=t.selector||!1,e?n("body").off("click.fb-start",e).on("click.fb-start",e,{options:t},i):this.off("click.fb-start").on("click.fb-start",{items:this,options:t},i),this},r.on("click.fb-start","[data-fancybox]",i),r.on("click.fb-start","[data-fancybox-trigger]",function(t){n('[data-fancybox="'+n(this).attr("data-fancybox-trigger")+'"]').eq(n(this).attr("data-fancybox-index")||0).trigger("click.fb-start",{$trigger:n(this)})}),function(){var t=null;r.on("mousedown mouseup focus blur",".fancybox-button",function(e){switch(e.type){case"mousedown":t=n(this);break;case"mouseup":t=null;break;case"focusin":n(".fancybox-button").removeClass("fancybox-focus"),n(this).is(t)||n(this).is("[disabled]")||n(this).addClass("fancybox-focus");break;case"focusout":n(".fancybox-button").removeClass("fancybox-focus")}})}()}}(window,document,jQuery),function(t){"use strict";var e={youtube:{matcher:/(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(watch\?(.*&)?v=|v\/|u\/|embed\/?)?(videoseries\?list=(.*)|[\w-]{11}|\?listType=(.*)&list=(.*))(.*)/i,params:{autoplay:1,autohide:1,fs:1,rel:0,hd:1,wmode:"transparent",enablejsapi:1,html5:1},paramPlace:8,type:"iframe",url:"https://www.youtube-nocookie.com/embed/$4",thumb:"https://img.youtube.com/vi/$4/hqdefault.jpg"},vimeo:{matcher:/^.+vimeo.com\/(.*\/)?([\d]+)(.*)?/,params:{autoplay:1,hd:1,show_title:1,show_byline:1,show_portrait:0,fullscreen:1},paramPlace:3,type:"iframe",url:"//player.vimeo.com/video/$2"},instagram:{matcher:/(instagr\.am|instagram\.com)\/p\/([a-zA-Z0-9_\-]+)\/?/i,type:"image",url:"//$1/p/$2/media/?size=l"},gmap_place:{matcher:/(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(((maps\/(place\/(.*)\/)?\@(.*),(\d+.?\d+?)z))|(\?ll=))(.*)?/i,type:"iframe",url:function(t){return"//maps.google."+t[2]+"/?ll="+(t[9]?t[9]+"&z="+Math.floor(t[10])+(t[12]?t[12].replace(/^\//,"&"):""):t[12]+"").replace(/\?/,"&")+"&output="+(t[12]&&t[12].indexOf("layer=c")>0?"svembed":"embed")}},gmap_search:{matcher:/(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(maps\/search\/)(.*)/i,type:"iframe",url:function(t){return"//maps.google."+t[2]+"/maps?q="+t[5].replace("query=","q=").replace("api=1","")+"&output=embed"}}},n=function(e,n,o){if(e)return o=o||"","object"===t.type(o)&&(o=t.param(o,!0)),t.each(n,function(t,n){e=e.replace("$"+t,n||"")}),o.length&&(e+=(e.indexOf("?")>0?"&":"?")+o),e};t(document).on("objectNeedsType.fb",function(o,i,a){var s,r,c,l,d,u,f,p=a.src||"",h=!1;s=t.extend(!0,{},e,a.opts.media),t.each(s,function(e,o){if(c=p.match(o.matcher)){if(h=o.type,f=e,u={},o.paramPlace&&c[o.paramPlace]){d=c[o.paramPlace],"?"==d[0]&&(d=d.substring(1)),d=d.split("&");for(var i=0;i<d.length;++i){var s=d[i].split("=",2);2==s.length&&(u[s[0]]=decodeURIComponent(s[1].replace(/\+/g," ")))}}return l=t.extend(!0,{},o.params,a.opts[e],u),p="function"===t.type(o.url)?o.url.call(this,c,l,a):n(o.url,c,l),r="function"===t.type(o.thumb)?o.thumb.call(this,c,l,a):n(o.thumb,c),"youtube"===e?p=p.replace(/&t=((\d+)m)?(\d+)s/,function(t,e,n,o){return"&start="+((n?60*parseInt(n,10):0)+parseInt(o,10))}):"vimeo"===e&&(p=p.replace("&%23","#")),!1}}),h?(a.opts.thumb||a.opts.$thumb&&a.opts.$thumb.length||(a.opts.thumb=r),"iframe"===h&&(a.opts=t.extend(!0,a.opts,{iframe:{preload:!1,attr:{scrolling:"no"}}})),t.extend(a,{type:h,src:p,origSrc:a.src,contentSource:f,contentType:"image"===h?"image":"gmap_place"==f||"gmap_search"==f?"map":"video"})):p&&(a.type=a.opts.defaultType)});var o={youtube:{src:"https://www.youtube.com/iframe_api",class:"YT",loading:!1,loaded:!1},vimeo:{src:"https://player.vimeo.com/api/player.js",class:"Vimeo",loading:!1,loaded:!1},load:function(t){var e,n=this;if(this[t].loaded)return void setTimeout(function(){n.done(t)});this[t].loading||(this[t].loading=!0,e=document.createElement("script"),e.type="text/javascript",e.src=this[t].src,"youtube"===t?window.onYouTubeIframeAPIReady=function(){n[t].loaded=!0,n.done(t)}:e.onload=function(){n[t].loaded=!0,n.done(t)},document.body.appendChild(e))},done:function(e){var n,o,i;"youtube"===e&&delete window.onYouTubeIframeAPIReady,(n=t.fancybox.getInstance())&&(o=n.current.$content.find("iframe"),"youtube"===e&&void 0!==YT&&YT?i=new YT.Player(o.attr("id"),{events:{onStateChange:function(t){0==t.data&&n.next()}}}):"vimeo"===e&&void 0!==Vimeo&&Vimeo&&(i=new Vimeo.Player(o),i.on("ended",function(){n.next()})))}};t(document).on({"afterShow.fb":function(t,e,n){e.group.length>1&&("youtube"===n.contentSource||"vimeo"===n.contentSource)&&o.load(n.contentSource)}})}(jQuery),function(t,e,n){"use strict";var o=function(){return t.requestAnimationFrame||t.webkitRequestAnimationFrame||t.mozRequestAnimationFrame||t.oRequestAnimationFrame||function(e){return t.setTimeout(e,1e3/60)}}(),i=function(){return t.cancelAnimationFrame||t.webkitCancelAnimationFrame||t.mozCancelAnimationFrame||t.oCancelAnimationFrame||function(e){t.clearTimeout(e)}}(),a=function(e){var n=[];e=e.originalEvent||e||t.e,e=e.touches&&e.touches.length?e.touches:e.changedTouches&&e.changedTouches.length?e.changedTouches:[e];for(var o in e)e[o].pageX?n.push({x:e[o].pageX,y:e[o].pageY}):e[o].clientX&&n.push({x:e[o].clientX,y:e[o].clientY});return n},s=function(t,e,n){return e&&t?"x"===n?t.x-e.x:"y"===n?t.y-e.y:Math.sqrt(Math.pow(t.x-e.x,2)+Math.pow(t.y-e.y,2)):0},r=function(t){if(t.is('a,area,button,[role="button"],input,label,select,summary,textarea,video,audio,iframe')||n.isFunction(t.get(0).onclick)||t.data("selectable"))return!0;for(var e=0,o=t[0].attributes,i=o.length;e<i;e++)if("data-fancybox-"===o[e].nodeName.substr(0,14))return!0;return!1},c=function(e){var n=t.getComputedStyle(e)["overflow-y"],o=t.getComputedStyle(e)["overflow-x"],i=("scroll"===n||"auto"===n)&&e.scrollHeight>e.clientHeight,a=("scroll"===o||"auto"===o)&&e.scrollWidth>e.clientWidth;return i||a},l=function(t){for(var e=!1;;){if(e=c(t.get(0)))break;if(t=t.parent(),!t.length||t.hasClass("fancybox-stage")||t.is("body"))break}return e},d=function(t){var e=this;e.instance=t,e.$bg=t.$refs.bg,e.$stage=t.$refs.stage,e.$container=t.$refs.container,e.destroy(),e.$container.on("touchstart.fb.touch mousedown.fb.touch",n.proxy(e,"ontouchstart"))};d.prototype.destroy=function(){var t=this;t.$container.off(".fb.touch"),n(e).off(".fb.touch"),t.requestId&&(i(t.requestId),t.requestId=null),t.tapped&&(clearTimeout(t.tapped),t.tapped=null)},d.prototype.ontouchstart=function(o){var i=this,c=n(o.target),d=i.instance,u=d.current,f=u.$slide,p=u.$content,h="touchstart"==o.type;if(h&&i.$container.off("mousedown.fb.touch"),(!o.originalEvent||2!=o.originalEvent.button)&&f.length&&c.length&&!r(c)&&!r(c.parent())&&(c.is("img")||!(o.originalEvent.clientX>c[0].clientWidth+c.offset().left))){if(!u||d.isAnimating||u.$slide.hasClass("fancybox-animated"))return o.stopPropagation(),void o.preventDefault();i.realPoints=i.startPoints=a(o),i.startPoints.length&&(u.touch&&o.stopPropagation(),i.startEvent=o,i.canTap=!0,i.$target=c,i.$content=p,i.opts=u.opts.touch,i.isPanning=!1,i.isSwiping=!1,i.isZooming=!1,i.isScrolling=!1,i.canPan=d.canPan(),i.startTime=(new Date).getTime(),i.distanceX=i.distanceY=i.distance=0,i.canvasWidth=Math.round(f[0].clientWidth),i.canvasHeight=Math.round(f[0].clientHeight),i.contentLastPos=null,i.contentStartPos=n.fancybox.getTranslate(i.$content)||{top:0,left:0},i.sliderStartPos=n.fancybox.getTranslate(f),i.stagePos=n.fancybox.getTranslate(d.$refs.stage),i.sliderStartPos.top-=i.stagePos.top,i.sliderStartPos.left-=i.stagePos.left,i.contentStartPos.top-=i.stagePos.top,i.contentStartPos.left-=i.stagePos.left,n(e).off(".fb.touch").on(h?"touchend.fb.touch touchcancel.fb.touch":"mouseup.fb.touch mouseleave.fb.touch",n.proxy(i,"ontouchend")).on(h?"touchmove.fb.touch":"mousemove.fb.touch",n.proxy(i,"ontouchmove")),n.fancybox.isMobile&&e.addEventListener("scroll",i.onscroll,!0),((i.opts||i.canPan)&&(c.is(i.$stage)||i.$stage.find(c).length)||(c.is(".fancybox-image")&&o.preventDefault(),n.fancybox.isMobile&&c.parents(".fancybox-caption").length))&&(i.isScrollable=l(c)||l(c.parent()),n.fancybox.isMobile&&i.isScrollable||o.preventDefault(),(1===i.startPoints.length||u.hasError)&&(i.canPan?(n.fancybox.stop(i.$content),i.isPanning=!0):i.isSwiping=!0,i.$container.addClass("fancybox-is-grabbing")),2===i.startPoints.length&&"image"===u.type&&(u.isLoaded||u.$ghost)&&(i.canTap=!1,i.isSwiping=!1,i.isPanning=!1,i.isZooming=!0,n.fancybox.stop(i.$content),i.centerPointStartX=.5*(i.startPoints[0].x+i.startPoints[1].x)-n(t).scrollLeft(),i.centerPointStartY=.5*(i.startPoints[0].y+i.startPoints[1].y)-n(t).scrollTop(),i.percentageOfImageAtPinchPointX=(i.centerPointStartX-i.contentStartPos.left)/i.contentStartPos.width,i.percentageOfImageAtPinchPointY=(i.centerPointStartY-i.contentStartPos.top)/i.contentStartPos.height,i.startDistanceBetweenFingers=s(i.startPoints[0],i.startPoints[1]))))}},d.prototype.onscroll=function(t){var n=this;n.isScrolling=!0,e.removeEventListener("scroll",n.onscroll,!0)},d.prototype.ontouchmove=function(t){var e=this;return void 0!==t.originalEvent.buttons&&0===t.originalEvent.buttons?void e.ontouchend(t):e.isScrolling?void(e.canTap=!1):(e.newPoints=a(t),void((e.opts||e.canPan)&&e.newPoints.length&&e.newPoints.length&&(e.isSwiping&&!0===e.isSwiping||t.preventDefault(),e.distanceX=s(e.newPoints[0],e.startPoints[0],"x"),e.distanceY=s(e.newPoints[0],e.startPoints[0],"y"),e.distance=s(e.newPoints[0],e.startPoints[0]),e.distance>0&&(e.isSwiping?e.onSwipe(t):e.isPanning?e.onPan():e.isZooming&&e.onZoom()))))},d.prototype.onSwipe=function(e){var a,s=this,r=s.instance,c=s.isSwiping,l=s.sliderStartPos.left||0;if(!0!==c)"x"==c&&(s.distanceX>0&&(s.instance.group.length<2||0===s.instance.current.index&&!s.instance.current.opts.loop)?l+=Math.pow(s.distanceX,.8):s.distanceX<0&&(s.instance.group.length<2||s.instance.current.index===s.instance.group.length-1&&!s.instance.current.opts.loop)?l-=Math.pow(-s.distanceX,.8):l+=s.distanceX),s.sliderLastPos={top:"x"==c?0:s.sliderStartPos.top+s.distanceY,left:l},s.requestId&&(i(s.requestId),s.requestId=null),s.requestId=o(function(){s.sliderLastPos&&(n.each(s.instance.slides,function(t,e){var o=e.pos-s.instance.currPos;n.fancybox.setTranslate(e.$slide,{top:s.sliderLastPos.top,left:s.sliderLastPos.left+o*s.canvasWidth+o*e.opts.gutter})}),s.$container.addClass("fancybox-is-sliding"))});else if(Math.abs(s.distance)>10){if(s.canTap=!1,r.group.length<2&&s.opts.vertical?s.isSwiping="y":r.isDragging||!1===s.opts.vertical||"auto"===s.opts.vertical&&n(t).width()>800?s.isSwiping="x":(a=Math.abs(180*Math.atan2(s.distanceY,s.distanceX)/Math.PI),s.isSwiping=a>45&&a<135?"y":"x"),"y"===s.isSwiping&&n.fancybox.isMobile&&s.isScrollable)return void(s.isScrolling=!0);r.isDragging=s.isSwiping,s.startPoints=s.newPoints,n.each(r.slides,function(t,e){var o,i;n.fancybox.stop(e.$slide),o=n.fancybox.getTranslate(e.$slide),i=n.fancybox.getTranslate(r.$refs.stage),e.$slide.css({transform:"",opacity:"","transition-duration":""}).removeClass("fancybox-animated").removeClass(function(t,e){return(e.match(/(^|\s)fancybox-fx-\S+/g)||[]).join(" ")}),e.pos===r.current.pos&&(s.sliderStartPos.top=o.top-i.top,s.sliderStartPos.left=o.left-i.left),n.fancybox.setTranslate(e.$slide,{top:o.top-i.top,left:o.left-i.left})}),r.SlideShow&&r.SlideShow.isActive&&r.SlideShow.stop()}},d.prototype.onPan=function(){var t=this;if(s(t.newPoints[0],t.realPoints[0])<(n.fancybox.isMobile?10:5))return void(t.startPoints=t.newPoints);t.canTap=!1,t.contentLastPos=t.limitMovement(),t.requestId&&i(t.requestId),t.requestId=o(function(){n.fancybox.setTranslate(t.$content,t.contentLastPos)})},d.prototype.limitMovement=function(){var t,e,n,o,i,a,s=this,r=s.canvasWidth,c=s.canvasHeight,l=s.distanceX,d=s.distanceY,u=s.contentStartPos,f=u.left,p=u.top,h=u.width,g=u.height;return i=h>r?f+l:f,a=p+d,t=Math.max(0,.5*r-.5*h),e=Math.max(0,.5*c-.5*g),n=Math.min(r-h,.5*r-.5*h),o=Math.min(c-g,.5*c-.5*g),l>0&&i>t&&(i=t-1+Math.pow(-t+f+l,.8)||0),l<0&&i<n&&(i=n+1-Math.pow(n-f-l,.8)||0),d>0&&a>e&&(a=e-1+Math.pow(-e+p+d,.8)||0),d<0&&a<o&&(a=o+1-Math.pow(o-p-d,.8)||0),{top:a,left:i}},d.prototype.limitPosition=function(t,e,n,o){var i=this,a=i.canvasWidth,s=i.canvasHeight;return n>a?(t=t>0?0:t,t=t<a-n?a-n:t):t=Math.max(0,a/2-n/2),o>s?(e=e>0?0:e,e=e<s-o?s-o:e):e=Math.max(0,s/2-o/2),{top:e,left:t}},d.prototype.onZoom=function(){var e=this,a=e.contentStartPos,r=a.width,c=a.height,l=a.left,d=a.top,u=s(e.newPoints[0],e.newPoints[1]),f=u/e.startDistanceBetweenFingers,p=Math.floor(r*f),h=Math.floor(c*f),g=(r-p)*e.percentageOfImageAtPinchPointX,b=(c-h)*e.percentageOfImageAtPinchPointY,m=(e.newPoints[0].x+e.newPoints[1].x)/2-n(t).scrollLeft(),v=(e.newPoints[0].y+e.newPoints[1].y)/2-n(t).scrollTop(),y=m-e.centerPointStartX,x=v-e.centerPointStartY,w=l+(g+y),$=d+(b+x),S={top:$,left:w,scaleX:f,scaleY:f};e.canTap=!1,e.newWidth=p,e.newHeight=h,e.contentLastPos=S,e.requestId&&i(e.requestId),e.requestId=o(function(){n.fancybox.setTranslate(e.$content,e.contentLastPos)})},d.prototype.ontouchend=function(t){var o=this,s=o.isSwiping,r=o.isPanning,c=o.isZooming,l=o.isScrolling;if(o.endPoints=a(t),o.dMs=Math.max((new Date).getTime()-o.startTime,1),o.$container.removeClass("fancybox-is-grabbing"),n(e).off(".fb.touch"),e.removeEventListener("scroll",o.onscroll,!0),o.requestId&&(i(o.requestId),o.requestId=null),o.isSwiping=!1,o.isPanning=!1,o.isZooming=!1,o.isScrolling=!1,o.instance.isDragging=!1,o.canTap)return o.onTap(t);o.speed=100,o.velocityX=o.distanceX/o.dMs*.5,o.velocityY=o.distanceY/o.dMs*.5,r?o.endPanning():c?o.endZooming():o.endSwiping(s,l)},d.prototype.endSwiping=function(t,e){var o=this,i=!1,a=o.instance.group.length,s=Math.abs(o.distanceX),r="x"==t&&a>1&&(o.dMs>130&&s>10||s>50);o.sliderLastPos=null,"y"==t&&!e&&Math.abs(o.distanceY)>50?(n.fancybox.animate(o.instance.current.$slide,{top:o.sliderStartPos.top+o.distanceY+150*o.velocityY,opacity:0},200),i=o.instance.close(!0,250)):r&&o.distanceX>0?i=o.instance.previous(300):r&&o.distanceX<0&&(i=o.instance.next(300)),!1!==i||"x"!=t&&"y"!=t||o.instance.centerSlide(200),o.$container.removeClass("fancybox-is-sliding")},d.prototype.endPanning=function(){var t,e,o,i=this;i.contentLastPos&&(!1===i.opts.momentum||i.dMs>350?(t=i.contentLastPos.left,e=i.contentLastPos.top):(t=i.contentLastPos.left+500*i.velocityX,e=i.contentLastPos.top+500*i.velocityY),o=i.limitPosition(t,e,i.contentStartPos.width,i.contentStartPos.height),o.width=i.contentStartPos.width,o.height=i.contentStartPos.height,n.fancybox.animate(i.$content,o,366))},d.prototype.endZooming=function(){var t,e,o,i,a=this,s=a.instance.current,r=a.newWidth,c=a.newHeight;a.contentLastPos&&(t=a.contentLastPos.left,e=a.contentLastPos.top,i={top:e,left:t,width:r,height:c,scaleX:1,scaleY:1},n.fancybox.setTranslate(a.$content,i),r<a.canvasWidth&&c<a.canvasHeight?a.instance.scaleToFit(150):r>s.width||c>s.height?a.instance.scaleToActual(a.centerPointStartX,a.centerPointStartY,150):(o=a.limitPosition(t,e,r,c),n.fancybox.animate(a.$content,o,150)))},d.prototype.onTap=function(e){var o,i=this,s=n(e.target),r=i.instance,c=r.current,l=e&&a(e)||i.startPoints,d=l[0]?l[0].x-n(t).scrollLeft()-i.stagePos.left:0,u=l[0]?l[0].y-n(t).scrollTop()-i.stagePos.top:0,f=function(t){var o=c.opts[t];if(n.isFunction(o)&&(o=o.apply(r,[c,e])),o)switch(o){case"close":r.close(i.startEvent);break;case"toggleControls":r.toggleControls();break;case"next":r.next();break;case"nextOrClose":r.group.length>1?r.next():r.close(i.startEvent);break;case"zoom":"image"==c.type&&(c.isLoaded||c.$ghost)&&(r.canPan()?r.scaleToFit():r.isScaledDown()?r.scaleToActual(d,u):r.group.length<2&&r.close(i.startEvent))}};if((!e.originalEvent||2!=e.originalEvent.button)&&(s.is("img")||!(d>s[0].clientWidth+s.offset().left))){if(s.is(".fancybox-bg,.fancybox-inner,.fancybox-outer,.fancybox-container"))o="Outside";else if(s.is(".fancybox-slide"))o="Slide";else{if(!r.current.$content||!r.current.$content.find(s).addBack().filter(s).length)return;o="Content"}if(i.tapped){if(clearTimeout(i.tapped),i.tapped=null,Math.abs(d-i.tapX)>50||Math.abs(u-i.tapY)>50)return this;f("dblclick"+o)}else i.tapX=d,i.tapY=u,c.opts["dblclick"+o]&&c.opts["dblclick"+o]!==c.opts["click"+o]?i.tapped=setTimeout(function(){i.tapped=null,r.isAnimating||f("click"+o)},500):f("click"+o);return this}},n(e).on("onActivate.fb",function(t,e){e&&!e.Guestures&&(e.Guestures=new d(e))}).on("beforeClose.fb",function(t,e){e&&e.Guestures&&e.Guestures.destroy()})}(window,document,jQuery),function(t,e){"use strict";e.extend(!0,e.fancybox.defaults,{btnTpl:{slideShow:'<button data-fancybox-play class="fancybox-button fancybox-button--play" title="{{PLAY_START}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M6.5 5.4v13.2l11-6.6z"/></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M8.33 5.75h2.2v12.5h-2.2V5.75zm5.15 0h2.2v12.5h-2.2V5.75z"/></svg></button>'},slideShow:{autoStart:!1,speed:3e3,progress:!0}});var n=function(t){this.instance=t,this.init()};e.extend(n.prototype,{timer:null,isActive:!1,$button:null,init:function(){var t=this,n=t.instance,o=n.group[n.currIndex].opts.slideShow;t.$button=n.$refs.toolbar.find("[data-fancybox-play]").on("click",function(){t.toggle()}),n.group.length<2||!o?t.$button.hide():o.progress&&(t.$progress=e('<div class="fancybox-progress"></div>').appendTo(n.$refs.inner))},set:function(t){var n=this,o=n.instance,i=o.current;i&&(!0===t||i.opts.loop||o.currIndex<o.group.length-1)?n.isActive&&"video"!==i.contentType&&(n.$progress&&e.fancybox.animate(n.$progress.show(),{scaleX:1},i.opts.slideShow.speed),n.timer=setTimeout(function(){o.current.opts.loop||o.current.index!=o.group.length-1?o.next():o.jumpTo(0)},i.opts.slideShow.speed)):(n.stop(),o.idleSecondsCounter=0,o.showControls())},clear:function(){var t=this;clearTimeout(t.timer),t.timer=null,t.$progress&&t.$progress.removeAttr("style").hide()},start:function(){var t=this,e=t.instance.current;e&&(t.$button.attr("title",(e.opts.i18n[e.opts.lang]||e.opts.i18n.en).PLAY_STOP).removeClass("fancybox-button--play").addClass("fancybox-button--pause"),t.isActive=!0,e.isComplete&&t.set(!0),t.instance.trigger("onSlideShowChange",!0))},stop:function(){var t=this,e=t.instance.current;t.clear(),t.$button.attr("title",(e.opts.i18n[e.opts.lang]||e.opts.i18n.en).PLAY_START).removeClass("fancybox-button--pause").addClass("fancybox-button--play"),t.isActive=!1,t.instance.trigger("onSlideShowChange",!1),t.$progress&&t.$progress.removeAttr("style").hide()},toggle:function(){var t=this;t.isActive?t.stop():t.start()}}),e(t).on({"onInit.fb":function(t,e){e&&!e.SlideShow&&(e.SlideShow=new n(e))},"beforeShow.fb":function(t,e,n,o){var i=e&&e.SlideShow;o?i&&n.opts.slideShow.autoStart&&i.start():i&&i.isActive&&i.clear()},"afterShow.fb":function(t,e,n){var o=e&&e.SlideShow;o&&o.isActive&&o.set()},"afterKeydown.fb":function(n,o,i,a,s){var r=o&&o.SlideShow;!r||!i.opts.slideShow||80!==s&&32!==s||e(t.activeElement).is("button,a,input")||(a.preventDefault(),r.toggle())},"beforeClose.fb onDeactivate.fb":function(t,e){var n=e&&e.SlideShow;n&&n.stop()}}),e(t).on("visibilitychange",function(){var n=e.fancybox.getInstance(),o=n&&n.SlideShow;o&&o.isActive&&(t.hidden?o.clear():o.set())})}(document,jQuery),function(t,e){"use strict";var n=function(){for(var e=[["requestFullscreen","exitFullscreen","fullscreenElement","fullscreenEnabled","fullscreenchange","fullscreenerror"],["webkitRequestFullscreen","webkitExitFullscreen","webkitFullscreenElement","webkitFullscreenEnabled","webkitfullscreenchange","webkitfullscreenerror"],["webkitRequestFullScreen","webkitCancelFullScreen","webkitCurrentFullScreenElement","webkitCancelFullScreen","webkitfullscreenchange","webkitfullscreenerror"],["mozRequestFullScreen","mozCancelFullScreen","mozFullScreenElement","mozFullScreenEnabled","mozfullscreenchange","mozfullscreenerror"],["msRequestFullscreen","msExitFullscreen","msFullscreenElement","msFullscreenEnabled","MSFullscreenChange","MSFullscreenError"]],n={},o=0;o<e.length;o++){var i=e[o];if(i&&i[1]in t){for(var a=0;a<i.length;a++)n[e[0][a]]=i[a];return n}}return!1}();if(n){var o={request:function(e){e=e||t.documentElement,e[n.requestFullscreen](e.ALLOW_KEYBOARD_INPUT)},exit:function(){t[n.exitFullscreen]()},toggle:function(e){e=e||t.documentElement,this.isFullscreen()?this.exit():this.request(e)},isFullscreen:function(){return Boolean(t[n.fullscreenElement])},enabled:function(){return Boolean(t[n.fullscreenEnabled])}};e.extend(!0,e.fancybox.defaults,{btnTpl:{fullScreen:'<button data-fancybox-fullscreen class="fancybox-button fancybox-button--fsenter" title="{{FULL_SCREEN}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 16h3v3h2v-5H5zm3-8H5v2h5V5H8zm6 11h2v-3h3v-2h-5zm2-11V5h-2v5h5V8z"/></svg></button>'},fullScreen:{autoStart:!1}}),e(t).on(n.fullscreenchange,function(){var t=o.isFullscreen(),n=e.fancybox.getInstance();n&&(n.current&&"image"===n.current.type&&n.isAnimating&&(n.isAnimating=!1,n.update(!0,!0,0),n.isComplete||n.complete()),n.trigger("onFullscreenChange",t),n.$refs.container.toggleClass("fancybox-is-fullscreen",t),n.$refs.toolbar.find("[data-fancybox-fullscreen]").toggleClass("fancybox-button--fsenter",!t).toggleClass("fancybox-button--fsexit",t))})}e(t).on({"onInit.fb":function(t,e){var i;if(!n)return void e.$refs.toolbar.find("[data-fancybox-fullscreen]").remove();e&&e.group[e.currIndex].opts.fullScreen?(i=e.$refs.container,i.on("click.fb-fullscreen","[data-fancybox-fullscreen]",function(t){t.stopPropagation(),t.preventDefault(),o.toggle()}),e.opts.fullScreen&&!0===e.opts.fullScreen.autoStart&&o.request(),e.FullScreen=o):e&&e.$refs.toolbar.find("[data-fancybox-fullscreen]").hide()},"afterKeydown.fb":function(t,e,n,o,i){e&&e.FullScreen&&70===i&&(o.preventDefault(),e.FullScreen.toggle())},"beforeClose.fb":function(t,e){e&&e.FullScreen&&e.$refs.container.hasClass("fancybox-is-fullscreen")&&o.exit()}})}(document,jQuery),function(t,e){"use strict";var n="fancybox-thumbs";e.fancybox.defaults=e.extend(!0,{btnTpl:{thumbs:'<button data-fancybox-thumbs class="fancybox-button fancybox-button--thumbs" title="{{THUMBS}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M14.59 14.59h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76H5.65v-3.76zm8.94-4.47h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76H5.65v-3.76zm8.94-4.47h3.76v3.76h-3.76V5.65zm-4.47 0h3.76v3.76h-3.76V5.65zm-4.47 0h3.76v3.76H5.65V5.65z"/></svg></button>'},thumbs:{autoStart:!1,hideOnClose:!0,parentEl:".fancybox-container",axis:"y"}},e.fancybox.defaults);var o=function(t){this.init(t)};e.extend(o.prototype,{$button:null,$grid:null,$list:null,isVisible:!1,isActive:!1,init:function(t){var e=this,n=t.group,o=0;e.instance=t,e.opts=n[t.currIndex].opts.thumbs,t.Thumbs=e,e.$button=t.$refs.toolbar.find("[data-fancybox-thumbs]");for(var i=0,a=n.length;i<a&&(n[i].thumb&&o++,!(o>1));i++);o>1&&e.opts?(e.$button.removeAttr("style").on("click",function(){e.toggle()}),e.isActive=!0):e.$button.hide()},create:function(){var t,o=this,i=o.instance,a=o.opts.parentEl,s=[];o.$grid||(o.$grid=e('<div class="'+n+" "+n+"-"+o.opts.axis+'"></div>').appendTo(i.$refs.container.find(a).addBack().filter(a)),o.$grid.on("click","a",function(){i.jumpTo(e(this).attr("data-index"))})),o.$list||(o.$list=e('<div class="'+n+'__list">').appendTo(o.$grid)),e.each(i.group,function(e,n){t=n.thumb,t||"image"!==n.type||(t=n.src),s.push('<a href="javascript:;" tabindex="0" data-index="'+e+'"'+(t&&t.length?' style="background-image:url('+t+')"':'class="fancybox-thumbs-missing"')+"></a>")}),o.$list[0].innerHTML=s.join(""),"x"===o.opts.axis&&o.$list.width(parseInt(o.$grid.css("padding-right"),10)+i.group.length*o.$list.children().eq(0).outerWidth(!0))},focus:function(t){var e,n,o=this,i=o.$list,a=o.$grid;o.instance.current&&(e=i.children().removeClass("fancybox-thumbs-active").filter('[data-index="'+o.instance.current.index+'"]').addClass("fancybox-thumbs-active"),n=e.position(),"y"===o.opts.axis&&(n.top<0||n.top>i.height()-e.outerHeight())?i.stop().animate({scrollTop:i.scrollTop()+n.top},t):"x"===o.opts.axis&&(n.left<a.scrollLeft()||n.left>a.scrollLeft()+(a.width()-e.outerWidth()))&&i.parent().stop().animate({scrollLeft:n.left},t))},update:function(){var t=this;t.instance.$refs.container.toggleClass("fancybox-show-thumbs",this.isVisible),t.isVisible?(t.$grid||t.create(),t.instance.trigger("onThumbsShow"),t.focus(0)):t.$grid&&t.instance.trigger("onThumbsHide"),t.instance.update()},hide:function(){this.isVisible=!1,this.update()},show:function(){this.isVisible=!0,this.update()},toggle:function(){this.isVisible=!this.isVisible,this.update()}}),e(t).on({"onInit.fb":function(t,e){var n;e&&!e.Thumbs&&(n=new o(e),n.isActive&&!0===n.opts.autoStart&&n.show())},"beforeShow.fb":function(t,e,n,o){var i=e&&e.Thumbs;i&&i.isVisible&&i.focus(o?0:250)},"afterKeydown.fb":function(t,e,n,o,i){var a=e&&e.Thumbs;a&&a.isActive&&71===i&&(o.preventDefault(),a.toggle())},"beforeClose.fb":function(t,e){var n=e&&e.Thumbs;n&&n.isVisible&&!1!==n.opts.hideOnClose&&n.$grid.hide()}})}(document,jQuery),function(t,e){"use strict";function n(t){var e={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;","/":"&#x2F;","`":"&#x60;","=":"&#x3D;"};return String(t).replace(/[&<>"'`=\/]/g,function(t){return e[t]})}e.extend(!0,e.fancybox.defaults,{btnTpl:{share:'<button data-fancybox-share class="fancybox-button fancybox-button--share" title="{{SHARE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M2.55 19c1.4-8.4 9.1-9.8 11.9-9.8V5l7 7-7 6.3v-3.5c-2.8 0-10.5 2.1-11.9 4.2z"/></svg></button>'},share:{url:function(t,e){return!t.currentHash&&"inline"!==e.type&&"html"!==e.type&&(e.origSrc||e.src)||window.location},
tpl:'<div class="fancybox-share"><h1>{{SHARE}}</h1><p><a class="fancybox-share__button fancybox-share__button--fb" href="https://www.facebook.com/sharer/sharer.php?u={{url}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m287 456v-299c0-21 6-35 35-35h38v-63c-7-1-29-3-55-3-54 0-91 33-91 94v306m143-254h-205v72h196" /></svg><span>Facebook</span></a><a class="fancybox-share__button fancybox-share__button--tw" href="https://twitter.com/intent/tweet?url={{url}}&text={{descr}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m456 133c-14 7-31 11-47 13 17-10 30-27 37-46-15 10-34 16-52 20-61-62-157-7-141 75-68-3-129-35-169-85-22 37-11 86 26 109-13 0-26-4-37-9 0 39 28 72 65 80-12 3-25 4-37 2 10 33 41 57 77 57-42 30-77 38-122 34 170 111 378-32 359-208 16-11 30-25 41-42z" /></svg><span>Twitter</span></a><a class="fancybox-share__button fancybox-share__button--pt" href="https://www.pinterest.com/pin/create/button/?url={{url}}&description={{descr}}&media={{media}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m265 56c-109 0-164 78-164 144 0 39 15 74 47 87 5 2 10 0 12-5l4-19c2-6 1-8-3-13-9-11-15-25-15-45 0-58 43-110 113-110 62 0 96 38 96 88 0 67-30 122-73 122-24 0-42-19-36-44 6-29 20-60 20-81 0-19-10-35-31-35-25 0-44 26-44 60 0 21 7 36 7 36l-30 125c-8 37-1 83 0 87 0 3 4 4 5 2 2-3 32-39 42-75l16-64c8 16 31 29 56 29 74 0 124-67 124-157 0-69-58-132-146-132z" fill="#fff"/></svg><span>Pinterest</span></a></p><p><input class="fancybox-share__input" type="text" value="{{url_raw}}" onclick="select()" /></p></div>'}}),e(t).on("click","[data-fancybox-share]",function(){var t,o,i=e.fancybox.getInstance(),a=i.current||null;a&&("function"===e.type(a.opts.share.url)&&(t=a.opts.share.url.apply(a,[i,a])),o=a.opts.share.tpl.replace(/\{\{media\}\}/g,"image"===a.type?encodeURIComponent(a.src):"").replace(/\{\{url\}\}/g,encodeURIComponent(t)).replace(/\{\{url_raw\}\}/g,n(t)).replace(/\{\{descr\}\}/g,i.$caption?encodeURIComponent(i.$caption.text()):""),e.fancybox.open({src:i.translate(i,o),type:"html",opts:{touch:!1,animationEffect:!1,afterLoad:function(t,e){i.$refs.container.one("beforeClose.fb",function(){t.close(null,0)}),e.$content.find(".fancybox-share__button").click(function(){return window.open(this.href,"Share","width=550, height=450"),!1})},mobile:{autoFocus:!1}}}))})}(document,jQuery),function(t,e,n){"use strict";function o(){var e=t.location.hash.substr(1),n=e.split("-"),o=n.length>1&&/^\+?\d+$/.test(n[n.length-1])?parseInt(n.pop(-1),10)||1:1,i=n.join("-");return{hash:e,index:o<1?1:o,gallery:i}}function i(t){""!==t.gallery&&n("[data-fancybox='"+n.escapeSelector(t.gallery)+"']").eq(t.index-1).focus().trigger("click.fb-start")}function a(t){var e,n;return!!t&&(e=t.current?t.current.opts:t.opts,""!==(n=e.hash||(e.$orig?e.$orig.data("fancybox")||e.$orig.data("fancybox-trigger"):""))&&n)}n.escapeSelector||(n.escapeSelector=function(t){return(t+"").replace(/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g,function(t,e){return e?"\0"===t?"�":t.slice(0,-1)+"\\"+t.charCodeAt(t.length-1).toString(16)+" ":"\\"+t})}),n(function(){!1!==n.fancybox.defaults.hash&&(n(e).on({"onInit.fb":function(t,e){var n,i;!1!==e.group[e.currIndex].opts.hash&&(n=o(),(i=a(e))&&n.gallery&&i==n.gallery&&(e.currIndex=n.index-1))},"beforeShow.fb":function(n,o,i,s){var r;i&&!1!==i.opts.hash&&(r=a(o))&&(o.currentHash=r+(o.group.length>1?"-"+(i.index+1):""),t.location.hash!=="#"+o.currentHash&&(s&&!o.origHash&&(o.origHash=t.location.hash),o.hashTimer&&clearTimeout(o.hashTimer),o.hashTimer=setTimeout(function(){"replaceState"in t.history?(t.history[s?"pushState":"replaceState"]({},e.title,t.location.pathname+t.location.search+"#"+o.currentHash),s&&(o.hasCreatedHistory=!0)):t.location.hash=o.currentHash,o.hashTimer=null},300)))},"beforeClose.fb":function(n,o,i){i&&!1!==i.opts.hash&&(clearTimeout(o.hashTimer),o.currentHash&&o.hasCreatedHistory?t.history.back():o.currentHash&&("replaceState"in t.history?t.history.replaceState({},e.title,t.location.pathname+t.location.search+(o.origHash||"")):t.location.hash=o.origHash),o.currentHash=null)}}),n(t).on("hashchange.fb",function(){var t=o(),e=null;n.each(n(".fancybox-container").get().reverse(),function(t,o){var i=n(o).data("FancyBox");if(i&&i.currentHash)return e=i,!1}),e?e.currentHash===t.gallery+"-"+t.index||1===t.index&&e.currentHash==t.gallery||(e.currentHash=null,e.close()):""!==t.gallery&&i(t)}),setTimeout(function(){n.fancybox.getInstance()||i(o())},50))})}(window,document,jQuery),function(t,e){"use strict";var n=(new Date).getTime();e(t).on({"onInit.fb":function(t,e,o){e.$refs.stage.on("mousewheel DOMMouseScroll wheel MozMousePixelScroll",function(t){var o=e.current,i=(new Date).getTime();e.group.length<2||!1===o.opts.wheel||"auto"===o.opts.wheel&&"image"!==o.type||(t.preventDefault(),t.stopPropagation(),o.$slide.hasClass("fancybox-animated")||(t=t.originalEvent||t,i-n<250||(n=i,e[(-t.deltaY||-t.deltaX||t.wheelDelta||-t.detail)<0?"next":"previous"]())))})}})}(document,jQuery);
// POPUP FOR TRA CLUB PAGE
// Fancybox Config
$('[data-fancybox="gallery"]').fancybox({
  buttons: [
    "slideShow",
    "thumbs",
    "zoom",
    "fullScreen",
    "share",
    "close"
  ],
  loop: false,
  protect: true
});



$(window).on('load', function(){
 

    // ABOUT SLIDER
    $('.about-meet-ohana-slider').slick({
    dots: false,
    infinite: false,
    arrow: true,
    speed: 300,
    slidesToShow: 1.1,
    slidesToScroll: 1
    });


    // about video iframe play
    document.getElementById("video-container").addEventListener("click", function () {
    const thumbnail = this.querySelector(".video-thumbnail");
    const frame = this.querySelector(".video-frame");

    // Hide thumbnail
    thumbnail.style.display = "none";

    // Show iframe
    frame.style.display = "block";
  });

});



    
    
// blogs filter
// document.addEventListener("DOMContentLoaded", function () {
//   const categoryButtons = document.querySelectorAll(".blog-main-category-card");

//   const blogPosts = document.querySelectorAll(
//     ".blog-main-grid .grid__item, .blog-main-grid .grid_item, .grid__item, .grid_item"
//   );

//   blogPosts.forEach(post => post.style.display = "");

//   categoryButtons.forEach(button => {
//     button.addEventListener("click", function () {
//       categoryButtons.forEach(btn => btn.classList.remove("active"));
//       this.classList.add("active");

//       const categoryClass = Array.from(this.classList).find(c => c.startsWith("cat-"));
//       if (!categoryClass) {
//         blogPosts.forEach(p => p.style.display = "");
//         return;
//       }
//       const category = categoryClass.replace("cat-", "");

//       blogPosts.forEach(post => {
//         const link = post.querySelector("a");

//         if (!link) {
//           post.style.display = "none";
//           return;
//         }

//         const hasTag = Array.from(link.classList).some(cls => cls === `tag-${category}` || cls.startsWith(`tag-${category}-`) || cls.includes(`tag-${category}`));

//         post.style.display = hasTag ? "" : "none";
//       });
//     });
//   });
// });
// $('.demo-tour-category-row').slick({
//       slidesToShow: 2,
//       slidesToScroll: 1,
//       rows: 2,
//       arrows: true,
//       fade: false,
//       infinite: true,
//       speed: 1000,
//       autoplay: false,
//       autoplaySpeed: 2000,
//       pauseOnHover: false,
//       pauseOnFocus: false,
//       responsive: [
//         {
//           breakpoint: 575,
//           settings: {
//             rows: 1,
//             slidesToShow: 1
//           }
//         }
//       ]
// });


// footer from placeholder add
(function () {
  var container = document.querySelector('.footer-subscribe-form'); // wraps the CC embed
  if (!container) return;

  function applyPlaceholder(input) {
    if (!input || input.dataset.placeholderApplied) return;
    input.setAttribute('placeholder', 'you@email.com');
    input.dataset.placeholderApplied = 'true';
  }

  // In case it's already loaded
  applyPlaceholder(container.querySelector('input[name="email_address"]'));

  // Watch for Constant Contact injecting the form asynchronously
  var observer = new MutationObserver(function () {
    var input = container.querySelector('input[name="email_address"]');
    if (input) {
      applyPlaceholder(input);
    }
  });

  observer.observe(container, { childList: true, subtree: true });
})();

